// THIS FILE IS GENERATED AUTOMATICALLY. DON'T CHANGE IT!

export function getEnumServerErrorValues() {
  return [0, -1, -2, -3, -4, -5, -6, -7, -8];
}

export function getEnumRpcErrorValues() {
  return [0, 1, 3, 4, 5];
}

export function getEnumStatValues() {
  return [0, 10, 20];
}

export function getEnumCheaterReasonValues() {
  return [0, 1, 2];
}

export function getEnumLanguageValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8];
}

export function getEnumPlatformValues() {
  return [0, 1, 2, 3, 4, 5];
}

export function getEnumPlatformBitValues() {
  return [0, 1, 2, 4, 8, 16];
}

export function getEnumClientIdentityValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7];
}

export function getEnumInGameEventValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
}

export function getEnumStockValues() {
  return [41259540, 112151937, 65428884, 120783026, 250458942, 254488213, 208477032, 146135299, 71848851, 111025913, 71359390, 255786630, 257611015, 249216032, 71857089, 151142894, 24184776, 232424325, 137248552, 114267458, 40982798, 100649854, 95925952, 222310101, 109897756, 227369309, 125623217, 50326614, 26874558, 63051773, 140136229, 250952865, 247912363, 88937451, 220414064, 248296543, 153006451, 267073102, 24903204, 29026631, 174732018, 127115697, 7658338, 222793166, 158360729, 187556710, 255641636, 218896632, 191567948, 145006193, 97717656, 141030531, 26711773, 232049586, 113647149, 51255808, 48278976, 221454860, 257917831, 52360249, 129866324, 132828839, 75563595, 20273967, 58263650, 52501899, 99484835, 220211542, 64654092, 247891409, 240255460, 43297642, 179287198, 86498303, 64273735, 152672137, 176195498, 163261517, 31844273, 2179812, 213654220, 19955063, 67860965, 169464439, 224577076, 258333665, 145635986, 62715865];
}

export function getEnumResourceGameActionValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143];
}

export function getEnumQuestStateValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumQuestStoryNodeRoleValues() {
  return [0, 1, 2, 3];
}

export function getEnumCharacterIdleBehaviourValues() {
  return [0, 1];
}

export function getEnumTutorialStateValues() {
  return [0, 1, 2];
}

export function getEnumTutorialTypeValues() {
  return [0, 1, 2, 3];
}

export function getEnumTutorialKindValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumTutorialBubbleAvatarValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7];
}

export function getEnumQuestActionKindValues() {
  return [0, 1, 2, 3, 4, 5];
}

export function getM3EventValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];
}

export function getEnumUserSettingValues() {
  return [1, 2, 3, 4, 5];
}

export function getM3HintDirectionValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumBillingInitResultValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumBillingPaymentResultValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
}

export function getEnumBillingPaymentProcessingStepValues() {
  return [0, 10, 20, 30, 40, 50, 60, 70, 80, 90, 100, 110, 120, 130, 32000, 32010];
}

export function getEnumPlayerRFMCategoryValues() {
  return [0, 1, 2, 3, 4, 5];
}

export function getEnumClientPaymentStatusValues() {
  return [1, 2, 0];
}

export function getEnumBillingTableGradeValues() {
  return [0, 1, 2, 3];
}

export function getEnumBillingGoodsGroupValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 17, 18, 20, 35, 40, 41, 42, 43, 44, 45, 46, 47, 100, 205, 206, 207, 300, 301];
}

export function getEnumSceneTransitionModeValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumStoryEventValues() {
  return [0, 1, 2, 3, 4, 5, 6];
}

export function getEnumNewsStatusValues() {
  return [0, 1, 2];
}

export function getEnumPendingStatusValues() {
  return [0, 1, 2, 3];
}

export function getEnumPendingPurposeValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
}

export function getEnumPetStatusValues() {
  return [0, 1];
}

export function getEnumBillingEnvOverrideValues() {
  return [0, 1, 2];
}

export function getEnumPlayerAvatarValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 200, 2096348, 252150272, 228707162, 120586800, 108954068, 177634329, 215872012, 221385440, 262188568, 17574525, 171494193, 250582719, 75753119, 86926330, 128711333, 152958376, 21701093, 26573769, 70383138, 172062527, 61870630, 64369787, 139857425, 206673802, 246026410, 96574990, 8493308, 237646434, 78050800, 247979318, 39982063, 65700637, 73545215, 45052314, 126431394, 52815045, 217990658, 112085656, 25979493, 193516066, 152041173, 13159147, 169308034, 23206714, 90571433, 196523801, 112132784, 88959007, 54372819, 128651658, 4999391, 188982273, 131526751, 175215764, 215189676, 26613247, 209947419, 255276935, 145044705, 50217824, 76763552, 199624045, 50598820, 61212483, 140397531, 25855378, 63764193, 139056555, 161275782, 65303641, 113531305, 198199047, 130966619, 59593306, 75456608, 226628686, 234267318, 39564849, 52339324, 56077311, 265655937, 249181321, 55700552, 57364224, 165844672, 264428320, 139230353, 114665191, 198579354, 118238743, 53280978, 39680069, 90858583, 76299162, 173684702, 26940608, 117883237, 259791921, 175115128, 158914056, 240742592, 174547822, 84470288, 46624684, 99687615, 227526763, 176566247, 266000530, 149183675, 85839557, 120753942, 39903667, 196208503, 193088137, 220543853, 63100084, 213604018, 42239545, 120070106, 55560074, 147288580, 112842785, 176518441, 21634909, 209561645, 157626321, 38173983, 132599644, 31879542, 152454762, 208047763, 175876748, 259525383, 119591507, 53247580, 213875444, 124331045, 212225617, 26343713, 76119773, 262810643, 168500816, 201990266, 83498854, 25878431, 15527875, 99569224, 230135580, 187405967, 206602956, 137490181, 256572230, 261708240, 200815641, 25003957, 85781116, 104241996, 187678114, 172662049, 216960058, 136718917, 99198674, 93056114, 109077080, 131460782, 147919469, 29803939, 194147594, 42969112, 157040916, 219267024, 131418813, 113410505, 72242758, 157062657, 180837871, 5266111, 30555770, 265178487, 257635795, 258289455, 122551222, 16464103, 163901471, 187172606, 174058724, 79040822, 81192781, 134184077, 102290259, 140602181, 143775994, 62018908, 185254913, 204227220, 92524456, 86019626, 244755517, 180263394, 2074516, 193287377, 233917246, 68895513, 58212503, 264797440, 14900332, 5663432, 241850309, 52365171, 212100059, 209785019, 36530290, 267475378, 200255903, 197788181, 185480103, 5394906, 250689288, 152142544, 257387640, 124759456, 69028528, 237746003, 99706478];
}

export function getEnumPlayerAvatarFrameValues() {
  return [0, 1];
}

export function getEnumSocietyValues() {
  return [0, 1, 2, 3, 4, 5];
}

export function getEnumDailyRewardStateValues() {
  return [0, 1, 2, 3];
}

export function getEnumDailyRewardTypeValues() {
  return [0, 1, 2];
}

export function getEnumSpecialOfferGroupValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96];
}

export function getEnumSpecialOfferStateValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumABTestClientStatusValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
}

export function getEnumQAUserRoleValues() {
  return [0, 1, 2];
}

export function getEnumQAUserIdentityValues() {
  return [0, 1, 2, 3];
}

export function getEnumLimitValues() {
  return [0, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 85, 86, 80, 81, 82, 83, 84, 40, 50, 51, 52, 53, 54, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 200, 201, 202, 203, 204, 205, 206, 207, 208, 209, 210, 211, 212, 213, 214, 215, 216, 217, 218, 219, 70, 71, 72, 73, 74, 75, 92, 93, 94, 95, 76, 77, 78, 79, 90, 91, 100, 101, 102, 103, 104, 105, 106, 107, 108, 300, 301, 302, 303, 304, 305, 306, 308, 309, 310, 311, 312, 315, 330, 400, 410, 411, 412, 413, 414, 500, 110, 111, 112, 120, 121, 122, 123, 124, 125, 126, 130, 9000, 150, 151, 152, 153, 154, 155, 600, 601, 602, 603, 604, 605, 606, 700, 701, 1200, 1201, 1202, 1203, 1204, 1205, 1206, 1300, 800];
}

export function getEnumAnalyticsUserMetricValues() {
  return [0, 1, 2, 3, 4, 5, 6];
}

export function getEnumAnalyticsPlayerCohortValues() {
  return [0, 1, 2, 3, 4, 5, 6];
}

export function getEnumAdPlacementValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 101, 102];
}

export function getEnumAdPlacementStatusValues() {
  return [0, 1, 2, 101, 201, 202, 203, 204, 205];
}

export function getEnumAdOfferwallRewardStatusValues() {
  return [0, 1, 201];
}

export function getEnumTechSupportPlacementValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7];
}

export function getEnumNotificationChannelValues() {
  return [0, 1, 2, 3, 4, 5];
}

export function getEnumLocalNotificationValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65];
}

export function getEnumExtFilesTrackValues() {
  return [0, 1];
}

export function getEnumAssetBundleCompressionValues() {
  return [0, 1, 2, 3];
}

export function getEnumTechSupportOperatorValues() {
  return [0, 1, 2];
}

export function getEnumFileDownloadMethodValues() {
  return [0, 1];
}

export function getEnumInsiderUserRoleValues() {
  return [1, 2, 3];
}

export function getEnumInsiderUserActionTypeValues() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24];
}

export function getEnumRainbowActivationTypeValues() {
  return [1, 2, 3];
}

export function getEnumTmntTypeValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8];
}

export function getEnumTmntMedalValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumTmntStatusValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumTmntIndividualLeagueValues() {
  return [0, 1, 2, 3, 4, 5, 6];
}

export function getEnumRushStatusValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumWinStreakStatusValues() {
  return [0, 1, 2, 3];
}

export function getEnumWinStreakTypeValues() {
  return [179432759, 218578173, 69217790, 209619100, 102032800, 231119380, 20352860, 138246943, 211473605];
}

export function getEnumWinStreakPublicTypeValues() {
  return [218578173, 138246943, 102032800];
}

export function getEnumWinStreakPersonalTypeValues() {
  return [69217790, 209619100, 231119380, 20352860];
}

export function getEnumM3LevelSequenceIteratorValues() {
  return [0, 1];
}

export function getEnumUserAcquisitionCohortValues() {
  return [0, 1, 2, 3, 4, 5, 6, 101];
}

export function getEnumUserAcquisitionKindValues() {
  return [0, 1, 2];
}

export function getEnumUserAcquisitionServerStateValues() {
  return [0, 1, 2];
}

export function getEnumGvntTypeValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72];
}

export function getEnumGvntStatusValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumGvntPotStatusValues() {
  return [1, 2, 3, 4];
}

export function getEnumGvntFlowerValues() {
  return [1, 2, 3, 4];
}

export function getEnumMachineTagValues() {
  return [1, 2];
}

export function getEnumFestiveDecorSlotValues() {
  return [0, 1, 2, 3, 4, 5, 6, 8, 9, 10, 12, 13, 14, 15, 16, 22, 18, 19, 17, 20, 21, 11, 23, 24, 25, 7, 26, 101, 102, 103];
}

export function getEnumGeoSocietyHideableObjectValues() {
  return [0, 1];
}

export function getEnumBattlePassDecorSlotValues() {
  return [0];
}

export function getEnumCameraBoundsStageValues() {
  return [0, 1];
}

export function getEnumFeedbackSurveyArgValues() {
  return [0, 1, 2, 3];
}

export function getEnumFeedbackSurveyStatusValues() {
  return [0, 1, 2, 3, 4, 5, 6];
}

export function getEnumTutorialTagValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
}

export function getEnumMesaStateValues() {
  return [0, 1, 2, 3];
}

export function getEnumMesaStatusValues() {
  return [0, 1, 2];
}

export function getEnumMesaTypeValues() {
  return [197417682, 84269712, 114889750, 153407683, 242105588, 125239771, 108565663, 90369301, 204274525, 190312222, 255230679, 139302548, 202082084, 141224685, 13081626, 64873872, 78049747, 63603464, 193541734, 183244517, 12004376, 99295120, 13695618, 136614663, 53694049, 161767620, 76797876, 25907272, 209362749, 240219156, 139479614, 12420085, 129398124, 128746445, 255929879, 265203146, 249503597, 71840200, 159352504, 208077124, 26660401, 62727448, 96213810, 223466233, 173679712, 222021250, 97938264, 89778309, 95392669, 50325200, 198365924, 151361348, 23441217, 60952756, 166692576, 167642967, 7551890, 100040608, 80943751, 97201648, 82725079, 217113087, 232096984, 247500561, 266725942, 155591585, 140723846, 8253358, 22579849, 4242942, 23451865, 159085041, 140383446, 189472543, 175012408, 212571634, 227471573, 93346301, 78986458, 95226797, 76050058, 211208098, 6288265, 55244864, 139772935, 112424108, 165790285, 147834921, 85262574, 229421661, 225537373, 159546591, 258565517, 236195828, 133157916];
}

export function getEnumMesaUIEventValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 101, 102, 103, 110];
}

export function getEnumCollectionsStepValues() {
  return [1, 2, 3];
}

export function getUIM3FailedBubbleItemTypeValues() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
}

export function getEnumBattlePassTypeValues() {
  return [0, 66889332, 96021351, 135675450, 186858163, 248731929, 203920031, 229740742, 44518064, 169205758, 220758278, 26966858, 235864425, 30856632, 226047957, 80092436, 172549851, 244031023, 4999391, 25573064, 162390976, 63590610, 24933576, 103080438, 19926441, 61919985, 198383642, 124020412, 206916675, 85349898, 46922603, 19198549, 11980097, 173530299, 98443129, 103407892, 178293558, 225135206, 267257778, 145307652, 93263450, 69645621, 226013015, 227461389, 139749850, 10601092, 5385302, 72095947, 179925271, 45761434, 206206815, 91579632, 92601849, 179795797, 235516182, 166963397, 88994336, 30803342, 25551595, 163242515, 139493227, 121213394, 204664560, 173520010, 137647445, 241210918, 39948302, 221596644, 94218511, 119659565, 255733369, 205319734, 32418328, 166451676, 143903978, 240037891, 261763874, 263949834, 163318518, 224913648, 132754311, 166600133, 103432464, 44467804, 173350172, 197060479, 171709057, 127823442];
}

export function getEnumBattlePassStatusValues() {
  return [0, 1, 2, 3];
}

export function getEnumBattlePassRewardStateValues() {
  return [0, 1, 2];
}

export function getEnumBattlePassRewardsPartVersionValues() {
  return [0, 1];
}

export function getEnumBattlePassRewardTypeValues() {
  return [0, 1, 2];
}

export function getEnumDerbyStatusValues() {
  return [0, 1, 2, 3];
}

export function getEnumDerbyAudienceValues() {
  return [0, 1, 2];
}

export function getEnumRaceStatusValues() {
  return [0, 1, 2];
}

export function getEnumPromoCodeStatusValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9];
}

export function getEnumPromoCodeRewardStateValues() {
  return [0, 1, 2];
}

export function getEnumRandomSeedGroupValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46];
}

export function getEnumMergeFieldTagValues() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53];
}

export function getEnumMahjongFieldTagValues() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38];
}

export function getEnumItemAdditionStackTagValues() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52];
}

export function getEnumClubGiftTypeValues() {
  return [0, 1];
}

export function getEnumMesaJigsawThemeValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];
}

export function getEnumCharacterValues() {
  return [0, 20808534, 73782177, 267329427, 70465995, 217744055, 123065358, 3248650, 261331690, 5331241, 32906133, 128116580, 135724455, 145944780];
}

export function getEnumTapValues() {
  return [0, 1, 2, 3];
}

export function getEnumDressVariantValues() {
  return [0, 1, 2, 3];
}

export function getEnumM3SeqABTestAudienceTagValues() {
  return [0, 50, 51, 52, 53, 100, 101, 200, 201, 300, 301, 350, 351, 400, 401, 402, 403, 404, 450, 451, 500, 501, 550, 551, 600, 601, 650, 651, 700, 701, 800, 801];
}

export function getEnumGlobalQuestStateValues() {
  return [0, 1, 2, 3, 4, 5];
}

export function getEnumGlobalQuestTaskKindValues() {
  return [0, 1, 2, 3, 100];
}

export function getEnumGlobalQuestTaskTagValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31];
}

export function getEnumGlobalQuestTaskGeneratorKindValues() {
  return [0, 1, 2];
}

export function getEnumLocationThemeStatusValues() {
  return [0, 1, 2, 3];
}

export function getEnumLocationThemeValues() {
  return [0, 173346143, 239115985, 231073735, 18153885, 13334447, 68954657, 266198884, 65947958, 247614140, 175252578, 81366780, 70541736, 244418913, 161230823, 165042267, 101579420, 24866492, 171669109];
}

export function getEnumGvntQuestTutorialMaskValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumTimeUnitValues() {
  return [0, 1, 2];
}

export function getEnumProgressBarTypeValues() {
  return [1, 2];
}

export function getEnumM3AudienceSourceValues() {
  return [1, 2];
}

export function getEnumIntraTeamTmntProgressValues() {
  return [1, 2, 3];
}

export function getEnumAnnouncementSubjectTypeValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumAnnoucementConditionTypeValues() {
  return [0, 1, 2];
}

export function getEnumServerNotificationValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35];
}

export function getEnumServerNotificationGroupValues() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
}

export function getEnumBonusLevelStateValues() {
  return [0, 1];
}

export function getEnumSideActivityOnboardingStepValues() {
  return [0, 1, 2, 3, 4, 5, 6];
}

export function getEnumMaterialManagerTagValues() {
  return [0, 1];
}

export function getEnumFestivalZoneValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7];
}

export function getEnumAccountDeletingStatusValues() {
  return [0, 1, 2, 3];
}

export function getEnumGvntPlayerPurposeValues() {
  return [0, 1, 2];
}

export function getUIM3FailedBubbleWndTypeValues() {
  return [1, 2];
}

export function getEnumProtractedFailWndTypeValues() {
  return [1, 2, 3, 4];
}

export function getEnumWndTypeValues() {
  return [0, 1, 2];
}

export function getUIM3FailedBubbleActionValues() {
  return [1, 2, 3, 4, 5];
}

export function getUIBankWidgetActionValues() {
  return [1, 2, 3];
}

export function getUIBankWidgetTypeValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 9];
}

export function getM3TestingSystemOwnerValues() {
  return [0, 1, 2];
}

export function getStoryLockStateValues() {
  return [0, 1, 2];
}

export function getEnumBillingAPIValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumVibrationValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41];
}

export function getEnumScreenFunnelValues() {
  return [0, 100, 200, 300, 400, 500, 600, 700, 800, 900, 1000, 1100, 1200, 1300, 1400, 1500, 1600, 1700, 1800, 1900];
}

export function getEnumLifetimeMetricValues() {
  return [0, 100];
}

export function getEnumDLCBundleStatusValues() {
  return [0, 10, 20, 30, 40, 50, 60, 70, 80];
}

export function getEnumSplashScreenTypeValues() {
  return [0, 1, 3];
}

export function getEnumSplashScreenLogoPositionValues() {
  return [0, 1];
}

export function getEnumRemoteOfferStateValues() {
  return [0, 1, 2];
}

export function getEnumStoryItemIconFitValues() {
  return [0, 1];
}

export function getEnumCameraEffectValues() {
  return [0, 1];
}

export function getEnumAccountTransferCodeStateValues() {
  return [0, 1, 2, 3];
}

export function getEnumDayOfWeekValues() {
  return [1, 2, 3, 4, 5, 6, 0];
}

export function getEnumFeatureValues() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
}

export function getEnumFeatureStateValues() {
  return [0, 1, 2, 3];
}

export function getEnumUIAttentionGroupValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53];
}

export function getEnumSuspiciousActivityValues() {
  return [0, 1, 2, 4, 8, 16, 32, 64];
}

export function getEnumLocationRoomLoadingLazinessValues() {
  return [0, 1, 2];
}

export function getEnumIconPlaceValues() {
  return [0, 1];
}

export function getEnumLocationValues() {
  return [90844505, 195136432];
}

export function getEnumUpdateOfferTypeValues() {
  return [0, 1, 2];
}

export function getEnumMesaCheckpointsLivesRecoveryKindValues() {
  return [0, 1];
}

export function getEnumMesaCheckpointsRewardsClaimPointValues() {
  return [0, 1];
}

export function getEnumMesaCheckpointsRewardsLossKindValues() {
  return [0, 1];
}

export function getEnumIconDisplayModeValues() {
  return [0, 1];
}

export function getEnumFBSAnalyticsEventValues() {
  return [1, 2];
}

export function getEnumAFAnalyticsEventValues() {
  return [1, 2];
}

export function getEnumRegattaStatusValues() {
  return [0, 1, 2];
}

export function getEnumRegattaRoundStatusValues() {
  return [0, 1, 2, 3];
}

export function getEnumRegattaJoinRoundStatusValues() {
  return [0, 1, 2];
}

export function getEnumRegattaLeaveRoundStatusValues() {
  return [0, 1, 2, 3, 4];
}

export function getEnumABTestTagValues() {
  return [1];
}

export function getEnumCollectionStatusValues() {
  return [0, 1, 2, 3];
}

export function getCollectionItemTypeValues() {
  return [0, 1, 2, 3];
}

export function getCollectionGroupTypeValues() {
  return [1, 2];
}

export function getCollectionGroupBackgroundValues() {
  return [1, 2, 4, 5, 6, 7, 8, 9, 10];
}

export function getCollectionCardBackgroundValues() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
}

export function getCollectionGroupPatternValues() {
  return [3, 4, 5, 6, 7, 8, 9];
}

export function getEnumActivityTypeValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
}

export function getEnumDigMechanicsFieldTagValues() {
  return [1];
}

export function getM3DirValues() {
  return [0, 1, 2, 3, 4];
}

export function getM3MatchModeValues() {
  return [0, 1, 2, 3];
}

export function getM3PlaneValues() {
  return [0, 1];
}

export function getM3TilemapValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8];
}

export function getM3MechanicsValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 20, 21, 22, 23, 24, 25, 27, 28, 29, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54];
}

export function getM3GoalsIdsValues() {
  return [0, 10, 34681458, 182865318, 165835097, 17201424, 124248265, 105096733, 72057805, 86370893, 168633071, 107133260, 37925772, 144139772, 152123871, 69201358, 103514130, 109310110, 47307072, 99200788, 239173506, 58458845, 240727102, 77815192, 99382431, 268228540, 46351931, 171013116, 187083537, 77312621, 259889572, 4705389, 259027716, 215706882, 243654319, 1, 2, 3, 4, 5, 6];
}

export function getM3ChipsValues() {
  return [0, 159587649, 149856411, 173571093, 20043541, 152790968, 266541332, 152369935, 17824785, 34681458, 182865318, 192896741, 165835097, 17201424, 103514130, 37876280, 168633071, 109310110, 130928691, 47307072, 4705389, 259027716, 158564410, 203671966, 144508370, 108834744, 4153540, 105916447, 150880180, 223856470, 72057805, 251912449, 86370893, 220370293, 78621104, 64273907, 129355834, 107133260, 99200788, 264630631, 97991665, 27253688, 20890305, 243654319, 259889572, 77815192, 203259574, 156916201, 268228540, 215706882, 99382431, 169073011, 204595850, 126361439, 7588332, 217835229, 34356751, 63418720, 130361475, 238292662, 246509973, 233729156, 248454097, 137848189, 77107490, 115048568, 46351931, 171013116, 187083537, 164015039, 146262794, 233405292, 226894248, 22251383, 155655390, 33287124, 128711131, 236501597, 92056254, 115710274, 250675947, 119511529, 1959918, 11774505, 222429917, 176471193, 43001648, 107148176, 209502773, 226084583, 76199471, 228435278, 77312621, 52335828, 239173506];
}

export function getM3RegularChipsValues() {
  return [0, 149856411, 159587649, 173571093, 20043541, 152790968, 152369935, 17824785, 266541332];
}

export function getM3TargetChipsValues() {
  return [0, 223856470, 268228540, 77312621, 251912449, 228435278];
}

export function getM3ChipsCatValues() {
  return [238292662, 246509973, 233729156, 248454097, 137848189, 77107490, 115048568, 46351931];
}

export function getM3CompassDirValues() {
  return [1, 2, 3, 4, 5];
}

export function getM3ChipsPaintValues() {
  return [0, 176942238, 10502419, 137783651, 208900658, 44005175, 131475464, 159587649, 220370293, 78621104, 64273907, 129355834];
}

export function getM3ChipsPetardValues() {
  return [0, 22788757, 22861769, 257908925, 128173113, 156180796, 214376637, 159587649, 220370293, 78621104, 64273907, 129355834];
}

export function getM3ChipsBirdsValues() {
  return [225305613, 68663070, 26693013, 194353825, 91848612, 116972268, 159587649, 220370293, 78621104, 64273907, 129355834];
}

export function getM3TrashChipsValues() {
  return [34681458, 182865318, 192896741, 130928691, 47307072, 156916201, 169073011, 204595850, 171013116, 4705389, 259027716, 215706882];
}

export function getM3LinkChipsValues() {
  return [217835229, 34356751, 63418720, 130361475];
}

export function getM3BombChipsValues() {
  return [158564410, 203671966, 144508370, 108834744, 4153540, 105916447];
}

export function getM3MultiColorChipsValues() {
  return [0, 259889572, 27253688, 20890305, 243654319];
}

export function getM3UmbrellaChipsValues() {
  return [0, 22251383, 155655390, 33287124, 128711131, 236501597, 92056254];
}

export function getM3Icebomb1ChipsValues() {
  return [0, 115710274, 250675947, 119511529, 1959918, 11774505, 222429917];
}

export function getM3Icebomb2ChipsValues() {
  return [0, 176471193, 43001648, 107148176, 209502773, 226084583, 76199471];
}

export function getM3MultiCellChipsValues() {
  return [0, 150880180, 233405292, 226894248];
}

export function getM3CurtainsValues() {
  return [0, 187083537];
}

export function getM3InvaderChipsValues() {
  return [0, 107133260];
}

export function getM3SourceSpawnValues() {
  return [0, 1, 2, 3, 4];
}

export function getM3SpawnTypeValues() {
  return [173571093, 20043541, 152790968, 152369935, 266541332, 17824785, 165835097, 182865318, 99200788, 52335828, 239173506, 77312621, 215706882, 228435278, 246509973, 233729156, 248454097, 137848189, 77107490, 115048568, 115710274, 250675947, 119511529, 1959918, 11774505, 222429917, 176471193, 43001648, 107148176, 209502773, 226084583, 76199471];
}

export function getM3ExtraSpawnTypeValues() {
  return [173571093, 20043541, 152790968, 152369935, 266541332, 17824785, 158564410, 203671966, 144508370, 108834744, 4153540, 105916447, 165835097, 182865318, 52335828, 99200788, 239173506, 156916201, 99382431, 171013116, 146262794, 17201424, 168633071, 77312621, 215706882, 228435278, 246509973, 233729156, 248454097, 137848189, 77107490, 115048568, 115710274, 250675947, 119511529, 1959918, 11774505, 222429917, 176471193, 43001648, 107148176, 209502773, 226084583, 76199471];
}

export function getM3SpawnIconValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29];
}

export function getM3ChipsLayeredValues() {
  return [0, 103514130, 37876280, 168633071, 109310110, 34681458, 203259574];
}

export function getM3ChipsBlockerValues() {
  return [0, 144139772, 152123871, 69201358];
}

export function getM3ChipsBlockedValues() {
  return [0, 37280846, 62260110, 171654987, 50342600, 75185803, 100000075, 26512514, 267755988, 72412603, 258430648, 201310007, 71160841, 261658726, 222593823];
}

export function getM3ChipsRiderValues() {
  return [0];
}

export function getM3ChipsConversionsValues() {
  return [264630631, 164015039, 97991665, 52335828];
}

export function getM3MatsValues() {
  return [0, 37925772];
}

export function getM3CoversValues() {
  return [0, 58458845, 240727102];
}

export function getM3WallsValues() {
  return [0, 165432907, 196666317];
}

export function getM3BeltsValues() {
  return [0, 39232813, 92461380];
}

export function getM3BarriersValues() {
  return [0, 150329024, 42563302];
}

export function getM3PortalsValues() {
  return [0, 210966518, 83030634, 80246951];
}

export function getM3SpawnersValues() {
  return [0, 1];
}

export function getM3DamageSourceTypeValues() {
  return [0, 1];
}

export function getM3DamageTypeValues() {
  return [0, 1, 2, 4, 8, 16, 32, 64];
}

export function getM3DamageResponseValues() {
  return [0, 1, 2];
}

export function getM3GoalTypeValues() {
  return [0, 1, 2, 3, 4];
}

export function getM3GoalTypeBarrierListValues() {
  return [0, 3];
}

export function getM3GoalAnimTypeValues() {
  return [0, 1, 2];
}

export function getM3GoalChipsValues() {
  return [173571093, 20043541, 152790968, 266541332, 152369935, 17824785, 34681458, 182865318, 165835097, 17201424, 124248265, 105096733, 109310110, 72057805, 86370893, 47307072, 99200788, 239173506, 58458845, 240727102, 77815192, 99382431, 169073011, 204595850, 144508370, 108834744, 203671966, 158564410, 4153540, 268228540, 46351931, 171013116, 187083537, 146262794, 77312621, 259889572, 217835229, 4705389, 259027716, 215706882, 243654319, 228435278, 42563302];
}

export function getM3GoalCollectChipsValues() {
  return [77312621];
}

export function getM3GoalTagsValues() {
  return [0, 1, 2, 3, 4, 5, 6];
}

export function getM3GoalRemoveAllTargetsValues() {
  return [0, 17824785, 34681458, 182865318, 165835097, 17201424, 150880180, 107133260, 144139772, 152123871, 69201358, 109310110, 47307072, 171013116, 58458845, 240727102, 77815192, 268228540, 169073011, 204595850, 46351931, 187083537, 77312621, 259889572, 217835229, 4705389, 259027716, 215706882, 239173506, 1, 2, 3, 4, 5, 6, 7];
}

export function getM3CertainRandomChipsValues() {
  return [220370293, 78621104, 64273907, 129355834];
}

export function getM3LevelSpecificsTypeValues() {
  return [0, 1, 2, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18];
}

export function getM3LevelOfDifficultyValues() {
  return [0, 1, 2];
}

export function getM3BoosterTypeValues() {
  return [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14];
}

export function getM3BoosterUseTypeValues() {
  return [0, 1, 2, 3];
}

export function getM3InstantBoostersValues() {
  return [100649854, 222310101, 95925952];
}

export function getM3LinkDirectionValues() {
  return [0, 1, 2, 4, 8];
}

export function getM3MarkerTypeValues() {
  return [2827952, 50688134, 225717855, 82154108];
}

export function getM3WinStreakTypeValues() {
  return [0, 102032800];
}

export function getM3AssistantTypeValues() {
  return [0, 1, 2, 3];
}

export function getCutsceneWrapModeValues() {
  return [0, 1, 2, 3];
}

export function getCutscenePostPlaybackStateValues() {
  return [0, 1, 2, 3];
}

export function getCutscenePostPlaybackCustomizationStateValues() {
  return [0, 1, 2];
}

export function getCutsceneTransformApplyModeValues() {
  return [0, 1];
}

export function getCutsceneDialogTypeValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51, 52, 53, 54, 55, 56, 57, 58, 59, 60, 61, 62, 63, 64, 65, 66, 67, 68, 69, 70, 71, 72, 73, 74, 75, 76, 77, 78, 79, 80, 81, 82, 83, 84, 85, 86, 87, 88, 89, 90, 91, 92, 93, 94, 95, 96, 97, 98, 99, 100, 101, 102, 103, 104, 105, 106, 107, 108, 109, 110, 111, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 122, 123, 124, 125, 126, 127, 128, 129, 130, 131, 132, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153, 154, 155, 156, 157, 158, 159, 160, 161, 162, 163, 164, 165, 166, 167, 168, 169, 170, 171, 172, 173, 174, 175, 176, 177, 178];
}

export function getCutscenePointValues() {
  return [0, 1, 2, 3, 4, 5];
}

export function getClubTypeValues() {
  return [0, 1];
}

export function getClubFlagValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47, 48, 49, 50, 51];
}

export function getTweenFuncTypeValues() {
  return [0, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16];
}

export function getM3ActionTypeValues() {
  return [0, 1, 2, 4, 8, 16, 32];
}

export function getM3EventTypeValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
}

export function getOperatorValues() {
  return [0, 1, 2];
}

export function getEnumRiverRumbleStatusValues() {
  return [0, 1, 2, 3];
}

export function getEnumRiverRumbleSequenceValues() {
  return [0, 1];
}

export function getEnumBitStatsEventValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 14, 15, 16];
}

export function getRpcErrorRestoreGameValues() {
  return [0, 1];
}

export function getRpcErrorSaveGameValues() {
  return [0, 1];
}

export function getRpcErrorAddIdentityValues() {
  return [0, 1];
}

export function getRpcErrorIAPValues() {
  return [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13];
}

export function getError_CLUB_MAKEValues() {
  return [0];
}

export function getError_CLUB_JOINValues() {
  return [0, 1, 2, 3, 4];
}

export function getError_CLUB_JOIN_PRIVValues() {
  return [0, 1, 2, 3, 4, 5];
}

export function getError_CLUB_SAYValues() {
  return [0, 1];
}

export function getEnumTmntPromotionValues() {
  return [0, 1, 2];
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumServerErrorName(code) {
  switch(code) {
    case  0: return 'NONE';
    case -1: return 'GENERIC';
    case -2: return 'BAD_AUTH';
    case -3: return 'UPDATE_CLIENT';
    case -4: return 'BANNED';
    case -5: return 'MAINTENANCE';
    case -6: return 'BAD_PLAYER';
    case -7: return 'PLAYER_REMOVED';
    case -8: return 'CHEATER_ACCESS_DENIED';
  }
  return `Unknown EnumServerError code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRpcErrorName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'NET_ERROR';
    case 3: return 'CLIENT_EXCEPTION';
    case 4: return 'CLIENT_CANCELLED';
    case 5: return 'REQUEST_TIMEDOUT';
  }
  return `Unknown EnumRpcError code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumStatName(code) {
  switch(code) {
    case  0: return 'NOTIFICATION_SCHEDULED';
    case 10: return 'NOTIFICATION_SENT';
    case 20: return 'EXEC_RPC';
  }
  return `Unknown EnumStat code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumCheaterReasonName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'EXECUTABLE_INFO';
    case 2: return 'SAVE_OLD_VERSION';
  }
  return `Unknown EnumCheaterReason code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumLanguageName(code) {
  switch(code) {
    case 0: return 'en';
    case 1: return 'ru';
    case 2: return 'undefined';
    case 3: return 'de';
    case 4: return 'pt';
    case 5: return 'es';
    case 6: return 'fr';
    case 7: return 'ko';
    case 8: return 'ja';
  }
  return `Unknown EnumLanguage code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumPlatformName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'IOS';
    case 2: return 'GPLAY';
    case 3: return 'AMAZON';
    case 4: return 'SAMSUNG';
    case 5: return 'HUAWEI';
  }
  return `Unknown EnumPlatform code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumPlatformBitName(code) {
  switch(code) {
    case  0: return 'NONE';
    case  1: return 'IOS';
    case  2: return 'GPLAY';
    case  4: return 'AMAZON';
    case  8: return 'SAMSUNG';
    case 16: return 'HUAWEI';
  }
  return `Unknown EnumPlatformBit code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumClientIdentityName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'EXT_ID';
    case 2: return 'DEVICE';
    case 3: return 'FB';
    case 4: return 'GPLAY';
    case 5: return 'APPLE';
    case 6: return 'MYGAMES';
    case 7: return 'ACCOUNT_TRANSFER_CODE';
  }
  return `Unknown EnumClientIdentity code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumInGameEventName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'DressSelected';
    case  2: return 'DecorSelected';
    case  3: return 'DressSelectionCancelled';
    case  4: return 'DecorSelectionCancelled';
    case  5: return 'PetNameChanged';
    case  6: return 'PetNameChangeCancelled';
    case  7: return 'SysQuestAlwaysActive';
    case  8: return 'TutorialComplete';
    case  9: return 'TutorialCancelled';
    case 10: return 'TutorialStarted';
  }
  return `Unknown EnumInGameEvent code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumStockName(code) {
  switch(code) {
    case  41259540: return 'M3_STAR';
    case 112151937: return 'M3_STAR_LIMITED';
    case  65428884: return 'M3_LIFE';
    case 120783026: return 'M3_LIFE_MAX';
    case 250458942: return 'M3_BOOSTER_EXTRA_MOVES';
    case 254488213: return 'M3_BOOSTER_RAINBOW';
    case 208477032: return 'M3_BOOSTER_HBBOMB';
    case 146135299: return 'M3_BOOSTER_DOUBLE_ROCKET';
    case  71848851: return 'M3_BOOSTER_HAMMER';
    case 111025913: return 'M3_BOOSTER_SLEDGEHAMMER';
    case  71359390: return 'M3_BOOSTER_GLOVE';
    case 255786630: return 'M3_BOOSTER_BONUS_MOVES';
    case 257611015: return 'M3_BOOSTER_ONE_MOVE';
    case 249216032: return 'M3_BOOSTER_SUPER_RAINBOW';
    case  71857089: return 'M3_BOOSTER_SUPER_RAINBOW_DISPOSABLE';
    case 151142894: return 'M3_BOOSTER_BURNING_ROCKET';
    case  24184776: return 'M3_BOOSTER_BURNING_RAINBOW';
    case 232424325: return 'M3_BOOSTER_BURNING_HBBOMB';
    case 137248552: return 'M3_BOOSTER_BURNING_HBOMB';
    case 114267458: return 'M3_BOOSTER_BURNING_VBOMB';
    case  40982798: return 'M3_BOOSTER_BURNING_BBOMB';
    case 100649854: return 'M3_BOOSTER_BURNING_HAMMER';
    case  95925952: return 'M3_BOOSTER_BURNING_SLEDGEHAMMER';
    case 222310101: return 'M3_BOOSTER_BURNING_GLOVE';
    case 109897756: return 'M3_BOOSTER_WINSTREAK_STEPS';
    case 227369309: return 'M3_BOOSTER_WINSTREAK_BUG';
    case 125623217: return 'M3_BOOSTER_WINSTREAK_BBOMB';
    case  50326614: return 'M3_BOOSTER_WINSTREAK_HVBOMB';
    case  26874558: return 'M3_BOOSTER_WINSTREAK_RAINBOW';
    case  63051773: return 'M3_BOOSTER_WINSTREAK_VBOMB';
    case 140136229: return 'MONEY';
    case 250952865: return 'MONEY_PAID';
    case 247912363: return 'CLUB_GIFT';
    case  88937451: return 'M3_MOVE';
    case 220414064: return 'GVNT_FLOWER_SEED';
    case 248296543: return 'GVNT_FLOWER';
    case 153006451: return 'GVNT_FLOWER_SEED_COUNTER';
    case 267073102: return 'GVNT_PUMPKIN_SEED';
    case  24903204: return 'GVNT_PIE';
    case  29026631: return 'GVNT_PUMPKIN_SEED_COUNTER';
    case 174732018: return 'GVNT_ELEPHANT';
    case 127115697: return 'GVNT_ELEPHANT_COUNTER';
    case   7658338: return 'GVNT_CANDYCANE';
    case 222793166: return 'GVNT_CANDYCANE_COUNTER';
    case 158360729: return 'GVNT_CANDYCANE_SPECIAL';
    case 187556710: return 'MESA_FK_LIFE';
    case 255641636: return 'GVNT_CHINESE_NY21_CURRENCY';
    case 218896632: return 'GVNT_CHINESE_NY21_CURRENCY_COUNTER';
    case 191567948: return 'GVNT_CHINESE_NY21_CURRENCY_SPECIAL';
    case 145006193: return 'GOLDEN_TICKET';
    case  97717656: return 'BIG_GOLDEN_TICKET';
    case 141030531: return 'SUPER_GOLDEN_TICKET';
    case  26711773: return 'GIVEAWAY_GOLDEN_TICKET';
    case 232049586: return 'GVNT_PIRATE21_CURRENCY';
    case 113647149: return 'OFFER_GOLD_X_MULTIPLY';
    case  51255808: return 'OFFER_GOLD_X_MULTIPLY_ALL';
    case  48278976: return 'GVNT_DARK_CASTLE21_CURRENCY';
    case 221454860: return 'M3_LEVELS_HOROSCOPE_01';
    case 257917831: return 'DAILY_QUEST_XP_BONUS_015';
    case  52360249: return 'DAILY_QUEST_XP_BONUS_030';
    case 129866324: return 'DAILY_QUEST_XP_BONUS_060';
    case 132828839: return 'DAILY_QUEST_XP_BONUS_120';
    case  75563595: return 'GVNT_MAHJONG_BOAT_CLUB_22_CURRENCY';
    case  20273967: return 'GVNT_MAHJONG02_HALLOWEEN22_CURRENCY';
    case  58263650: return 'GVNT_MAHJONG03_WINTER23_CURRENCY';
    case  52501899: return 'GVNT_MAHJONG04_FAIRY_BALL23_CURRENCY';
    case  99484835: return 'GVNT_MAHJONG05_EXPEDITION23_CURRENCY';
    case 220211542: return 'GVNT_MAHJONG05_THANKSGIVING23_CURRENCY';
    case  64654092: return 'GVNT_MAHJONG07_FAIRYTALES24_CURRENCY';
    case 247891409: return 'GVNT_MAHJONG08_LADIESDAY24_CURRENCY';
    case 240255460: return 'GVNT_MAHJONG09_ORIENTAL124_CURRENCY';
    case  43297642: return 'GVNT_MAHJONG10_ORIENTAL324_CURRENCY';
    case 179287198: return 'GVNT_MAHJONG11_TENNIS24_CURRENCY';
    case  86498303: return 'GVNT_MAHJONG12_SCHOOL24_CURRENCY';
    case  64273735: return 'GVNT_MAHJONG13_HALLOWEEN24_CURRENCY';
    case 152672137: return 'GVNT_MAHJONG14_CHRISTMAS24_CURRENCY';
    case 176195498: return 'GVNT_MAHJONG15_VALENTINE25_CURRENCY';
    case 163261517: return 'GVNT_MAHJONG16_SPRING25_CURRENCY';
    case  31844273: return 'GVNT_MAHJONG17_CARNIVAL25_CURRENCY';
    case   2179812: return 'GVNT_MAHJONG18_HALLOWEEN25_CURRENCY';
    case 213654220: return 'GVNT_MAHJONG19_CHRISTMAS25_CURRENCY';
    case  19955063: return 'M3_BOOSTER_SUPER_RAINBOW_LIFE';
    case  67860965: return 'M3_BOOSTER_SUPER_RAINBOW_UP1';
    case 169464439: return 'M3_BOOSTER_SUPER_RAINBOW_UP2';
    case 224577076: return 'M3_BOOSTER_SUPER_RAINBOW_UP3';
    case 258333665: return 'JOKER_TOKENS';
    case 145635986: return 'JOKER';
    case  62715865: return 'COLLECTION_CARD';
  }
  return `Unknown EnumStock code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumResourceGameActionName(code) {
  switch(code) {
    case   0: return 'Login';
    case   1: return 'LoginDailyBonus';
    case   2: return 'LevelStart';
    case   3: return 'LevelUseBooster';
    case   4: return 'LevelBuyInstantBooster';
    case   5: return 'LevelComplete';
    case   6: return 'LevelCompleteWatchAd';
    case   7: return 'CompleteQuest';
    case   8: return 'CompleteQuestStoryReward';
    case   9: return 'BuyM3Booster';
    case  10: return 'BuyLives';
    case  11: return 'GiftLivesReceive';
    case  12: return 'GiftLivesWatchAd';
    case  13: return 'GiftLivesApply';
    case  14: return 'BuyCoins';
    case  15: return 'SendGift';
    case  16: return 'ReadNews';
    case  17: return 'ReceivePending';
    case  18: return 'RegenLives';
    case  19: return 'BuyM3Moves';
    case  20: return 'Unknown';
    case  21: return 'LevelLost';
    case  22: return 'CreateClub';
    case  23: return 'Debug';
    case  24: return 'AddTutorialM3Booster';
    case  25: return 'FirstTimeJoinClub';
    case  26: return 'ClubHelp';
    case  27: return 'AdChest';
    case  28: return 'LevelLostWatchAd';
    case  29: return 'BuyGood1SpecialOfferThreeSteps';
    case  30: return 'CompleteSpecialOfferThreeStepsReward';
    case  31: return 'TmntPlaceReward';
    case  32: return 'TmntGoldenMedalsReward';
    case  33: return 'TmntParticipationReward';
    case  34: return 'OfferwallReward';
    case  35: return 'DoubleLevelReward';
    case  36: return 'AdSurpriseBox';
    case  37: return 'SetInventoryItemAmountFromInsider';
    case  38: return 'M3StartFreeBooster';
    case  39: return 'FacebookLoginReward';
    case  40: return 'GvntInstantGrowth';
    case  41: return 'GvntPotAdd';
    case  42: return 'TmntChestReward';
    case  43: return 'GvntMilestoneReward';
    case  44: return 'GvntAdBoostPot';
    case  45: return 'GvntReward';
    case  46: return 'GvntClaimCurrency';
    case  47: return 'GvntStartProduction';
    case  48: return 'GvntClaimProduction';
    case  49: return 'GvntDecorPurchase';
    case  50: return 'AbsenceReward';
    case  51: return 'EarnSpecialOfferItem';
    case  52: return 'GvntAction';
    case  53: return 'GvntForceRemoved';
    case  54: return 'GvntMilestoneSpecialReward';
    case  55: return 'MesaReset';
    case  56: return 'MesaBuyResource';
    case  57: return 'MesaMilestone';
    case  58: return 'BattlePassClaimCurrency';
    case  59: return 'BattlePassReward';
    case  60: return 'GoldenTicketApply';
    case  61: return 'GoldenTicketSpend';
    case  62: return 'PromoCodeReward';
    case  63: return 'BattlePassCustom';
    case  64: return 'BattlePassForceRemoved';
    case  65: return 'BattlePassClubGift';
    case  66: return 'GvntExchangeReward';
    case  67: return 'MysteryBoxOpen';
    case  68: return 'MergeFieldItemAdded';
    case  69: return 'MergeFieldItemRemoved';
    case  70: return 'MergeFieldItemMerged';
    case  71: return 'MergeFieldItemAutoMerged';
    case  72: return 'LevelHasBurningInstantBooster';
    case  73: return 'GvntStarted';
    case  74: return 'CustomAction';
    case  75: return 'GvntActivatesBurningReward';
    case  76: return 'GvntGetBurningReward';
    case  77: return 'WinStreakStartLevel';
    case  78: return 'WinStreakChangeStep';
    case  79: return 'GlobalQuestTaskComplete';
    case  80: return 'SpecialOfferPurchaseBonus';
    case  81: return 'Tutorial';
    case  82: return 'GvntFinished';
    case  83: return 'SamsungInstallReward';
    case  84: return 'CatsMinigameReward';
    case  85: return 'LevelBonusComplete';
    case  86: return 'DailyQuestRewardGranted';
    case  87: return 'CloseUIM3FailedBubble';
    case  88: return 'RaceReward';
    case  89: return 'OfferProtractedFail';
    case  90: return 'MesaHoroscope01Aries22';
    case  91: return 'M3LevelStartFromUIM3Description';
    case  92: return 'MesaHoroscope02Taurus22';
    case  93: return 'IncMesaHoroscopeIndex';
    case  94: return 'FakeStartMesa';
    case  95: return 'MahjongFieldMakeTurn';
    case  96: return 'GvntIntroTutorialStarted';
    case  97: return 'MesaHoroscope03Gemini22';
    case  98: return 'MahjongFieldUseHint';
    case  99: return 'MahjongFieldBuyHintsPack';
    case 100: return 'GvntClaimBonusCurrency';
    case 101: return 'MesaHoroscope04Cancer22';
    case 102: return 'MesaHoroscope05Leo22';
    case 103: return 'MesaHoroscope06Virgo22';
    case 104: return 'MesaHoroscope07Libra22';
    case 105: return 'MesaHoroscope08Scorpio22';
    case 106: return 'MesaHoroscope09Sagittarius22';
    case 107: return 'MesaHoroscope10Capricorn22';
    case 108: return 'MesaHoroscope11Aquarius23';
    case 109: return 'MesaHoroscope12Pisces23';
    case 110: return 'TmntRinbowRush';
    case 111: return 'GvntClaimMahjongBonus';
    case 112: return 'SpecialOfferClaimReward';
    case 113: return 'MahjongFieldHintBonusClaimed';
    case 114: return 'GvntMysteryBoxOpen';
    case 115: return 'MesaSpendLive';
    case 116: return 'MesaRestoreLives';
    case 117: return 'RiverRumbleReward';
    case 118: return 'MergeFieldBonusItemsApplied';
    case 119: return 'RegattaRoundWon';
    case 120: return 'MesaAdvent';
    case 121: return 'CollectedCollection';
    case 122: return 'CollectedCollectionsGroup';
    case 123: return 'CollectionsJokerExchange';
    case 124: return 'CollectionReplaceCards';
    case 125: return 'CollectionReplaceDuplicates';
    case 126: return 'CollectionJokerTokensToJokers';
    case 127: return 'CollectionsWelcomeReward';
    case 128: return 'DigFieldMakeTurn';
    case 129: return 'MesaM3LevelReward';
    case 130: return 'DeeplinkGiveawayReward';
    case 131: return 'FreeGoldenTicketApply';
    case 132: return 'MesaHoroscope01Aries26';
    case 133: return 'MesaHoroscope02Taurus26';
    case 134: return 'MesaHoroscope03Gemini26';
    case 135: return 'MesaHoroscope04Cancer26';
    case 136: return 'MesaHoroscope05Leo26';
    case 137: return 'MesaHoroscope06Virgo26';
    case 138: return 'MesaHoroscope07Libra26';
    case 139: return 'MesaHoroscope08Scorpio26';
    case 140: return 'MesaHoroscope09Sagittarius26';
    case 141: return 'MesaHoroscope10Capricorn26';
    case 142: return 'MesaHoroscope11Aquarius26';
    case 143: return 'MesaHoroscope12Pisces26';
  }
  return `Unknown EnumResourceGameAction code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumQuestStateName(code) {
  switch(code) {
    case 0: return 'Inactive';
    case 1: return 'Active';
    case 2: return 'Complete';
    case 3: return 'Suspended';
    case 4: return 'SuspendedComplete';
  }
  return `Unknown EnumQuestState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumQuestStoryNodeRoleName(code) {
  switch(code) {
    case 0: return 'Regular';
    case 1: return 'EntryPoint';
    case 2: return 'Terminal';
    case 3: return 'Junction';
  }
  return `Unknown EnumQuestStoryNodeRole code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumCharacterIdleBehaviourName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Wander';
  }
  return `Unknown EnumCharacterIdleBehaviour code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTutorialStateName(code) {
  switch(code) {
    case 0: return 'Inactive';
    case 1: return 'Active';
    case 2: return 'Complete';
  }
  return `Unknown EnumTutorialState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTutorialTypeName(code) {
  switch(code) {
    case 0: return 'BeforeIdleHud';
    case 1: return 'M3';
    case 2: return 'Idle';
    case 3: return 'Test';
  }
  return `Unknown EnumTutorialType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTutorialKindName(code) {
  switch(code) {
    case 0: return 'none';
    case 1: return 'gvnt_merge';
    case 2: return 'gvnt_mahjong';
    case 3: return 'bp_without_quests';
    case 4: return 'bp_with_quests';
  }
  return `Unknown EnumTutorialKind code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTutorialBubbleAvatarName(code) {
  switch(code) {
    case 0: return 'Jane';
    case 1: return 'Mammy';
    case 2: return 'James';
    case 3: return 'Slagger';
    case 4: return 'Joe';
    case 5: return 'Papaman';
    case 6: return 'Hill';
    case 7: return 'Linwood';
  }
  return `Unknown EnumTutorialBubbleAvatar code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumQuestActionKindName(code) {
  switch(code) {
    case 0: return 'Nothing';
    case 1: return 'Decorate';
    case 2: return 'Wardrobe';
    case 3: return 'PetName';
    case 4: return 'ToBeContinued';
    case 5: return 'Tutorial';
  }
  return `Unknown EnumQuestActionKind code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3EventName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'FirstTick';
    case  2: return 'NewTurn';
    case  3: return 'NoMoreTurns';
    case  4: return 'Win';
    case  5: return 'LoseByShuffle';
    case  6: return 'AfterTurn';
    case  7: return 'Destroy';
    case  8: return 'FieldChange';
    case  9: return 'ApplyBooster';
    case 10: return 'BeforeNewTurn';
    case 11: return 'PrecalcGoals';
  }
  return `Unknown M3Event code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumUserSettingName(code) {
  switch(code) {
    case 1: return 'EnableSounds';
    case 2: return 'EnableMusic';
    case 3: return 'UpdateClient';
    case 4: return 'UpdateClientHint';
    case 5: return 'EnableVibrations';
  }
  return `Unknown EnumUserSetting code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3HintDirectionName(code) {
  switch(code) {
    case 0: return 'SELF';
    case 1: return 'TOP';
    case 2: return 'RIGHT';
    case 3: return 'BOTTOM';
    case 4: return 'LEFT';
  }
  return `Unknown M3HintDirection code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBillingInitResultName(code) {
  switch(code) {
    case 0: return 'OK';
    case 1: return 'ERR_NO_ITEMS';
    case 2: return 'ERR_BAD_APP';
    case 3: return 'ERR_DISABLED';
    case 4: return 'ERR_UNKNOWN';
  }
  return `Unknown EnumBillingInitResult code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBillingPaymentResultName(code) {
  switch(code) {
    case  0: return 'OK';
    case  1: return 'CANCELLED';
    case  2: return 'ERR_INET';
    case  3: return 'ERR_NOT_READY';
    case  4: return 'ERR_BUSY';
    case  5: return 'ERR_VERIFY';
    case  6: return 'ERR_SYSTEM';
    case  7: return 'ERR_DISABLED';
    case  8: return 'ERR_DECLINED';
    case  9: return 'ERR_ALREADY_PURCHASED';
    case 10: return 'ERR_ITEM_UNAVAILABLE';
    case 11: return 'ERR_UNKNOWN';
    case 12: return 'ERR_SERVER_INTERNAL';
    case 13: return 'ERR_SERVER_INCOMPATIBLE';
    case 14: return 'ERR_UNSUPPORTED_BUILD';
  }
  return `Unknown EnumBillingPaymentResult code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBillingPaymentProcessingStepName(code) {
  switch(code) {
    case     0: return 'UNKNOWN';
    case    10: return 'INITIATED';
    case    20: return 'CANCELLED';
    case    30: return 'PAYLOAD_REQUEST_STARTED';
    case    40: return 'PAYLOAD_REQUEST_COMPLETE';
    case    50: return 'SYS_FLOW_STARTED';
    case    60: return 'SYS_FLOW_COMPLETE';
    case    70: return 'SERVER_VERIFICATION_STARTED';
    case    80: return 'SERVER_VERIFICATION_COMPLETE';
    case    90: return 'SYS_CONSUME_STARTED';
    case   100: return 'SYS_CONSUME_COMPLETE';
    case   110: return 'COMPLETE';
    case   120: return 'REWARD_GRANTED';
    case   130: return 'PROMOTED_PAYMENT_DETECTED';
    case 32000: return 'ERROR';
    case 32010: return 'ERROR_AUTO_RESOLUTION_ATTEMPT';
  }
  return `Unknown EnumBillingPaymentProcessingStep code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumPlayerRFMCategoryName(code) {
  switch(code) {
    case 0: return 'Uncategorized';
    case 1: return 'Minnow';
    case 2: return 'Dolphin';
    case 3: return 'Whale';
    case 4: return 'StarterPack';
    case 5: return 'SuperWhale';
  }
  return `Unknown EnumPlayerRFMCategory code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumClientPaymentStatusName(code) {
  switch(code) {
    case 1: return 'PENDING';
    case 2: return 'VERIFIED';
    case 0: return 'COMPLETE';
  }
  return `Unknown EnumClientPaymentStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBillingTableGradeName(code) {
  switch(code) {
    case 0: return 'UNKNOWN';
    case 1: return 'POOR';
    case 2: return 'MIDDLE';
    case 3: return 'RICH';
  }
  return `Unknown EnumBillingTableGrade code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBillingGoodsGroupName(code) {
  switch(code) {
    case   0: return 'BankCoinsOffers';
    case   1: return 'BankPacks';
    case   2: return 'SpecialOfferStarterPacks';
    case   3: return 'SpecialOfferGoldenBox';
    case   4: return 'SpecialOfferForYou';
    case   5: return 'SpecialOfferDolphinCheckUp';
    case   6: return 'SpecialOfferThreeSteps';
    case   7: return 'SpecialOfferGiftsForPay';
    case   8: return 'SpecialOfferSuperWhale';
    case   9: return 'SpecialOfferSofa';
    case  10: return 'SpecialOfferGoldenTree';
    case  11: return 'BankCoinsOffersBlackFriday';
    case  12: return 'BankPacksBlackFriday';
    case  13: return 'SpecialOfferGoldenTicket';
    case  14: return 'SpecialOfferDressSale';
    case  15: return 'SpecialOfferFashion21';
    case  17: return 'SpecialOfferProlong';
    case  18: return 'SpecialOfferTreasury';
    case  20: return 'SpecialOfferBlackFriday21';
    case  35: return 'SpecialOfferTreasury6slots';
    case  40: return 'SpecialOfferBlackFriday23';
    case  41: return 'SpecialOfferAdventBuyCurrency';
    case  42: return 'SpecialOfferGvntDressSale';
    case  43: return 'Dotseco24Packs';
    case  44: return 'TopupSofa';
    case  45: return 'TopupRegular';
    case  46: return 'TopupWeek';
    case  47: return 'TopupToken';
    case 100: return 'SpecialOfferGenericGVNT';
    case 205: return 'SpecialOfferDolphinCheckUp_GB_B';
    case 206: return 'SpecialOfferThreeSteps_GB_B';
    case 207: return 'SpecialOfferGiftsForPay_GB_B';
    case 300: return 'BankCoinsOffersTopup';
    case 301: return 'BankPacksTopup';
  }
  return `Unknown EnumBillingGoodsGroup code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumSceneTransitionModeName(code) {
  switch(code) {
    case 0: return 'Fan';
    case 1: return 'NewChapter';
    case 2: return 'SplashScreen';
    case 3: return 'Seamless';
    case 4: return 'Blackout';
  }
  return `Unknown EnumSceneTransitionMode code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumStoryEventName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'PlayCutsceneIntro';
    case 2: return 'PlayCutsceneOutro';
    case 3: return 'GrantChapterRewards';
    case 4: return 'Obsolete_PlayCutsceneTerminal';
    case 5: return 'Obsolete_PlayCutsceneEntryPoint';
    case 6: return 'Obsolete_PlayCutsceneExplicit';
  }
  return `Unknown EnumStoryEvent code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumNewsStatusName(code) {
  switch(code) {
    case 0: return 'Unread';
    case 1: return 'Read';
    case 2: return 'Expired';
  }
  return `Unknown EnumNewsStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumPendingStatusName(code) {
  switch(code) {
    case 0: return 'Pending';
    case 1: return 'Complete';
    case 2: return 'RejectedPurpose';
    case 3: return 'RejectedPayload';
  }
  return `Unknown EnumPendingStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumPendingPurposeName(code) {
  switch(code) {
    case 0: return 'RewardLetter';
    case 1: return 'RestorePaymentBySKU';
    case 2: return 'RewindStoryToQuest';
    case 3: return 'RewindM3MainSequence';
    case 4: return 'ForceSpecialOffer';
    case 5: return 'ForceApplyMigration';
    case 6: return 'TransferClubOwnershipReceived';
    case 7: return 'TransferClubOwnershipLost';
    case 8: return 'FollowingLink';
    case 9: return 'RewardForVip';
  }
  return `Unknown EnumPendingPurpose code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumPetStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Open';
  }
  return `Unknown EnumPetStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBillingEnvOverrideName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'StagingAlwaysSucceed';
    case 2: return 'BetaBillingDisabled';
  }
  return `Unknown EnumBillingEnvOverride code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumPlayerAvatarName(code) {
  switch(code) {
    case         0: return 'GenericFemale';
    case         1: return 'GenericMale';
    case         2: return 'CharacterJane';
    case         3: return 'CharacterJames';
    case         4: return 'CharacterFerret';
    case         5: return 'CharacterWroth';
    case         6: return 'CharacterSlagger';
    case         7: return 'CharacterMother';
    case         8: return 'CharacterFather';
    case         9: return 'CharacterHill';
    case        10: return 'CharacterJoe';
    case        11: return 'CharacterLinwood';
    case        12: return 'CharacterDavid';
    case        13: return 'CharacterRuington';
    case       200: return 'SocialFacebook';
    case   2096348: return 'GvntChristmas';
    case 252150272: return 'GvntChineseNY21';
    case 228707162: return 'GvntEaster21';
    case 120586800: return 'GvntSpring21';
    case 108954068: return 'GvntCheese21';
    case 177634329: return 'GvntBday21';
    case 215872012: return 'GvntChristmas21';
    case 221385440: return 'GvntSweetFest22';
    case 262188568: return 'GvntPoetryEvening22';
    case  17574525: return 'GvntEgypt22';
    case 171494193: return 'GvntChristmas22';
    case 250582719: return 'GvntEaster23';
    case  75753119: return 'GvntCelticTales23';
    case  86926330: return 'GvntMarine23';
    case 128711333: return 'GvntBaroque23';
    case 152958376: return 'GvntHalloween23';
    case  21701093: return 'GvntChristmas23';
    case  26573769: return 'GvntMahjong07Fairytales24';
    case  70383138: return 'GvntValentine24';
    case 172062527: return 'GvntMahjong08Ladiesday24';
    case  61870630: return 'GvntLadiesday124';
    case  64369787: return 'GvntLadiesday324';
    case 139857425: return 'GvntEaster24Ferret';
    case 206673802: return 'GvntEaster24Jane';
    case 246026410: return 'GvntMahjong09Oriental124';
    case  96574990: return 'GvntOrientalMammy224';
    case   8493308: return 'GvntPirate24';
    case 237646434: return 'GvntFairytale24';
    case  78050800: return 'GvntMahjong11Tennis24';
    case 247979318: return 'GvntOlympic24';
    case  39982063: return 'GvntMermaid24';
    case  65700637: return 'GvntMahjong13Halloween24';
    case  73545215: return 'GvntThanksgiving24';
    case  45052314: return 'GvntPlanetParade24';
    case 126431394: return 'GvntPatrick25';
    case  52815045: return 'GvntEaster25';
    case 217990658: return 'GvntSlagerBirthday25';
    case 112085656: return 'GvntHarvestFest25';
    case  25979493: return 'GvntTropics25';
    case 193516066: return 'GvntJapan25';
    case 152041173: return 'GvntMahjong18Halloween25';
    case  13159147: return 'GvntWinterfest25';
    case 169308034: return 'Bp09Winter21';
    case  23206714: return 'Bp10Love22';
    case  90571433: return 'Bp11Alpaca22';
    case 196523801: return 'Bp12Easter22';
    case 112132784: return 'Bp13Pleinair22';
    case  88959007: return 'Bp14Minipig22';
    case  54372819: return 'Bp15Tanabata22';
    case 128651658: return 'Bp16Toothy22';
    case   4999391: return 'Bp17Oracle22';
    case 188982273: return 'Bp18Musical22';
    case 131526751: return 'Bp19Deer22';
    case 175215764: return 'Bp20Thanksgiving22';
    case 215189676: return 'Bp21Ice22';
    case  26613247: return 'Bp22Chineseny23';
    case 209947419: return 'Bp23Stvalentines23';
    case 255276935: return 'Bp24Patrick23';
    case 145044705: return 'Bp25Capybara23';
    case  50217824: return 'Bp26Genie23';
    case  76763552: return 'BP27Boar23';
    case 199624045: return 'Bp28HurdyGurdy23';
    case  50598820: return 'Bp29Fireworks23';
    case  61212483: return 'BpNewbieWedding22';
    case 140397531: return 'Bp30Butterflies23';
    case  25855378: return 'Bp31Greyhound23';
    case  63764193: return 'BpWeek01';
    case 139056555: return 'BpWeek01_VFX';
    case 161275782: return 'Bp32giraffe23';
    case  65303641: return 'Bp33Viking23';
    case 113531305: return 'Bp34chess23';
    case 198199047: return 'Bp35Redpanda23';
    case 130966619: return 'Bp36Macaque23';
    case  59593306: return 'Bp37Reindeer23';
    case  75456608: return 'Bp38Flamingo24';
    case 226628686: return 'Bp00Test';
    case 234267318: return 'Bp39LunarNy24';
    case  39564849: return 'Bp40Owls24';
    case  52339324: return 'Bp41Patrick24';
    case  56077311: return 'Bp42Bees24';
    case 265655937: return 'Bp43Magic24';
    case 249181321: return 'Bp44Pony24';
    case  55700552: return 'Bp45Fathersday24';
    case  57364224: return 'Bp46Independence24';
    case 165844672: return 'Bp47Donkey24';
    case 264428320: return 'Bp48Vampire24';
    case 139230353: return 'BpNewbieVampire';
    case 114665191: return 'Bp50Dotseco24';
    case 198579354: return 'Bp49Chocolate24';
    case 118238743: return 'Bp51Halloween24';
    case  53280978: return 'Bp52Hawaii24';
    case  39680069: return 'Bp53Christmas24';
    case  90858583: return 'Bp54Yetti24';
    case  76299162: return 'Bp55Kungfu25';
    case 173684702: return 'Bp56Sheep25';
    case  26940608: return 'Bp57Snowwhite25';
    case 117883237: return 'Bp59Squirrel25';
    case 259791921: return 'Bp58Flyingfox25';
    case 175115128: return 'Bp60Mothersday25';
    case 158914056: return 'Bp61Gardendwarf25';
    case 240742592: return 'Bp62Independence25';
    case 174547822: return 'Bp63Hunting25';
    case  84470288: return 'Bp64Beavers25';
    case  46624684: return 'Bp65Horse25';
    case  99687615: return 'Bp66Fox25';
    case 227526763: return 'Bp67Peacock25';
    case 176566247: return 'Bp68Gingerbread25';
    case 266000530: return 'Bp69Thanksgiving25';
    case 149183675: return 'Bp70Christmas25';
    case  85839557: return 'Bp71Icesculpture25';
    case 120753942: return 'Bp72Valentine26';
    case  39903667: return 'Bp73Patrick26';
    case 196208503: return 'Bp75Mothersday26';
    case 193088137: return 'Bp74Easter26';
    case 220543853: return 'Bp76Circus26';
    case  63100084: return 'Bp77Fishing26';
    case 213604018: return 'Bp78Independence26';
    case  42239545: return 'Bp79Safari26';
    case 120070106: return 'Bp80Exhibition26';
    case  55560074: return 'Bp81Swan26';
    case 147288580: return 'Bp82Halloween26';
    case 112842785: return 'Bp83Thanksgiving26';
    case 176518441: return 'MesaHoroscope01Aries22';
    case  21634909: return 'MesaHoroscope02Taurus22';
    case 209561645: return 'MesaHoroscope03Gemini22';
    case 157626321: return 'MesaHoroscope04Cancer22';
    case  38173983: return 'MesaHoroscope05Leo22';
    case 132599644: return 'MesaHoroscope06Virgo22';
    case  31879542: return 'MesaHoroscope07Libra22';
    case 152454762: return 'MesaHoroscope08Scorpio22';
    case 208047763: return 'MesaHoroscope09Sagittarius22';
    case 175876748: return 'MesaHoroscope10Capricorn22';
    case 259525383: return 'MesaHoroscope11Aquarius23';
    case 119591507: return 'MesaHoroscope12Pisces23';
    case  53247580: return 'MesaStarDivinationHare';
    case 213875444: return 'MesaStarDivinationWhale';
    case 124331045: return 'MesaHoroscope01Aries26';
    case 212225617: return 'MesaHoroscope02Taurus26';
    case  26343713: return 'MesaHoroscope03Gemini26';
    case  76119773: return 'MesaHoroscope04Cancer26';
    case 262810643: return 'MesaHoroscope05Leo26';
    case 168500816: return 'MesaHoroscope06Virgo26';
    case 201990266: return 'MesaHoroscope07Libra26';
    case  83498854: return 'MesaHoroscope08Scorpio26';
    case  25878431: return 'MesaHoroscope09Sagittarius26';
    case  15527875: return 'MesaHoroscope10Capricorn26';
    case  99569224: return 'MesaHoroscope11Aquarius26';
    case 230135580: return 'MesaHoroscope12Pisces26';
    case 187405967: return 'MesaJigsawBouqet22';
    case 206602956: return 'MesaJigsawBouqet23';
    case 137490181: return 'MesaJigsawBouqet24';
    case 256572230: return 'MesaJigsawBouqet25';
    case 261708240: return 'MesaStainedGlass22';
    case 200815641: return 'MesaStainedGlass25';
    case  25003957: return 'MesaPersianRug22';
    case  85781116: return 'MesaPersianRug25';
    case 104241996: return 'MesaChristmasWreath22';
    case 187678114: return 'MesaChristmasTree25';
    case 172662049: return 'MesaCuisineItalia23';
    case 216960058: return 'MesaCuisine2Hawaii23';
    case 136718917: return 'MesaPinata24';
    case  99198674: return 'MesaPillow25';
    case  93056114: return 'MesaSerial01TrainTravel23';
    case 109077080: return 'MesaSerial01TrainTravel23VFX';
    case 131460782: return 'MesaSerial02TrainTravel23';
    case 147919469: return 'MesaSerial02TrainTravel23_VFX';
    case  29803939: return 'MesaSerial03TrainTravel23';
    case 194147594: return 'MesaSerial03TrainTravel23_VFX';
    case  42969112: return 'MesaSerial04TrainTravel23';
    case 157040916: return 'MesaSerial04TrainTravel23_VFX';
    case 219267024: return 'MesaSerial05TrainTravel23';
    case 131418813: return 'MesaSerial05TrainTravel23_VFX';
    case 113410505: return 'MesaSerial06TrainTravel23';
    case  72242758: return 'MesaSerial06TrainTravel23_VFX';
    case 157062657: return 'MesaSerial07TrainTravel23';
    case 180837871: return 'MesaSerial07TrainTravel23_VFX';
    case   5266111: return 'MesaSerial08TrainTravel23';
    case  30555770: return 'MesaSerial08TrainTravel23_VFX';
    case 265178487: return 'MesaSerial09TrainTravel23';
    case 257635795: return 'MesaSerial09TrainTravel23_VFX';
    case 258289455: return 'MesaSerial10TrainTravel23';
    case 122551222: return 'MesaSerial10TrainTravel23_VFX';
    case  16464103: return 'MesaSerial11TrainTravel23';
    case 163901471: return 'MesaSerial11TrainTravel23_VFX';
    case 187172606: return 'MesaSerial12TrainTravel23';
    case 174058724: return 'MesaSerial12TrainTravel23_VFX';
    case  79040822: return 'MesaSerial13TrainTravel23';
    case  81192781: return 'MesaSerial13TrainTravel23_VFX';
    case 134184077: return 'MesaSerial14TrainTravel23';
    case 102290259: return 'MesaSerial14TrainTravel23_VFX';
    case 140602181: return 'MesaSerial15TrainTravel23';
    case 143775994: return 'MesaSerial15TrainTravel23_VFX';
    case  62018908: return 'MesaSerial16TrainTravel23';
    case 185254913: return 'MesaSerial16TrainTravel23_VFX';
    case 204227220: return 'MesaSerial17TrainTravel23';
    case  92524456: return 'MesaSerial17TrainTravel23_VFX';
    case  86019626: return 'MesaSerial18TrainTravel23';
    case 244755517: return 'MesaSerial18TrainTravel23_VFX';
    case 180263394: return 'MesaSerial19TrainTravel23';
    case   2074516: return 'MesaSerial19TrainTravel23_VFX';
    case 193287377: return 'MesaSerial20TrainTravel23';
    case 233917246: return 'MesaSerial20TrainTravel23_VFX';
    case  68895513: return 'MesaSerial21TrainTravel23';
    case  58212503: return 'MesaSerial21TrainTravel23_VFX';
    case 264797440: return 'MesaSerial22TrainTravel23';
    case  14900332: return 'MesaSerial22TrainTravel23_VFX';
    case   5663432: return 'MesaSerial23TrainTravel23';
    case 241850309: return 'MesaSerial23TrainTravel23_VFX';
    case  52365171: return 'MesaSerial24TrainTravel23';
    case 212100059: return 'MesaSerial24TrainTravel23_VFX';
    case 209785019: return 'MesaSerial25TrainTravel23';
    case  36530290: return 'MesaSerial25TrainTravel23_VFX';
    case 267475378: return 'MesaSerial26';
    case 200255903: return 'MesaSerial26VFX';
    case 197788181: return 'MesaSerial27';
    case 185480103: return 'MesaSerial27VFX';
    case   5394906: return 'MesaSerial28';
    case 250689288: return 'MesaSerial28VFX';
    case 152142544: return 'MesaAdvent01Christmas23';
    case 257387640: return 'MesaAdvent02Carnival24';
    case 124759456: return 'MesaAdvent03Mgbday24';
    case  69028528: return 'MesaAdvent04Autumn24';
    case 237746003: return 'Mesa01Dig24';
    case  99706478: return 'Mesa02Dig24';
  }
  return `Unknown EnumPlayerAvatar code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumPlayerAvatarFrameName(code) {
  switch(code) {
    case 0: return 'Default';
    case 1: return 'Gold';
  }
  return `Unknown EnumPlayerAvatarFrame code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumSocietyName(code) {
  switch(code) {
    case 0: return 'SocietyVk';
    case 1: return 'SocietyOk';
    case 2: return 'SocietyFb';
    case 3: return 'SocietyTw';
    case 4: return 'SocietyYt';
    case 5: return 'SocietyIn';
  }
  return `Unknown EnumSociety code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumDailyRewardStateName(code) {
  switch(code) {
    case 0: return 'LOCKED';
    case 1: return 'UNLOCKED';
    case 2: return 'CLAIMED';
    case 3: return 'SKIPED';
  }
  return `Unknown EnumDailyRewardState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumDailyRewardTypeName(code) {
  switch(code) {
    case 0: return 'ENTER';
    case 1: return 'GOLDEN_TREE';
    case 2: return 'MONTHLY';
  }
  return `Unknown EnumDailyRewardType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumSpecialOfferGroupName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'StarterPack';
    case  2: return 'GoldenBox';
    case  3: return 'SpecialOfferForYou';
    case  4: return 'DolphinCheckUp';
    case  5: return 'ThreeSteps';
    case  6: return 'DecreasingBonus';
    case  7: return 'GiftsForPay';
    case  8: return 'SuperWhale';
    case  9: return 'Sofa';
    case 10: return 'GoldenTree';
    case 11: return 'GvntXMultiply';
    case 12: return 'Starfall';
    case 13: return 'BlackFriday';
    case 14: return 'SlaggerBirthdayXMultiply';
    case 15: return 'ChristmasXMultiply';
    case 16: return 'ChineseNY21XMultiply';
    case 17: return 'GoldenTicket';
    case 18: return 'BattlePassXMultiply';
    case 19: return 'BattlePassXMultiplyAnnounce';
    case 20: return 'GvntMergeFieldXMultiply';
    case 21: return 'DressSale';
    case 22: return 'GoldXMultiply';
    case 23: return 'Fashion21';
    case 24: return 'FakeBankUIMonitoringOnly';
    case 25: return 'Bday21';
    case 26: return 'GvntProlong';
    case 27: return 'Treasury';
    case 28: return 'DarkCastle21';
    case 29: return 'BlackFriday21';
    case 30: return 'Christmas21';
    case 31: return 'Winterwalk21';
    case 32: return 'ChineseNY22';
    case 33: return 'SweetFest22';
    case 34: return 'ProtractedFail';
    case 35: return 'SpringWalk22';
    case 36: return 'SunParty22';
    case 37: return 'GiftForPayment';
    case 38: return 'HillsGreenhouse22';
    case 39: return 'MahjongBoatClub22';
    case 40: return 'PoetryEvening22';
    case 41: return 'Cheese21';
    case 42: return 'SewingShop22';
    case 43: return 'Mahjong02Halloween22';
    case 44: return 'Egypt22';
    case 45: return 'BlackFridayWithDressGift';
    case 46: return 'Christmas22';
    case 47: return 'Mahjong03Winter23';
    case 48: return 'NewbieEvent23';
    case 49: return 'SweetShop23';
    case 50: return 'Easter23';
    case 51: return 'Mahjong04FairyBall23';
    case 52: return 'CelticTales23';
    case 53: return 'Fortuneteller23';
    case 54: return 'Marine23';
    case 55: return 'Mahjong05Expedition23';
    case 56: return 'Baroque23';
    case 57: return 'Halloween23';
    case 58: return 'Mahjong06thanksgiving23';
    case 59: return 'BlackFriday23';
    case 60: return 'Christmas23';
    case 61: return 'Mahjong07Fairytales24';
    case 62: return 'Valentine24';
    case 63: return 'Mahjong08Ladiesday24';
    case 64: return 'Ladiesday124';
    case 65: return 'Ladiesday324';
    case 66: return 'AdventBuyCurrency';
    case 67: return 'Easter24';
    case 68: return 'Mahjong09Oriental124';
    case 69: return 'OrientalMammy224';
    case 70: return 'Mahjong10Oriental324';
    case 71: return 'Pirate24';
    case 72: return 'Fairytale24';
    case 73: return 'Mahjong11Tennis24';
    case 74: return 'Olympic24';
    case 75: return 'Mahjong12School24';
    case 76: return 'Mermaid24';
    case 77: return 'Mahjong13Halloween24';
    case 78: return 'Dotseco24';
    case 79: return 'Thanksgiving24';
    case 80: return 'Mahjong14Christmas24';
    case 81: return 'PlanetParade24';
    case 82: return 'Chineseny25';
    case 83: return 'Mahjong15Valentine25';
    case 84: return 'Patrick25';
    case 85: return 'Easter25';
    case 86: return 'Mahjong16Spring25';
    case 87: return 'SlagerBirthday25';
    case 88: return 'Mahjong17Carnival25';
    case 89: return 'HarvestFest25';
    case 90: return 'Tropics25';
    case 91: return 'Japan25';
    case 92: return 'Mahjong18Halloween25';
    case 93: return 'Mahjong19Christmas25';
    case 94: return 'Winterfest25';
    case 95: return 'Summer26';
    case 96: return 'Cheese26';
  }
  return `Unknown EnumSpecialOfferGroup code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumSpecialOfferStateName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Running';
    case 2: return 'FinishedPurchased';
    case 3: return 'FinishedIgnored';
    case 4: return 'Incoming';
  }
  return `Unknown EnumSpecialOfferState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumABTestClientStatusName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'Active';
    case  2: return 'GroupForced';
    case  3: return 'RegStampTooOld';
    case  4: return 'NoGroups';
    case  5: return 'NoStartStamp';
    case  6: return 'NoEndStamp';
    case  7: return 'StartNotReached';
    case  8: return 'EndReached';
    case  9: return 'RegStampTooNew';
    case 10: return 'RegStampMissing';
    case 11: return 'RegVersionTooOld';
    case 12: return 'RegVersionTooNew';
    case 13: return 'Expelled';
    case 14: return 'StartConditionNotMet';
  }
  return `Unknown EnumABTestClientStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumQAUserRoleName(code) {
  switch(code) {
    case 0: return 'Unknown';
    case 1: return 'RegularUser';
    case 2: return 'QATester';
  }
  return `Unknown EnumQAUserRole code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumQAUserIdentityName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'PlayerId';
    case 2: return 'FacebookId';
    case 3: return 'AdsId';
  }
  return `Unknown EnumQAUserIdentity code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumLimitName(code) {
  switch(code) {
    case    0: return 'none';
    case    7: return 'club_force_change_available';
    case    8: return 'club_force_change_check_tmnt';
    case    9: return 'club_send_invite';
    case   10: return 'club_ask_help';
    case   11: return 'club_respond_help_msg';
    case   12: return 'club_ui_opened_first_time';
    case   13: return 'club_first_time_join';
    case   14: return 'club_join_ui_opened_first_time';
    case   15: return 'club_complain_at_user';
    case   16: return 'club_complains_per_day';
    case   17: return 'club_priv_club_join_request';
    case   18: return 'club_priv_joins_reqs_per_day';
    case   19: return 'club_send_friend_gift';
    case   20: return 'ads_video_daily_total';
    case   21: return 'ads_video_daily_total_victory';
    case   22: return 'ads_video_daily_total_clubs';
    case   30: return 'ads_video_placement_cooldown';
    case   31: return 'ads_video_chest_cooldown';
    case   32: return 'ads_video_chest_total';
    case   33: return 'ads_video_loose_cooldown';
    case   34: return 'ads_video_loose_lvl_use';
    case   35: return 'ads_video_loose_lvl_pacing';
    case   36: return 'ads_video_surprise_box_cooldown';
    case   37: return 'ads_video_surprise_box_progress';
    case   38: return 'ads_video_surprise_box_progress1';
    case   39: return 'ads_video_m3_start_free_booster_cooldown_ABCG';
    case   85: return 'ads_video_m3_start_free_booster_cooldown_AB1';
    case   86: return 'ads_video_m3_start_free_booster_cooldown_AB2';
    case   80: return 'ads_video_m3_start_free_booster_progress';
    case   81: return 'ads_video_surprise_box_progress2';
    case   82: return 'ads_video_m3_start_free_booster_m3lives_use';
    case   83: return 'ads_video_chest_ad_watched';
    case   84: return 'ads_video_chest_reminder_cooldown';
    case   40: return 'notifications_local_daily';
    case   50: return 'spec_offer_3_steps_good1';
    case   51: return 'spec_offer_3_steps_good2';
    case   52: return 'spec_offer_3_steps_good3';
    case   53: return 'spec_offer_protracted_fail';
    case   54: return 'spec_offer_protracted_fail_glob';
    case   60: return 'tmnt_level_attempt';
    case   61: return 'tmnt_welcomed';
    case   62: return 'tmnt_congratulated';
    case   63: return 'tmnt_league_congratulated';
    case   64: return 'tmnt_golden_rewarded';
    case   65: return 'tmnt_participation_rewarded';
    case   66: return 'tmnt_results_viewed';
    case   67: return 'tmnt_participated';
    case   68: return 'tmnt_seq_first_time';
    case   69: return 'tmnt_reminder_pause';
    case  200: return 'tmnt_remind';
    case  201: return 'tmnt_pressed_play_from_chat';
    case  202: return 'tmnt_gvnt_welcomed';
    case  203: return 'tmnt_golden_medals_last_seen_count';
    case  204: return 'tmnt_participation_seen';
    case  205: return 'tmnt_milestone_seen_mask';
    case  206: return 'tmnt_milestone_congrats_seen_mask';
    case  207: return 'tmnt_last_seen_place_icon';
    case  208: return 'tmnt_last_seen_place_top_clubs';
    case  209: return 'tmnt_last_seen_place_top_me';
    case  210: return 'tmnt_incoming_annotation';
    case  211: return 'tmnt_welcom_only_for_newbie';
    case  212: return 'rush_level_attempt';
    case  213: return 'rush_welcomed';
    case  214: return 'rush_welcom_only_for_newbie';
    case  215: return 'rush_first_start';
    case  216: return 'rush_first_race';
    case  217: return 'tmnt_bakery_marathon_win_streak';
    case  218: return 'tmnt_bakery_marathon_level_started_and_not_finished';
    case  219: return 'tmnt_bakery_marathon_last_best_score';
    case   70: return 'reminder_session';
    case   71: return 'reminder_pause';
    case   72: return 'game_rate_reminder_progress1';
    case   73: return 'game_rate_reminder_cooldown1';
    case   74: return 'game_rate_reminder_cooldown2';
    case   75: return 'game_rated';
    case   92: return 'game_rate_reminder_progress1_v2';
    case   93: return 'game_rate_reminder_cooldown1_v2';
    case   94: return 'game_rate_reminder_cooldown2_v2';
    case   95: return 'game_rated_v2';
    case   76: return 'reminder_long_pause';
    case   77: return 'gvnt_shop_reminder_pause';
    case   78: return 'gvnt_shop_reminder_long_pause';
    case   79: return 'ruble_payments_remind';
    case   90: return 'facebook_login_reward_claimed';
    case   91: return 'facebook_login_ui_opened_first_time';
    case  100: return 'gvnt_welcomed';
    case  101: return 'gvnt_ad_boost_pot_cooldown';
    case  102: return 'gvnt_rewarded';
    case  103: return 'gvnt_ad_boost_pot_first_time';
    case  104: return 'gvnt_tutored';
    case  105: return 'gvnt_additional_tutored';
    case  106: return 'gvnt_m3_win_streaks';
    case  107: return 'gvnt_special_shop_tutored';
    case  108: return 'gvnt_announcement_video_seen';
    case  300: return 'battle_pass_welcomed';
    case  301: return 'battle_pass_migration';
    case  302: return 'battle_pass_club_gift_msg_showed';
    case  303: return 'battle_pass_vip_ad_cooldown';
    case  304: return 'battle_pass_send_super_box_stats';
    case  305: return 'battle_pass_vip_unlock_animation';
    case  306: return 'battle_pass_golden_ticket_ad';
    case  308: return 'battle_pass_onboarding_reported';
    case  309: return 'battle_pass_tutorial_without_quests';
    case  310: return 'battle_pass_tutorial_with_quests';
    case  311: return 'battle_pass_tutorial_golden_tiket_remind';
    case  312: return 'battle_pass_newbie_preview_remind';
    case  315: return 'river_rumble_intro';
    case  330: return 'regatta_stage_reward_presented';
    case  400: return 'special_offer_day_pause';
    case  410: return 'special_offer_treasury_reward_counter';
    case  411: return 'special_offer_black_friday_counter';
    case  412: return 'special_offer_advent_start_spec_id';
    case  413: return 'special_offer_advent_finish_spec_id';
    case  414: return 'mesa_open_ui_counter';
    case  500: return 'booster_offer_pause';
    case  110: return 'feedback_survey_capping';
    case  111: return 'feedback_survey_pacing';
    case  112: return 'feedback_survey_complete';
    case  120: return 'mesa_hud_icon_remind';
    case  121: return 'random_seed_for_group';
    case  122: return 'random_seed_for_asset';
    case  123: return 'merge_field_bin_progress';
    case  124: return 'mrgs_showcase_content';
    case  125: return 'sessions_counter';
    case  126: return 'mahjong_field_bin_progress';
    case  130: return 'collection_welcomed';
    case 9000: return 'stats_single_event';
    case  150: return 'win_streak_welcomed';
    case  151: return 'samsung_install_rewards_granted';
    case  152: return 'cats_minigame_finished';
    case  153: return 'daily_quest_start_window_quest_id';
    case  154: return 'fbs_analytics_event_sent';
    case  155: return 'af_analytics_event_sent';
    case  600: return 'offer_surprise_box_progress';
    case  601: return 'ads_video_daily_total_victory_ab_test';
    case  602: return 'ads_video_daily_total_loose_ab_test';
    case  603: return 'ads_video_daily_total_chest_ab_test';
    case  604: return 'ads_video_chest_cooldown_ab_test';
    case  605: return 'ads_video_victory_lose_cooldown_ab_test';
    case  606: return 'ads_video_chest_total_ab_test';
    case  700: return 'derby_welcomed';
    case  701: return 'derby_shown';
    case 1200: return 'remote_offer';
    case 1201: return 'remote_offer_sync';
    case 1202: return 'remote_offer_load_dlc';
    case 1203: return 'remote_offer_uid';
    case 1204: return 'm3_testing_system_lvl_change';
    case 1205: return 'festival_square_has_been_set_to_default';
    case 1206: return 'hud_right_icons_limit_reached';
    case 1300: return 'special_offer_for_you_first_start';
    case  800: return 'mesa_serial_finishes_count';
  }
  return `Unknown EnumLimit code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAnalyticsUserMetricName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'LTV';
    case 2: return 'DaySincePayment';
    case 3: return 'M3LevelsComplete';
    case 4: return 'M3FailedAttempts';
    case 5: return 'PaymentsCount';
    case 6: return 'M3LevelsComplete_Resources';
  }
  return `Unknown EnumAnalyticsUserMetric code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAnalyticsPlayerCohortName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'NewbieNonPayer';
    case 2: return 'OldNonPayer';
    case 3: return 'VeryOldNonPayer';
    case 4: return 'RecentPayer';
    case 5: return 'LongAgoPayer';
    case 6: return 'VeryLongAgoPayer';
  }
  return `Unknown EnumAnalyticsPlayerCohort code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAdPlacementName(code) {
  switch(code) {
    case   0: return 'None';
    case   1: return 'VictoryScreen';
    case   2: return 'ClubsLivesInbox';
    case   3: return 'AdChest';
    case   4: return 'LostScreen';
    case   5: return 'DoubleLevelReward';
    case   6: return 'AdSurpriseBox';
    case   7: return 'M3StartFreeBooster';
    case   8: return 'GvntFlowerFestBoostPot';
    case 101: return 'OfferwallBankScreen';
    case 102: return 'OfferwallBankScreenTapjoy';
  }
  return `Unknown EnumAdPlacement code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAdPlacementStatusName(code) {
  switch(code) {
    case   0: return 'OK';
    case   1: return 'CooldownPacing';
    case   2: return 'CooldownCapping';
    case 101: return 'LockedByCondition';
    case 201: return 'SysBusy';
    case 202: return 'SysBadPlacement';
    case 203: return 'SysSDKError';
    case 204: return 'SysSDKNoFill';
    case 205: return 'SysSDKCancelled';
  }
  return `Unknown EnumAdPlacementStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAdOfferwallRewardStatusName(code) {
  switch(code) {
    case   0: return 'OK';
    case   1: return 'NoneAvailable';
    case 201: return 'SysSDKError';
  }
  return `Unknown EnumAdOfferwallRewardStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTechSupportPlacementName(code) {
  switch(code) {
    case 0: return 'Generic';
    case 1: return 'TitleScreen';
    case 2: return 'SettingsScreen';
    case 3: return 'FatalErrorDialog';
    case 4: return 'SaveErrorDialog';
    case 5: return 'AdsErrorDialog';
    case 6: return 'OfferwallErrorDialog';
    case 7: return 'AppleSignInErrorDialog';
  }
  return `Unknown EnumTechSupportPlacement code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumNotificationChannelName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'GenericUpdates';
    case 2: return 'Lives';
    case 3: return 'SpecialOffers';
    case 4: return 'Clubs';
    case 5: return 'CelebrationEvents';
  }
  return `Unknown EnumNotificationChannel code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumLocalNotificationName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'LivesRestored';
    case  2: return 'CouchPotato';
    case  3: return 'DailyRewards';
    case  4: return 'EndlessLivesEnd';
    case  5: return 'ShortFirstSession';
    case  6: return 'UnderTheWeekend';
    case  7: return 'OneWeekAbsenceReward';
    case  8: return 'TwoWeeksAbsenceReward';
    case  9: return 'SpecialOfferEnds';
    case 10: return 'TmntIndividualFinished';
    case 11: return 'TmntIndividualContinues';
    case 12: return 'TmntClubContinuesSecondDay';
    case 13: return 'TmntClubContinuesLastDay';
    case 14: return 'MesaJigsawRegular';
    case 15: return 'MesaJigsawLastChance';
    case 16: return 'BattlePassUnlockReward';
    case 17: return 'WinStreakBeeWithActiveBonus';
    case 18: return 'WinStreakBeeWithoutActiveBonus';
    case 19: return 'TmntIndividualFirstInterimRewardMedalsLeft';
    case 20: return 'TmntIndividualSecondInterimRewardMedalsLeft';
    case 21: return 'TmntIndividualThirdInterimRewardMedalsLeft';
    case 22: return 'MesaFosterKidPassedLessThenTwoThird';
    case 23: return 'MesaFosterKidPassedMoreThenTwoThird';
    case 24: return 'MesaNestlingPassedLessThenTwoThird';
    case 25: return 'MesaNestlingPassedMoreThenTwoThird';
    case 26: return 'QuestNotFinished_01_part_01_01_0021_change_dress';
    case 27: return 'QuestNotFinished_01_part_01_01_0050_dress_for_tea';
    case 28: return 'QuestNotFinished_01_part_01_01_0060_clean_table';
    case 29: return 'QuestNotFinished_01_part_01_02_0090_meet_papaman';
    case 30: return 'QuestNotFinished_01_part_01_02_0112_give_papers';
    case 31: return 'QuestNotFinished_01_part_01_02_0140_read_letter';
    case 32: return 'QuestNotFinished_01_part_01_03_0150_meet_slagger';
    case 33: return 'QuestNotFinished_01_part_01_03_0170_put_bisquits';
    case 34: return 'QuestNotFinished_01_part_01_03_0180_clean_fireplace';
    case 35: return 'WinStreakSheep4HoursBeforeEnd';
    case 36: return 'WinStreakSheepAfter2Hours';
    case 37: return 'WinStreakSheepAfter30Minutes';
    case 38: return 'QuestNotFinished_beginning_2_0_intro_intro_000_fake_dress_up';
    case 39: return 'QuestNotFinished_beginning_2_0_intro_intro_010_bring_books';
    case 40: return 'QuestNotFinished_beginning_2_0_intro_intro_020_enter_mansion';
    case 41: return 'QuestNotFinished_beginning_2_0_part_01_01_01_01_000_new_chapter';
    case 42: return 'QuestNotFinished_beginning_2_0_part_01_01_01_01_030_take_papers';
    case 43: return 'QuestNotFinished_beginning_2_0_part_01_01_01_01_070_add_flowers';
    case 44: return 'QuestNotFinished_beginning_2_0_part_01_01_01_01_080_try_on_dress';
    case 45: return 'QuestNotFinished_beginning_2_0_part_01_01_01_01_090_add_chairs';
    case 46: return 'QuestNotFinished_beginning_2_0_part_01_01_01_01_110_read_letter';
    case 47: return 'QuestNotFinished_beginning_2_0_part_01_01_01_01_120_change_dress';
    case 48: return 'QuestNotFinished_beginning_2_0_part_01_02_01_02_000_new_chapter';
    case 49: return 'QuestNotFinished_beginning_2_0_part_01_02_01_02_020_set_table';
    case 50: return 'QuestNotFinished_beginning_2_0_part_01_02_01_02_040_change_vase';
    case 51: return 'QuestNotFinished_beginning_2_0_part_01_02_01_02_070_put_table';
    case 52: return 'QuestNotFinished_beginning_2_0_part_01_02_01_02_100_repair_clock';
    case 53: return 'QuestNotFinished_beginning_2_0_part_01_02_01_02_140_put_muse';
    case 54: return 'QuestNotFinished_01_part_01_05_0350_meet_ferret';
    case 55: return 'MesaSerialPassedLessThenTwoThird';
    case 56: return 'MesaSerialPassedMoreThenTwoThird';
    case 57: return 'NotificationSchedulerRiverRumbleStart';
    case 58: return 'NotificationSchedulerRiverRumbleBeforeFinish';
    case 59: return 'NotificationSchedulerRiverRumbleAfterDefeat';
    case 60: return 'RoyalRegattaSecondRoundStart';
    case 61: return 'RoyalRegattaFinalRoundStart';
    case 62: return 'TmntRainbowRushFinished';
    case 63: return 'MesaDigPassedMoreThenOneThirdAndNotTutored';
    case 64: return 'MesaDigPassedBetweenOneQuarterAndOneThirdAndTutored';
    case 65: return 'MesaDigPassedMoreThenOneThirdAndTutored';
  }
  return `Unknown EnumLocalNotification code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumExtFilesTrackName(code) {
  switch(code) {
    case 0: return 'ext_files';
    case 1: return 'on_demand_files';
  }
  return `Unknown EnumExtFilesTrack code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAssetBundleCompressionName(code) {
  switch(code) {
    case 0: return 'Undefined';
    case 1: return 'LZMAWhole';
    case 2: return 'LZ4ChunkBased';
    case 3: return 'Uncompressed';
  }
  return `Unknown EnumAssetBundleCompression code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTechSupportOperatorName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'AIHelp';
    case 2: return 'MyCom';
  }
  return `Unknown EnumTechSupportOperator code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumFileDownloadMethodName(code) {
  switch(code) {
    case 0: return 'BestHTTP';
    case 1: return 'UnityWebRequest';
  }
  return `Unknown EnumFileDownloadMethod code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumInsiderUserRoleName(code) {
  switch(code) {
    case 1: return 'admin';
    case 2: return 'moderator';
    case 3: return 'reader';
  }
  return `Unknown EnumInsiderUserRole code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumInsiderUserActionTypeName(code) {
  switch(code) {
    case  1: return 'add_pending';
    case  2: return 'ban_player';
    case  3: return 'unban_player';
    case  4: return 'enforce_state';
    case  5: return 'del_player_data';
    case  6: return 'block_chat';
    case  7: return 'reject_complaint';
    case  8: return 'reject_complaints';
    case  9: return 'create_resource_log_copy';
    case 10: return 'edit_player_state';
    case 11: return 'successful_login';
    case 12: return 'set_inventory_item_amount';
    case 13: return 'unblock_chat';
    case 14: return 'create_gvnt';
    case 15: return 'force_start_gvnt';
    case 16: return 'finalize_gvnt';
    case 17: return 'del_gvnt';
    case 18: return 'set_level';
    case 19: return 'create_win_streak';
    case 20: return 'view_contests';
    case 21: return 'create_push';
    case 22: return 'del_push';
    case 23: return 'edit_push';
    case 24: return 'create_contest';
  }
  return `Unknown EnumInsiderUserActionType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRainbowActivationTypeName(code) {
  switch(code) {
    case 1: return 'SimpleRainbowDestruction';
    case 2: return 'ComboTwoRainbow';
    case 3: return 'ConvertingUnusedMoveIntoBomb';
  }
  return `Unknown EnumRainbowActivationType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTmntTypeName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Individual';
    case 2: return 'Champs';
    case 3: return 'Clubs';
    case 4: return 'Chest';
    case 5: return 'Bugz';
    case 6: return 'Gvnt';
    case 7: return 'RainbowRush';
    case 8: return 'BakeryMarathon';
  }
  return `Unknown EnumTmntType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTmntMedalName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Golden';
    case 2: return 'Silver';
    case 3: return 'Bronze';
    case 4: return 'Wooden';
  }
  return `Unknown EnumTmntMedal code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTmntStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Active';
    case 2: return 'Finished';
    case 3: return 'Incoming';
    case 4: return 'Closed';
  }
  return `Unknown EnumTmntStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTmntIndividualLeagueName(code) {
  switch(code) {
    case 0: return 'Lady';
    case 1: return 'Fancy';
    case 2: return 'Noble';
    case 3: return 'King';
    case 4: return 'Great';
    case 5: return 'National';
    case 6: return 'Worldwide';
  }
  return `Unknown EnumTmntIndividualLeague code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRushStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Active';
    case 2: return 'Finished';
    case 3: return 'Incoming';
    case 4: return 'Closed';
  }
  return `Unknown EnumRushStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumWinStreakStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Active';
    case 2: return 'Incoming';
    case 3: return 'Closed';
  }
  return `Unknown EnumWinStreakStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumWinStreakTypeName(code) {
  switch(code) {
    case 179432759: return 'Test';
    case 218578173: return 'Bee';
    case  69217790: return 'Bee_autoplay';
    case 209619100: return 'Bee_infinite';
    case 102032800: return 'BeeInSheepsClothing';
    case 231119380: return 'BeeInSheepsClothing_autoplay';
    case  20352860: return 'BeeInSheepsClothing_infinite';
    case 138246943: return 'Sheep';
    case 211473605: return 'Sheep_test';
  }
  return `Unknown EnumWinStreakType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumWinStreakPublicTypeName(code) {
  switch(code) {
    case 218578173: return 'Bee';
    case 138246943: return 'Sheep';
    case 102032800: return 'BeeInSheepsClothing';
  }
  return `Unknown EnumWinStreakPublicType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumWinStreakPersonalTypeName(code) {
  switch(code) {
    case  69217790: return 'Bee_autoplay';
    case 209619100: return 'Bee_infinite';
    case 231119380: return 'BeeInSheepsClothing_autoplay';
    case  20352860: return 'BeeInSheepsClothing_infinite';
  }
  return `Unknown EnumWinStreakPersonalType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumM3LevelSequenceIteratorName(code) {
  switch(code) {
    case 0: return 'Default';
    case 1: return 'TmntChamps';
  }
  return `Unknown EnumM3LevelSequenceIterator code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumUserAcquisitionCohortName(code) {
  switch(code) {
    case   0: return 'UnknownPending';
    case   1: return 'UnknownMissing';
    case   2: return 'Organic';
    case   3: return 'Installs_paid';
    case   4: return 'Purchase_paid';
    case   5: return 'Value_paid';
    case   6: return 'Retention_paid';
    case 101: return 'Other_paid';
  }
  return `Unknown EnumUserAcquisitionCohort code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumUserAcquisitionKindName(code) {
  switch(code) {
    case 0: return 'Unknown';
    case 1: return 'Organic';
    case 2: return 'Paid';
  }
  return `Unknown EnumUserAcquisitionKind code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumUserAcquisitionServerStateName(code) {
  switch(code) {
    case 0: return 'OK';
    case 1: return 'NotFound';
    case 2: return 'InternalLookupError';
  }
  return `Unknown EnumUserAcquisitionServerState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGvntTypeName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'FlowerFest';
    case  2: return 'Halloween';
    case  3: return 'SlaggersBirthday';
    case  4: return 'Christmas';
    case  5: return 'ChineseNY21';
    case  6: return 'Easter21';
    case  7: return 'Spring21';
    case  8: return 'Cheese21';
    case  9: return 'Fashion21';
    case 10: return 'Pirate21';
    case 11: return 'Bday21';
    case 12: return 'Carnival21';
    case 13: return 'DarkCastle21';
    case 14: return 'Christmas21';
    case 15: return 'Winterwalk21';
    case 16: return 'ChineseNY22';
    case 17: return 'SweetFest22';
    case 18: return 'SpringWalk22';
    case 19: return 'SunParty22';
    case 20: return 'HillsGreenhouse22';
    case 21: return 'MahjongBoatClub22';
    case 22: return 'PoetryEvening22';
    case 23: return 'SewingShop22';
    case 24: return 'Mahjong02Halloween22';
    case 25: return 'Egypt22';
    case 26: return 'Christmas22';
    case 27: return 'Mahjong03Winter23';
    case 28: return 'NewbieEvent23';
    case 29: return 'SweetShop23';
    case 30: return 'Easter23';
    case 31: return 'Mahjong04FairyBall23';
    case 32: return 'CelticTales23';
    case 33: return 'Fortuneteller23';
    case 34: return 'Marine23';
    case 35: return 'Mahjong05Expedition23';
    case 36: return 'Baroque23';
    case 37: return 'Halloween23';
    case 38: return 'Mahjong06thanksgiving23';
    case 39: return 'Christmas23';
    case 40: return 'Mahjong07Fairytales24';
    case 41: return 'Valentine24';
    case 42: return 'Mahjong08Ladiesday24';
    case 43: return 'Ladiesday124';
    case 44: return 'Ladiesday324';
    case 45: return 'Easter24';
    case 46: return 'Mahjong09Oriental124';
    case 47: return 'OrientalMammy224';
    case 48: return 'Mahjong10Oriental324';
    case 49: return 'Pirate24';
    case 50: return 'Fairytale24';
    case 51: return 'Mahjong11Tennis24';
    case 52: return 'Olympic24';
    case 53: return 'Mahjong12School24';
    case 54: return 'Mermaid24';
    case 55: return 'Mahjong13Halloween24';
    case 56: return 'Thanksgiving24';
    case 57: return 'Mahjong14Christmas24';
    case 58: return 'PlanetParade24';
    case 59: return 'Chineseny25';
    case 60: return 'Mahjong15Valentine25';
    case 61: return 'Patrick25';
    case 62: return 'Easter25';
    case 63: return 'Mahjong16Spring25';
    case 64: return 'SlagerBirthday25';
    case 65: return 'Mahjong17Carnival25';
    case 66: return 'HarvestFest25';
    case 67: return 'Tropics25';
    case 68: return 'Japan25';
    case 69: return 'Mahjong18Halloween25';
    case 70: return 'Mahjong19Christmas25';
    case 71: return 'Winterfest25';
    case 72: return 'Cheese26';
  }
  return `Unknown EnumGvntType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGvntStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Incoming';
    case 2: return 'Active';
    case 3: return 'Finished';
    case 4: return 'Closed';
  }
  return `Unknown EnumGvntStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGvntPotStatusName(code) {
  switch(code) {
    case 1: return 'Empty';
    case 2: return 'Planted';
    case 3: return 'Bud';
    case 4: return 'Flower';
  }
  return `Unknown EnumGvntPotStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGvntFlowerName(code) {
  switch(code) {
    case 1: return 'Orange';
    case 2: return 'Blue';
    case 3: return 'Pink';
    case 4: return 'Violet';
  }
  return `Unknown EnumGvntFlower code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMachineTagName(code) {
  switch(code) {
    case 1: return 'FlowerFest';
    case 2: return 'Halloween';
  }
  return `Unknown EnumMachineTag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumFestiveDecorSlotName(code) {
  switch(code) {
    case   0: return 'None';
    case   1: return 'BallroomWall01';
    case   2: return 'BallroomWall02';
    case   3: return 'BallroomWall03';
    case   4: return 'BallroomWall04';
    case   5: return 'BallroomWall05';
    case   6: return 'BallroomWall06';
    case   8: return 'BallroomWall07';
    case   9: return 'BallroomCenter';
    case  10: return 'BallroomTableWithChairs';
    case  12: return 'BallroomChandelier';
    case  13: return 'BallroomFloor';
    case  14: return 'BallroomCouch01';
    case  15: return 'BallroomCouch02';
    case  16: return 'BallroomCouch03';
    case  22: return 'BallroomCouch04';
    case  18: return 'BallroomNextToWindowLeft';
    case  19: return 'BallroomNextToLeftWall01';
    case  17: return 'BallroomNextToLeftWall02';
    case  20: return 'BallroomNextToLeftWall03';
    case  21: return 'BallroomNextToLeftWall04';
    case  11: return 'BallroomNextToLeftWall05';
    case  23: return 'BallroomTablewareRight';
    case  24: return 'BallroomTablewareLeft';
    case  25: return 'BallroomNextToRightWall01';
    case   7: return 'BallroomDecorMisc01';
    case  26: return 'BallroomDecorMisc02';
    case 101: return 'GardenGeoSocietyMarker';
    case 102: return 'GardenGate';
    case 103: return 'ChristmasWreath24';
  }
  return `Unknown EnumFestiveDecorSlot code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGeoSocietyHideableObjectName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Chandelier';
  }
  return `Unknown EnumGeoSocietyHideableObject code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBattlePassDecorSlotName(code) {
  switch(code) {
    case 0: return 'BACK';
  }
  return `Unknown EnumBattlePassDecorSlot code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumCameraBoundsStageName(code) {
  switch(code) {
    case 0: return 'Intro';
    case 1: return 'Default';
  }
  return `Unknown EnumCameraBoundsStage code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumFeedbackSurveyArgName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'PlayerID';
    case 2: return 'GvntRewardsCollected';
    case 3: return 'BattlePassRewardsCollected';
  }
  return `Unknown EnumFeedbackSurveyArg code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumFeedbackSurveyStatusName(code) {
  switch(code) {
    case 0: return 'NeverChecked';
    case 1: return 'Complete';
    case 2: return 'ConditionNotMet';
    case 3: return 'LimitReachedCapping';
    case 4: return 'LimitReachedPacing';
    case 5: return 'InProgress';
    case 6: return 'Disabled';
  }
  return `Unknown EnumFeedbackSurveyStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTutorialTagName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'ChangeDress';
    case  2: return 'ChangeDecor';
    case  3: return 'RequireCollectedDresses';
    case  4: return 'RequireOnlyStoryDresses';
    case  5: return 'ChangeDressMammy';
    case  6: return 'RequireBattlePassDecors';
    case  7: return 'ChangeDressJames';
    case  8: return 'M3BoosterHammer';
    case  9: return 'M3BoosterGlove';
    case 10: return 'M3BoosterSledgehammer';
    case 11: return 'ChangeDressSlagger';
    case 12: return 'ChangeDressJoe';
    case 13: return 'ChangeDressPapaman';
    case 14: return 'ChangeDressHill';
    case 15: return 'ChangeDressFerret';
    case 16: return 'ChangeDressLinwood';
  }
  return `Unknown EnumTutorialTag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMesaStateName(code) {
  switch(code) {
    case 0: return 'Inactive';
    case 1: return 'Active';
    case 2: return 'FinishedComplete';
    case 3: return 'FinishedIgnored';
  }
  return `Unknown EnumMesaState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMesaStatusName(code) {
  switch(code) {
    case 0: return 'Inactive';
    case 1: return 'Active';
    case 2: return 'Closed';
  }
  return `Unknown EnumMesaStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMesaTypeName(code) {
  switch(code) {
    case 197417682: return 'FosterKid';
    case  84269712: return 'Nestling21';
    case 114889750: return 'Jigsaw';
    case 153407683: return 'Sculpture';
    case 242105588: return 'Cake21';
    case 125239771: return 'StPatrick21';
    case 108565663: return 'Fireworks22';
    case  90369301: return 'Fireworks24';
    case 204274525: return 'Bouquet22';
    case 190312222: return 'Bouquet23';
    case 255230679: return 'Bouquet24';
    case 139302548: return 'Bouquet25';
    case 202082084: return 'StainedGlass22';
    case 141224685: return 'StainedGlass25';
    case  13081626: return 'PersianRug22';
    case  64873872: return 'PersianRug24';
    case  78049747: return 'PersianRug25';
    case  63603464: return 'ChristmasWreath22';
    case 193541734: return 'ChristmasTree25';
    case 183244517: return 'CuisineItalia23';
    case  12004376: return 'Cuisine2Hawaii23';
    case  99295120: return 'Pinata24';
    case  13695618: return 'ChristmasWreath24';
    case 136614663: return 'Pillow25';
    case  53694049: return 'Horoscope01Aries22';
    case 161767620: return 'Horoscope02Taurus22';
    case  76797876: return 'Horoscope03Gemini22';
    case  25907272: return 'Horoscope04Cancer22';
    case 209362749: return 'Horoscope05Leo22';
    case 240219156: return 'Horoscope06Virgo22';
    case 139479614: return 'Horoscope07Libra22';
    case  12420085: return 'Horoscope08Scorpio22';
    case 129398124: return 'Horoscope09Sagittarius22';
    case 128746445: return 'Horoscope10Capricorn22';
    case 255929879: return 'Horoscope11Aquarius23';
    case 265203146: return 'Horoscope12Pisces23';
    case 249503597: return 'Horoscope01Aries26';
    case  71840200: return 'Horoscope02Taurus26';
    case 159352504: return 'Horoscope03Gemini26';
    case 208077124: return 'Horoscope04Cancer26';
    case  26660401: return 'Horoscope05Leo26';
    case  62727448: return 'Horoscope06Virgo26';
    case  96213810: return 'Horoscope07Libra26';
    case 223466233: return 'Horoscope08Scorpio26';
    case 173679712: return 'Horoscope09Sagittarius26';
    case 222021250: return 'Horoscope10Capricorn26';
    case  97938264: return 'Horoscope11Aquarius26';
    case  89778309: return 'Horoscope12Pisces26';
    case  95392669: return 'StarDivination';
    case  50325200: return 'StarDivination_2';
    case 198365924: return 'FosterKidRepeated';
    case 151361348: return 'Nestling21Repeated';
    case  23441217: return 'JigsawRepeated';
    case  60952756: return 'SculptureRepeated';
    case 166692576: return 'Cake21Repeated';
    case 167642967: return 'Serial01TrainTravel23_A';
    case   7551890: return 'Serial01TrainTravel23_B';
    case 100040608: return 'Serial02TrainTravel23';
    case  80943751: return 'Serial03TrainTravel23';
    case  97201648: return 'Serial04TrainTravel23';
    case  82725079: return 'Serial05TrainTravel23';
    case 217113087: return 'Serial06TrainTravel23';
    case 232096984: return 'Serial07TrainTravel23';
    case 247500561: return 'Serial08TrainTravel23';
    case 266725942: return 'Serial09TrainTravel23';
    case 155591585: return 'Serial10TrainTravel23';
    case 140723846: return 'Serial11TrainTravel23';
    case   8253358: return 'Serial12TrainTravel23';
    case  22579849: return 'Serial13TrainTravel23';
    case   4242942: return 'Serial14TrainTravel23';
    case  23451865: return 'Serial15TrainTravel23';
    case 159085041: return 'Serial16TrainTravel23';
    case 140383446: return 'Serial17TrainTravel23';
    case 189472543: return 'Serial18TrainTravel23';
    case 175012408: return 'Serial19TrainTravel23';
    case 212571634: return 'Serial20TrainTravel23';
    case 227471573: return 'Serial21TrainTravel23';
    case  93346301: return 'Serial22TrainTravel23';
    case  78986458: return 'Serial23TrainTravel23';
    case  95226797: return 'Serial24TrainTravel23';
    case  76050058: return 'Serial25TrainTravel23';
    case 211208098: return 'Serial26TrainTravel';
    case   6288265: return 'Serial27TrainTravel';
    case  55244864: return 'Serial28TrainTravel';
    case 139772935: return 'Advent01Christmas23';
    case 112424108: return 'Advent02Carnival24';
    case 165790285: return 'Advent03Mgbday';
    case 147834921: return 'Advent04Autumn';
    case  85262574: return 'Dig01January24';
    case 229421661: return 'Dig02';
    case 225537373: return 'Dig03';
    case 159546591: return 'Dig04';
    case 258565517: return 'Dig05';
    case 236195828: return 'Dig06';
    case 133157916: return 'Dig07';
  }
  return `Unknown EnumMesaType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMesaUIEventName(code) {
  switch(code) {
    case   0: return 'None';
    case   1: return 'Started';
    case   2: return 'Finished';
    case   3: return 'ProgressChanged';
    case   4: return 'MilestoneReached';
    case   5: return 'Tutorial';
    case   6: return 'RemindRestart';
    case   7: return 'ApplyCumulativeRewards';
    case   8: return 'StepFailed';
    case   9: return 'RewardUnlocked';
    case  10: return 'DummyReward';
    case  11: return 'RewardLocked';
    case 101: return 'M3LivesChanged';
    case 102: return 'M3RewardsIntroMain';
    case 103: return 'M3RewardsIntroLevelDesc';
    case 110: return 'CompletedM3Level';
  }
  return `Unknown EnumMesaUIEvent code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumCollectionsStepName(code) {
  switch(code) {
    case 1: return 'Started';
    case 2: return 'TutorialStart';
    case 3: return 'TutorialComplete';
  }
  return `Unknown EnumCollectionsStep code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getUIM3FailedBubbleItemTypeName(code) {
  switch(code) {
    case  1: return 'WinStreak';
    case  2: return 'GvntResources';
    case  3: return 'BattlePassMedals';
    case  4: return 'TmntBugz';
    case  5: return 'DailyQuestTarget';
    case  6: return 'Mesa';
    case  7: return 'BattlePassX2';
    case  8: return 'GeoSocietyX2';
    case  9: return 'BattlePassReward';
    case 10: return 'GvntReward';
    case 11: return 'DailyQuestReward';
    case 12: return 'TmntIndividual';
    case 13: return 'TmntRainbowRush';
    case 14: return 'RiverRumble';
    case 15: return 'Regatta';
    case 16: return 'TmntBakeryMarathon';
  }
  return `Unknown UIM3FailedBubbleItemType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBattlePassTypeName(code) {
  switch(code) {
    case         0: return 'other';
    case  66889332: return 'love_and_swans';
    case  96021351: return 'sports_2021';
    case 135675450: return 'circus21';
    case 186858163: return 'bp_newbie22';
    case 248731929: return 'bp4_fireworks21';
    case 203920031: return 'bp05_hunting21';
    case 229740742: return 'bp06_fair21';
    case  44518064: return 'bp07_halloween21';
    case 169205758: return 'bp08_airo21';
    case 220758278: return 'bp09_winter21';
    case  26966858: return 'bp10_love22';
    case 235864425: return 'bp11_alpaca22';
    case  30856632: return 'bp12_easter22';
    case 226047957: return 'bp13_pleinair22';
    case  80092436: return 'bp14_minipig22';
    case 172549851: return 'bp15_tanabata22';
    case 244031023: return 'bp16_toothy22';
    case   4999391: return 'bp17_oracle22';
    case  25573064: return 'bp18_musical22';
    case 162390976: return 'bp19_deer22';
    case  63590610: return 'bp20_thanksgiving22';
    case  24933576: return 'bp21_ice22';
    case 103080438: return 'bp22_chineseny23';
    case  19926441: return 'bp23_stvalentines23';
    case  61919985: return 'bp24_patrick23';
    case 198383642: return 'bp25_capybara23';
    case 124020412: return 'bp26_genie23';
    case 206916675: return 'bp27_boar23';
    case  85349898: return 'bp28_hurdy_gurdy23';
    case  46922603: return 'bp29_fireworks23';
    case  19198549: return 'bp30_butterflies23';
    case  11980097: return 'bp31_greyhound23';
    case 173530299: return 'bp32_giraffe23';
    case  98443129: return 'bp33_viking23';
    case 103407892: return 'bp34_chess23';
    case 178293558: return 'bp35_redpanda23';
    case 225135206: return 'bp36_macaque23';
    case 267257778: return 'bp37_reindeer23';
    case 145307652: return 'bp38_flamingo24';
    case  93263450: return 'bp00_test';
    case  69645621: return 'bp40_owls24';
    case 226013015: return 'bp41_patrick24';
    case 227461389: return 'bp42_bees24';
    case 139749850: return 'bp43_magic24';
    case  10601092: return 'bp44_pony24';
    case   5385302: return 'bp45_fathersday24';
    case  72095947: return 'bp46_independence24';
    case 179925271: return 'bp47_donkey24';
    case  45761434: return 'bp48_vampire24';
    case 206206815: return 'bp50_dotseco24';
    case  91579632: return 'bp49_chocolate24';
    case  92601849: return 'bp51_halloween24';
    case 179795797: return 'bp52_hawaii24';
    case 235516182: return 'bp53_christmas24';
    case 166963397: return 'bp54_yetti24';
    case  88994336: return 'bp55_kungfu25';
    case  30803342: return 'bp56_sheep25';
    case  25551595: return 'bp57_snowwhite25';
    case 163242515: return 'bp59_squirrel25';
    case 139493227: return 'bp58_flyingfox25';
    case 121213394: return 'bp60_mothersday25';
    case 204664560: return 'bp61_gardendwarf25';
    case 173520010: return 'bp62_independence25';
    case 137647445: return 'bp63_hunting25';
    case 241210918: return 'bp64_beavers25';
    case  39948302: return 'bp65_horse25';
    case 221596644: return 'bp66_fox25';
    case  94218511: return 'bp67_peacock25';
    case 119659565: return 'bp68_gingerbread25';
    case 255733369: return 'bp69_thanksgiving25';
    case 205319734: return 'bp70_christmas25';
    case  32418328: return 'bp71_icesculpture25';
    case 166451676: return 'bp72_valentine26';
    case 143903978: return 'bp73_patrick26';
    case 240037891: return 'bp75_mothersday26';
    case 261763874: return 'bp74_easter26';
    case 263949834: return 'bp76_circus26';
    case 163318518: return 'bp77_fishing26';
    case 224913648: return 'bp78_independence26';
    case 132754311: return 'bp79_safari26';
    case 166600133: return 'bp80_exhibition26';
    case 103432464: return 'bp81_swan26';
    case  44467804: return 'bp82_halloween26';
    case 173350172: return 'bp83_thanksgiving26';
    case 197060479: return 'bp_newbie_vampire';
    case 171709057: return 'bp39_lunar_ny24';
    case 127823442: return 'bp_newbie_wedding22';
  }
  return `Unknown EnumBattlePassType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBattlePassStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Incoming';
    case 2: return 'Active';
    case 3: return 'Finished';
  }
  return `Unknown EnumBattlePassStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBattlePassRewardStateName(code) {
  switch(code) {
    case 0: return 'LOCKED';
    case 1: return 'UNLOCKED';
    case 2: return 'CLAIMED';
  }
  return `Unknown EnumBattlePassRewardState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBattlePassRewardsPartVersionName(code) {
  switch(code) {
    case 0: return 'ABSOLUTE_PRICE';
    case 1: return 'RESET_AFTER_UNLOCK';
  }
  return `Unknown EnumBattlePassRewardsPartVersion code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBattlePassRewardTypeName(code) {
  switch(code) {
    case 0: return 'REGULAR';
    case 1: return 'VIP';
    case 2: return 'CUSTOM';
  }
  return `Unknown EnumBattlePassRewardType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumDerbyStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Incoming';
    case 2: return 'Active';
    case 3: return 'Finished';
  }
  return `Unknown EnumDerbyStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumDerbyAudienceName(code) {
  switch(code) {
    case 0: return 'All';
    case 1: return 'QA';
    case 2: return 'ExceptQA';
  }
  return `Unknown EnumDerbyAudience code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRaceStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Active';
    case 2: return 'Finished';
  }
  return `Unknown EnumRaceStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumPromoCodeStatusName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'PENDING';
    case 2: return 'OK_REDEEMED';
    case 3: return 'ERR_INVALID_CODE';
    case 4: return 'ERR_INVALID_BATCH';
    case 5: return 'ERR_ALREADY_REDEEMED_YOU';
    case 6: return 'ERR_ALREADY_REDEEMED_OTHER';
    case 7: return 'ERR_SYSTEM';
    case 8: return 'ERR_NO_ATTEMPTS_LEFT';
    case 9: return 'ERR_EXPIRED_BATCH';
  }
  return `Unknown EnumPromoCodeStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumPromoCodeRewardStateName(code) {
  switch(code) {
    case 0: return 'NOT_ELIGIBLE';
    case 1: return 'PENDING';
    case 2: return 'CLAIMED';
  }
  return `Unknown EnumPromoCodeRewardState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRandomSeedGroupName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'GvntEaster21Boxes';
    case  2: return 'GvntSpring21Boxes';
    case  3: return 'GvntCheese21Boxes';
    case  4: return 'GvntFashion21Boxes';
    case  5: return 'GvntBday21Boxes';
    case  6: return 'GvntCarnival21Boxes';
    case  7: return 'GvntChristmas21Boxes';
    case  8: return 'GvntWinterwalk21Boxes';
    case  9: return 'GvntChineseNY22Boxes';
    case 10: return 'GvntSweetFest22Boxes';
    case 11: return 'GvntSpringWalk22Boxes';
    case 12: return 'GvntSunParty22Boxes';
    case 13: return 'GvntHillsGreenhouse22Boxes';
    case 14: return 'GvntPoetryEvening22Boxes';
    case 15: return 'GvntSewingShop22Boxes';
    case 16: return 'GvntEgypt22Boxes';
    case 17: return 'GvntChristmas22Boxes';
    case 18: return 'GvntNewbieEvent23Boxes';
    case 19: return 'GvntSweetShop23Boxes';
    case 20: return 'GvntEaster23Boxes';
    case 21: return 'GvntCelticTales23Boxes';
    case 22: return 'GvntFortuneteller23Boxes';
    case 23: return 'GvntMarine23Boxes';
    case 24: return 'GvntBaroque23Boxes';
    case 25: return 'GvntHalloween23Boxes';
    case 26: return 'GvntChristmas23Boxes';
    case 27: return 'GvntValentine24Boxes';
    case 28: return 'GvntLadiesday124Boxes';
    case 29: return 'GvntLadiesday324Boxes';
    case 30: return 'GvntEaster24Boxes';
    case 31: return 'GvntOrientalMammy224Boxes';
    case 32: return 'GvntPirate24Boxes';
    case 33: return 'GvntFairytale24Boxes';
    case 34: return 'GvntOlympic24Boxes';
    case 35: return 'GvntMermaid24Boxes';
    case 36: return 'GvntThanksgiving24Boxes';
    case 37: return 'GvntPlanetParade24Boxes';
    case 38: return 'GvntChineseny25Boxes';
    case 39: return 'GvntPatrick25Boxes';
    case 40: return 'GvntEaster25Boxes';
    case 41: return 'GvntSlagerBirthday25Boxes';
    case 42: return 'GvntHarvestFest25Boxes';
    case 43: return 'GvntTropics25Boxes';
    case 44: return 'GvntJapan25Boxes';
    case 45: return 'GvntWinterfest25Boxes';
    case 46: return 'GvntCheese26Boxes';
  }
  return `Unknown EnumRandomSeedGroup code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMergeFieldTagName(code) {
  switch(code) {
    case  1: return 'GvntEaster21';
    case  2: return 'GvntSpring21';
    case  3: return 'GvntCheese21';
    case  4: return 'GvntFashion21';
    case  5: return 'GvntBday21';
    case  6: return 'GvntCarnival21';
    case  7: return 'GvntChristmas21';
    case  8: return 'GvntWinterwalk21';
    case  9: return 'GvntChineseNY22';
    case 10: return 'GvntSweetFest22';
    case 11: return 'GvntSpringWalk22';
    case 12: return 'GvntSunParty22';
    case 13: return 'GvntHillsGreenhouse22';
    case 14: return 'GvntPoetryEvening22';
    case 15: return 'GvntSewingShop22';
    case 16: return 'GvntEgypt22';
    case 17: return 'GvntChristmas22';
    case 18: return 'GvntNewbieEvent23';
    case 19: return 'GvntSweetShop23';
    case 20: return 'GvntEaster23';
    case 21: return 'GvntCelticTales23';
    case 22: return 'GvntFortuneteller23';
    case 23: return 'GvntMarine23';
    case 24: return 'GvntBaroque23';
    case 25: return 'GvntHalloween23';
    case 26: return 'GvntChristmas23';
    case 27: return 'Mahjong07Fairytales24';
    case 28: return 'GvntValentine24';
    case 29: return 'Mahjong08Ladiesday24';
    case 30: return 'Ladiesday124';
    case 31: return 'GvntLadiesday124';
    case 32: return 'GvntLadiesday324';
    case 33: return 'GvntEaster24';
    case 34: return 'Mahjong09Oriental124';
    case 35: return 'GvntOrientalMammy224';
    case 36: return 'GvntPirate24';
    case 37: return 'GvntFairytale24';
    case 38: return 'Mahjong11Tennis24';
    case 39: return 'GvntOlympic24';
    case 40: return 'GvntMermaid24';
    case 41: return 'Mahjong13Halloween24';
    case 42: return 'GvntThanksgiving24';
    case 43: return 'GvntPlanetParade24';
    case 44: return 'GvntChineseny25';
    case 45: return 'GvntPatrick25';
    case 46: return 'GvntEaster25';
    case 47: return 'GvntSlagerBirthday25';
    case 48: return 'GvntHarvestFest25';
    case 49: return 'GvntTropics25';
    case 50: return 'GvntJapan25';
    case 51: return 'GvntMahjong18Halloween25';
    case 52: return 'GvntWinterfest25';
    case 53: return 'GvntCheese26';
  }
  return `Unknown EnumMergeFieldTag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMahjongFieldTagName(code) {
  switch(code) {
    case  1: return 'MahjongBoatClub22';
    case  2: return 'MahjongBoatClub22Bonus';
    case  3: return 'Mahjong02Halloween22';
    case  4: return 'Mahjong02Halloween22Bonus';
    case  5: return 'Mahjong03Winter23';
    case  6: return 'Mahjong03Winter23Bonus';
    case  7: return 'Mahjong04FairyBall23';
    case  8: return 'Mahjong04FairyBall23Bonus';
    case  9: return 'Mahjong05Expedition23';
    case 10: return 'Mahjong05Expedition23Bonus';
    case 11: return 'Mahjong06thanksgiving23';
    case 12: return 'Mahjong06thanksgiving23Bonus';
    case 13: return 'Mahjong07Fairytales24';
    case 14: return 'Mahjong07Fairytales24Bonus';
    case 15: return 'Mahjong08Ladiesday24';
    case 16: return 'Mahjong08Ladiesday24Bonus';
    case 17: return 'Mahjong09Oriental124';
    case 18: return 'Mahjong09Oriental124Bonus';
    case 19: return 'Mahjong10Oriental324';
    case 20: return 'Mahjong10Oriental324Bonus';
    case 21: return 'Mahjong11Tennis24';
    case 22: return 'Mahjong11Tennis24Bonus';
    case 23: return 'Mahjong12School24';
    case 24: return 'Mahjong12School24Bonus';
    case 25: return 'Mahjong13Halloween24';
    case 26: return 'Mahjong13Halloween24Bonus';
    case 27: return 'Mahjong14Christmas24';
    case 28: return 'Mahjong14Christmas24Bonus';
    case 29: return 'Mahjong15Valentine25';
    case 30: return 'Mahjong15Valentine25Bonus';
    case 31: return 'Mahjong16Spring25';
    case 32: return 'Mahjong16Spring25Bonus';
    case 33: return 'Mahjong17Carnival25';
    case 34: return 'Mahjong17Carnival25Bonus';
    case 35: return 'Mahjong18Halloween25';
    case 36: return 'Mahjong18Halloween25Bonus';
    case 37: return 'Mahjong19Christmas25';
    case 38: return 'Mahjong19Christmas25Bonus';
  }
  return `Unknown EnumMahjongFieldTag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumItemAdditionStackTagName(code) {
  switch(code) {
    case  1: return 'GvntEaster21';
    case  2: return 'GvntSpring21';
    case  3: return 'GvntCheese21';
    case  4: return 'GvntFashion21';
    case  5: return 'GvntBday21';
    case  6: return 'GvntCarnival21';
    case  7: return 'GvntChristmas21';
    case  8: return 'GvntWinterwalk21';
    case  9: return 'GvntChineseNY22';
    case 10: return 'GvntSweetFest22';
    case 11: return 'GvntSpringWalk22';
    case 12: return 'GvntSunParty22';
    case 13: return 'GvntHillsGreenhouse22';
    case 14: return 'GvntPoetryEvening22';
    case 15: return 'GvntSewingShop22';
    case 16: return 'GvntEgypt22';
    case 17: return 'GvntChristmas22';
    case 18: return 'GvntNewbieEvent23';
    case 19: return 'GvntSweetShop23';
    case 20: return 'GvntEaster23';
    case 21: return 'GvntCelticTales23';
    case 22: return 'GvntFortuneteller23';
    case 23: return 'GvntMarine23';
    case 24: return 'GvntBaroque23';
    case 25: return 'GvntHalloween23';
    case 26: return 'GvntChristmas23';
    case 27: return 'Mahjong07Fairytales24';
    case 28: return 'GvntValentine24';
    case 29: return 'Mahjong08Ladiesday24';
    case 30: return 'GvntLadiesday124';
    case 31: return 'GvntLadiesday324';
    case 32: return 'GvntEaster24';
    case 33: return 'Mahjong09Oriental124';
    case 34: return 'GvntOrientalMammy224';
    case 35: return 'GvntPirate24';
    case 36: return 'GvntFairytale24';
    case 37: return 'Mahjong11Tennis24';
    case 38: return 'GvntOlympic24';
    case 39: return 'GvntMermaid24';
    case 40: return 'Mahjong13Halloween24';
    case 41: return 'GvntThanksgiving24';
    case 42: return 'GvntPlanetParade24';
    case 43: return 'GvntChineseny25';
    case 44: return 'GvntPatrick25';
    case 45: return 'GvntEaster25';
    case 46: return 'GvntSlagerBirthday25';
    case 47: return 'GvntHarvestFest25';
    case 48: return 'GvntTropics25';
    case 49: return 'GvntJapan25';
    case 50: return 'GvntMahjong18Halloween25';
    case 51: return 'GvntWinterfest25';
    case 52: return 'GvntCheese26';
  }
  return `Unknown EnumItemAdditionStackTag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumClubGiftTypeName(code) {
  switch(code) {
    case 0: return 'LIFE';
    case 1: return 'GOLDEN_CARD_REWARD';
  }
  return `Unknown EnumClubGiftType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMesaJigsawThemeName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'Pillow';
    case  2: return 'Sculpture';
    case  3: return 'Cake';
    case  4: return 'StPatrick';
    case  5: return 'Fireworks22';
    case  6: return 'Bouquet22';
    case  7: return 'StainedGlass22';
    case  8: return 'PersianRug22';
    case  9: return 'ChristmasWreath22';
    case 10: return 'CuisineItalia23';
    case 11: return 'Cuisine2Hawaii23';
    case 12: return 'Pinata24';
    case 13: return 'Fireworks24';
    case 14: return 'Bouquet25';
    case 15: return 'StainedGlass25';
    case 16: return 'PersianRug25';
    case 17: return 'Pillow25';
    case 18: return 'ChristmasTree25';
  }
  return `Unknown EnumMesaJigsawTheme code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumCharacterName(code) {
  switch(code) {
    case         0: return 'Any';
    case  20808534: return 'Jane';
    case  73782177: return 'Mammy';
    case 267329427: return 'James';
    case  70465995: return 'Papaman';
    case 217744055: return 'mr_allen';
    case 123065358: return 'Slagger';
    case   3248650: return 'Joe';
    case 261331690: return 'Hill';
    case   5331241: return 'Ferret';
    case  32906133: return 'Cavalier';
    case 128116580: return 'Priest';
    case 135724455: return 'Beggar';
    case 145944780: return 'Linwood';
  }
  return `Unknown EnumCharacter code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTapName(code) {
  switch(code) {
    case 0: return 'DOWN';
    case 1: return 'UP';
    case 2: return 'DRAG';
    case 3: return 'CANCEL';
  }
  return `Unknown EnumTap code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumDressVariantName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Default';
    case 2: return 'Outdoor';
    case 3: return 'WithoutStick';
  }
  return `Unknown EnumDressVariant code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumM3SeqABTestAudienceTagName(code) {
  switch(code) {
    case   0: return 'None';
    case  50: return 'M3AssistantTest_2021_10_A';
    case  51: return 'M3AssistantTest_2021_10_B';
    case  52: return 'M3AssistantTest_2024_05_A';
    case  53: return 'M3AssistantTest_2024_05_B';
    case 100: return 'WinStreakTest_2021_06_A';
    case 101: return 'WinStreakTest_2021_06_B';
    case 200: return 'WinStreakTest_2021_07_A';
    case 201: return 'WinStreakTest_2021_07_B';
    case 300: return 'WinStreakTest_2021_08_A';
    case 301: return 'WinStreakTest_2021_08_B';
    case 350: return 'WinStreakTest_2021_09_A';
    case 351: return 'WinStreakTest_2021_09_B';
    case 400: return 'WinStreakTest_2021_12_A';
    case 401: return 'WinStreakTest_2021_12_B';
    case 402: return 'WinStreakTest_2022_01_A';
    case 403: return 'WinStreakTest_2022_01_B';
    case 404: return 'WinStreakTest_2022_01_C';
    case 450: return 'WinStreakTest_Reserved02_A';
    case 451: return 'WinStreakTest_Reserved02_B';
    case 500: return 'WinStreakTest_Reserved03_A';
    case 501: return 'WinStreakTest_Reserved03_B';
    case 550: return 'WinStreakTest_Reserved04_A';
    case 551: return 'WinStreakTest_Reserved04_B';
    case 600: return 'WinStreakTest_Reserved05_A';
    case 601: return 'WinStreakTest_Reserved05_B';
    case 650: return 'WinStreakTest_Reserved06_A';
    case 651: return 'WinStreakTest_Reserved06_B';
    case 700: return 'WinStreakTest_2022_07_A_Baseline';
    case 701: return 'WinStreakTest_2022_07_B_HardInfiniteWS';
    case 800: return 'M3ProdReplace_2023_05_A';
    case 801: return 'M3ProdReplace_2023_05_B';
  }
  return `Unknown EnumM3SeqABTestAudienceTag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGlobalQuestStateName(code) {
  switch(code) {
    case 0: return 'Inactive';
    case 1: return 'Active';
    case 2: return 'Finished';
    case 3: return 'Spoiled';
    case 4: return 'SeenFinished';
    case 5: return 'SeenSpoiled';
  }
  return `Unknown EnumGlobalQuestState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGlobalQuestTaskKindName(code) {
  switch(code) {
    case   0: return 'Autogenerated';
    case   1: return 'NoAction';
    case   2: return 'M3KillChip';
    case   3: return 'M3WinLevel';
    case 100: return 'SelectDecor';
  }
  return `Unknown EnumGlobalQuestTaskKind code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGlobalQuestTaskTagName(code) {
  switch(code) {
    case  0: return 'M3_green';
    case  1: return 'M3_blue';
    case  2: return 'M3_yellow';
    case  3: return 'M3_red';
    case  4: return 'M3_pink';
    case  5: return 'M3_green_blue';
    case  6: return 'M3_green_yellow';
    case  7: return 'M3_green_red';
    case  8: return 'M3_green_pink';
    case  9: return 'M3_blue_yellow';
    case 10: return 'M3_blue_red';
    case 11: return 'M3_blue_pink';
    case 12: return 'M3_yellow_red';
    case 13: return 'M3_yellow_pink';
    case 14: return 'M3_red_pink';
    case 15: return 'M3_rocket';
    case 16: return 'M3_bbomb';
    case 17: return 'M3_hbomb';
    case 18: return 'M3_vbomb';
    case 19: return 'M3_rainbow';
    case 20: return 'M3_rocket_bbomb';
    case 21: return 'M3_rocket_hbomb';
    case 22: return 'M3_rocket_vbomb';
    case 23: return 'M3_rocket_rainbow';
    case 24: return 'M3_bbomb_hbomb';
    case 25: return 'M3_bbomb_vbomb';
    case 26: return 'M3_bbomb_rainbow';
    case 27: return 'M3_hbomb_vbomb';
    case 28: return 'M3_hbomb_rainbow';
    case 29: return 'M3_vbomb_rainbow';
    case 30: return 'M3_win_level';
    case 31: return 'M3_bomb';
  }
  return `Unknown EnumGlobalQuestTaskTag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGlobalQuestTaskGeneratorKindName(code) {
  switch(code) {
    case 0: return 'Default';
    case 1: return 'GvntProgress';
    case 2: return 'BattlePassProgress';
  }
  return `Unknown EnumGlobalQuestTaskGeneratorKind code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumLocationThemeStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Active';
    case 2: return 'Opened';
    case 3: return 'Closed';
  }
  return `Unknown EnumLocationThemeStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumLocationThemeName(code) {
  switch(code) {
    case         0: return 'None';
    case 173346143: return 'Pirate21';
    case 239115985: return 'DarkCastle21';
    case 231073735: return 'ChineseNY22';
    case  18153885: return 'SunParty22';
    case  13334447: return 'Christmas22';
    case  68954657: return 'Easter23';
    case 266198884: return 'Marine23';
    case  65947958: return 'Halloween23';
    case 247614140: return 'Valentine24';
    case 175252578: return 'Pirate24';
    case  81366780: return 'Fairytale24';
    case  70541736: return 'Olympic24';
    case 244418913: return 'Thanksgiving24';
    case 161230823: return 'Chineseny25';
    case 165042267: return 'Easter25';
    case 101579420: return 'SlagerBirthday25';
    case  24866492: return 'Japan25';
    case 171669109: return 'Winterfest25';
  }
  return `Unknown EnumLocationTheme code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGvntQuestTutorialMaskName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'TasksAll';
    case 2: return 'TasksDaily';
    case 3: return 'BPReward';
    case 4: return 'BPReward2';
  }
  return `Unknown EnumGvntQuestTutorialMask code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTimeUnitName(code) {
  switch(code) {
    case 0: return 'Minute';
    case 1: return 'Hour';
    case 2: return 'Day';
  }
  return `Unknown EnumTimeUnit code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumProgressBarTypeName(code) {
  switch(code) {
    case 1: return 'Linear';
    case 2: return 'FilledImage';
  }
  return `Unknown EnumProgressBarType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumM3AudienceSourceName(code) {
  switch(code) {
    case 1: return 'WinStreak';
    case 2: return 'M3Assistant';
  }
  return `Unknown EnumM3AudienceSource code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumIntraTeamTmntProgressName(code) {
  switch(code) {
    case 1: return 'Half1stMilestone';
    case 2: return 'TwoThird1stMilestone';
    case 3: return 'HalfOtherMilestones';
  }
  return `Unknown EnumIntraTeamTmntProgress code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAnnouncementSubjectTypeName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Gvnt';
    case 2: return 'Mesa';
    case 3: return 'BattlePass';
    case 4: return 'DeepLink';
  }
  return `Unknown EnumAnnouncementSubjectType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAnnoucementConditionTypeName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'M3LevelsComplete';
    case 2: return 'StoryComplete';
  }
  return `Unknown EnumAnnoucementConditionType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumServerNotificationName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'TmntIndividualStarted';
    case  2: return 'TmntClubsStarted';
    case  3: return 'TmntBugzStarted';
    case  4: return 'TmntChampsStarted';
    case  5: return 'TmntChestStarted';
    case  6: return 'TmntIndividualPlayerLostPrizePlace';
    case  7: return 'TmntChampsPlayerLostPrizePlace';
    case  8: return 'TmntBugzPlayerLostPrizePlace';
    case  9: return 'TmntClubsPlayerLostPrizePlace';
    case 10: return 'TmntIndividualPlayerTookPrizePlace';
    case 11: return 'TmntChampsPlayerTookPrizePlace';
    case 12: return 'TmntClubsPlayerTookPrizePlace';
    case 13: return 'TmntBugzPlayerTookPrizePlace';
    case 14: return 'TmntChestHalfProgressCompleted1stMilestone';
    case 15: return 'TmntChestTwoThirdProgressCompleted1stMilestone';
    case 16: return 'TmntChestFinished';
    case 17: return 'MesaFosterKidStarted';
    case 18: return 'MesaJigsawStarted';
    case 19: return 'MesaSculptureStarted';
    case 20: return 'MesaCake21Started';
    case 21: return 'MesaNestling21Started';
    case 22: return 'TmntChestHalfProgressCompletedOtherMilestones';
    case 23: return 'TmntRainbowRushStarted';
    case 24: return 'TmntRainbowRushPlayerLostPrizePlace';
    case 25: return 'TmntRainbowRushPlayerTookPrizePlace';
    case 26: return 'MesaTrainTravel23Started';
    case 27: return 'RegattaStarted';
    case 28: return 'DerbyStarted';
    case 29: return 'RiverRumbleStarted';
    case 30: return 'TmntBakeryMarathonStarted';
    case 31: return 'TmntBakeryMarathonPlayerLostPrizePlace';
    case 32: return 'TmntBakeryMarathonPlayerTookPrizePlace';
    case 33: return 'RainbowRushStarted';
    case 34: return 'RainbowRushPlayerLostPrizePlace';
    case 35: return 'MesaDigStarted';
  }
  return `Unknown EnumServerNotification code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumServerNotificationGroupName(code) {
  switch(code) {
    case  1: return 'TmntStarted';
    case  2: return 'PrizePlaceInFinishedTmnt';
    case  3: return 'PrizePlaceLossInActiveTmnt';
    case  4: return 'NewProgressInIntraTeamTmnt';
    case  5: return 'MesaStarted';
    case  6: return 'TmntFinished';
    case  7: return 'RegattaStarted';
    case  8: return 'DerbyStarted';
    case  9: return 'RiverRumbleStarted';
    case 10: return 'RainbowRushStarted';
  }
  return `Unknown EnumServerNotificationGroup code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBonusLevelStateName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Active';
  }
  return `Unknown EnumBonusLevelState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumSideActivityOnboardingStepName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Started';
    case 2: return 'IntroCutsceneStarted';
    case 3: return 'TutorialStarted';
    case 4: return 'TutorialComplete';
    case 5: return 'TutorialLiteStarted';
    case 6: return 'TutorialLiteComplete';
  }
  return `Unknown EnumSideActivityOnboardingStep code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMaterialManagerTagName(code) {
  switch(code) {
    case 0: return 'Body';
    case 1: return 'Dress';
  }
  return `Unknown EnumMaterialManagerTag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumFestivalZoneName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'GeoSociety';
    case 2: return 'FestSquareSouth';
    case 3: return 'FestSquareSoutheast';
    case 4: return 'FestSquareEast';
    case 5: return 'FestSquareNorth';
    case 6: return 'FestSquareWest';
    case 7: return 'FestSquareCenter';
  }
  return `Unknown EnumFestivalZone code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAccountDeletingStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Started';
    case 2: return 'Canceled';
    case 3: return 'Deleted';
  }
  return `Unknown EnumAccountDeletingStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumGvntPlayerPurposeName(code) {
  switch(code) {
    case 0: return 'All';
    case 1: return 'QA';
    case 2: return 'AllExceptQA';
  }
  return `Unknown EnumGvntPlayerPurpose code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getUIM3FailedBubbleWndTypeName(code) {
  switch(code) {
    case 1: return 'UIM3Quit';
    case 2: return 'UIM3LossBuyMoves';
  }
  return `Unknown UIM3FailedBubbleWndType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumProtractedFailWndTypeName(code) {
  switch(code) {
    case 1: return 'UIM3LossBuyMoves';
    case 2: return 'UIBank';
    case 3: return 'UIPurchaseConfirmation';
    case 4: return 'UIPurchase';
  }
  return `Unknown EnumProtractedFailWndType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumWndTypeName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'UIM3LossBuyMoves';
    case 2: return 'UIBankWidget';
  }
  return `Unknown EnumWndType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getUIM3FailedBubbleActionName(code) {
  switch(code) {
    case 1: return 'Left';
    case 2: return 'Continued';
    case 3: return 'BoughtMoves';
    case 4: return 'WatchedAd';
    case 5: return 'SpentFreeMoves';
  }
  return `Unknown UIM3FailedBubbleAction code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getUIBankWidgetActionName(code) {
  switch(code) {
    case 1: return 'Show';
    case 2: return 'Click';
    case 3: return 'Purchase';
  }
  return `Unknown UIBankWidgetAction code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getUIBankWidgetTypeName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Sale';
    case 2: return 'Dress';
    case 3: return 'Sofa';
    case 4: return 'GoldenTree';
    case 5: return 'GoldenBox';
    case 6: return 'Treasury';
    case 7: return 'GvntProlong';
    case 9: return 'DecreasingBonus';
  }
  return `Unknown UIBankWidgetType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3TestingSystemOwnerName(code) {
  switch(code) {
    case 0: return 'common';
    case 1: return 'syfisher';
    case 2: return 'link';
  }
  return `Unknown M3TestingSystemOwner code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getStoryLockStateName(code) {
  switch(code) {
    case 0: return 'Open';
    case 1: return 'Close';
    case 2: return 'CanOpen';
  }
  return `Unknown StoryLockState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBillingAPIName(code) {
  switch(code) {
    case 0: return 'Undefined';
    case 1: return 'UnityIAP';
    case 2: return 'MRGS';
    case 3: return 'MRGSWeb';
    case 4: return 'MRGSFusion';
  }
  return `Unknown EnumBillingAPI code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumVibrationName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'Failure';
    case  2: return 'Success';
    case  3: return 'Selection';
    case  4: return 'MediumImpact';
    case  5: return 'SoftImpact';
    case  6: return 'RigidImpact';
    case  7: return 'M3WrongSwap';
    case  8: return 'M3TouchChip';
    case  9: return 'M3Match';
    case 10: return 'M3ReplaceChips';
    case 11: return 'M3BlockDamage';
    case 12: return 'M3HVBombDamage';
    case 13: return 'M3BBombDamage';
    case 14: return 'M3RocketDamage';
    case 15: return 'M3RocketFinalDamage';
    case 16: return 'M3RainbowActivateChip';
    case 17: return 'M3ComboTwoBBomb';
    case 18: return 'M3ComboTwoHVBomb';
    case 19: return 'M3ComboBombs';
    case 20: return 'M3ComboRocketBomb';
    case 21: return 'M3ComboRainbows';
    case 22: return 'M3BoosterHammer';
    case 23: return 'M3BoosterSledgehammer';
    case 24: return 'M3BoosterGlove';
    case 25: return 'M3ChipDamage';
    case 26: return 'UIM3Win';
    case 27: return 'UIM3VictorySummary';
    case 28: return 'UIM3DoublingReward';
    case 29: return 'UIM3VictoryClose';
    case 30: return 'M3CatMoving';
    case 31: return 'M3BeltMoving';
    case 32: return 'UIGvntYouWinOneItem';
    case 33: return 'UIGvntYouWinTwoItems';
    case 34: return 'UIGvntYouWinThreeItems';
    case 35: return 'UIGvntYouWinClose';
    case 36: return 'UITmntIndividualMedalAndScore';
    case 37: return 'UITmntClubsWinCup';
    case 38: return 'UITmntHighSocietyOpen';
    case 39: return 'UITmntHighSocietyReward';
    case 40: return 'UISpecialOfferGoldBoxOpen';
    case 41: return 'UISpecialOfferGoldBoxReward';
  }
  return `Unknown EnumVibration code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumScreenFunnelName(code) {
  switch(code) {
    case    0: return 'Unknown';
    case  100: return 'LoadingPreSignUp';
    case  200: return 'SignUp';
    case  300: return 'COPPAConsent';
    case  400: return 'IOSAppTrackingConsent';
    case  500: return 'LoadingPostSignUp';
    case  600: return 'TitleScreen';
    case  700: return 'BookAnimation';
    case  800: return 'IntroWardrobe';
    case  900: return 'IntroVideoClip';
    case 1000: return 'IntroCutscene';
    case 1100: return 'M3LoadingEnterLevel';
    case 1200: return 'M3LevelTutorial';
    case 1300: return 'M3Level';
    case 1400: return 'M3Victory';
    case 1500: return 'M3Loss';
    case 1600: return 'M3LoadingExitLevel';
    case 1700: return 'IdleTutorialQuest';
    case 1800: return 'Idle';
    case 1900: return 'DLCDownload';
  }
  return `Unknown EnumScreenFunnel code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumLifetimeMetricName(code) {
  switch(code) {
    case   0: return 'Unknown';
    case 100: return 'TotalTimeInGame';
  }
  return `Unknown EnumLifetimeMetric code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumDLCBundleStatusName(code) {
  switch(code) {
    case  0: return 'Unknown';
    case 10: return 'NeverRequested';
    case 20: return 'RequestedMissingInConfig';
    case 30: return 'RequestedMissingInManifest';
    case 40: return 'RequestedWaiting';
    case 50: return 'RequestedDownloadQueued';
    case 60: return 'Downloading';
    case 70: return 'DownloadedOK';
    case 80: return 'DownloadError';
  }
  return `Unknown EnumDLCBundleStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumSplashScreenTypeName(code) {
  switch(code) {
    case 0: return 'Default';
    case 1: return 'Themed';
    case 3: return 'Beginning';
  }
  return `Unknown EnumSplashScreenType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumSplashScreenLogoPositionName(code) {
  switch(code) {
    case 0: return 'RIGHT';
    case 1: return 'LEFT';
  }
  return `Unknown EnumSplashScreenLogoPosition code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRemoteOfferStateName(code) {
  switch(code) {
    case 0: return 'OFF';
    case 1: return 'QA';
    case 2: return 'ON';
  }
  return `Unknown EnumRemoteOfferState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumStoryItemIconFitName(code) {
  switch(code) {
    case 0: return 'Default';
    case 1: return 'FitDownsize';
  }
  return `Unknown EnumStoryItemIconFit code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumCameraEffectName(code) {
  switch(code) {
    case 0: return 'WEATHER';
    case 1: return 'LIGHT';
  }
  return `Unknown EnumCameraEffect code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAccountTransferCodeStateName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Ready';
    case 2: return 'Redeemed';
    case 3: return 'NotFound';
  }
  return `Unknown EnumAccountTransferCodeState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumDayOfWeekName(code) {
  switch(code) {
    case 1: return 'Monday';
    case 2: return 'Tuesday';
    case 3: return 'Wednesday';
    case 4: return 'Thursday';
    case 5: return 'Friday';
    case 6: return 'Saturday';
    case 0: return 'Sunday';
  }
  return `Unknown EnumDayOfWeek code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumFeatureName(code) {
  switch(code) {
    case  1: return 'TMNT_WELCOME_ONLY_FOR_NEWBIE';
    case  2: return 'UI_WAIT_TYPE';
    case  3: return 'UI_ATTENTION';
    case  4: return 'COMPETITIVE_ACTIVITIES_LIMITER';
    case  5: return 'USE_ONLY_UI_ATTENTION';
    case  6: return 'LOCATION_ROOM_LAZY_LOADING';
    case  7: return 'ANDROID_HIDE_INSTEAD_OF_QUIT';
    case  8: return 'NEW_UI_M3_WIN';
    case  9: return 'UPDATE_OFFER';
    case 10: return 'ANR_SUPERVISOR';
    case 11: return 'ANR_SUPERVISOR_FOREGROUND_KILL';
    case 12: return 'TCF';
    case 13: return 'MYGAMES_MARKET_ICON';
  }
  return `Unknown EnumFeature code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumFeatureStateName(code) {
  switch(code) {
    case 0: return 'OFF';
    case 1: return 'QA';
    case 2: return 'ON';
    case 3: return 'OFF_QA';
  }
  return `Unknown EnumFeatureState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumUIAttentionGroupName(code) {
  switch(code) {
    case  0: return 'OTHER';
    case  1: return 'DAILY_QUEST';
    case  2: return 'WIN_STREAK_WELCOME';
    case  3: return 'WIN_STREAK_MAIN';
    case  4: return 'SURPRISE_BOX';
    case  5: return 'RATE_GAME';
    case  6: return 'BATTLE_PASS_INTRO';
    case  7: return 'BATTLE_PASS_MAIN';
    case  8: return 'BATTLE_PASS_OUTRO';
    case  9: return 'GVNT_INTRO';
    case 10: return 'GVNT_MAIN';
    case 11: return 'GVNT_OUTRO';
    case 12: return 'MESA_INTRO';
    case 13: return 'MESA_MAIN';
    case 14: return 'MESA_OUTRO';
    case 15: return 'ANNOUNCEMENT';
    case 16: return 'SPECIAL_OFFERS_PROLONG';
    case 17: return 'SPECIAL_OFFERS_TREASURY';
    case 18: return 'SPECIAL_OFFERS_OTHER';
    case 19: return 'TMNT_INDIVIDUAL_WELCOME';
    case 20: return 'TMNT_INDIVIDUAL_MAIN';
    case 21: return 'TMNT_INDIVIDUAL_FINAL';
    case 22: return 'TMNT_CHAMPS_WELCOME';
    case 23: return 'TMNT_CHAMPS_MAIN';
    case 24: return 'TMNT_CHAMPS_FINAL';
    case 25: return 'TMNT_CLUBS_WELCOME';
    case 26: return 'TMNT_CLUBS_MAIN';
    case 27: return 'TMNT_CLUBS_FINAL';
    case 28: return 'TMNT_CHEST_WELCOME';
    case 29: return 'TMNT_CHEST_MAIN';
    case 30: return 'TMNT_CHEST_FINAL';
    case 31: return 'TMNT_BUGZ_WELCOME';
    case 32: return 'TMNT_BUGZ_MAIN';
    case 33: return 'TMNT_BUGZ_FINAL';
    case 34: return 'TMNT_GVNT_WELCOME';
    case 35: return 'TMNT_GVNT_MAIN';
    case 36: return 'TMNT_GVNT_FINAL';
    case 37: return 'TMNT_RAINBOW_RUSH_WELCOME';
    case 38: return 'TMNT_RAINBOW_RUSH_MAIN';
    case 39: return 'RACE_WELCOME';
    case 40: return 'RACE_MAIN';
    case 41: return 'RACE_FINAL';
    case 42: return 'ADS_CHEST';
    case 43: return 'CLUBS_FORCE_JOIN';
    case 44: return 'BATTLE_PASS_ADS';
    case 45: return 'FACEBOOK_LOGIN_REWARD';
    case 46: return 'RIVER_RUMBLE_INTRO';
    case 47: return 'RIVER_RUMBLE_MAIN';
    case 48: return 'REGATTA_START_ROUND';
    case 49: return 'REGATTA_MAIN';
    case 50: return 'TMNT_BAKERY_MARATHON_WELCOME';
    case 51: return 'TMNT_BAKERY_MARATHON_MAIN';
    case 52: return 'TMNT_BAKERY_MARATHON_FINAL';
    case 53: return 'RUBLE_PAYMENTS_REMIND';
  }
  return `Unknown EnumUIAttentionGroup code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumSuspiciousActivityName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'ExecutableInfoUnfamiliar';
    case  2: return 'TooMuchMoneyNoPayments';
    case  4: return 'TooManyBoostersNoPayments';
    case  8: return 'UnexpectedInventoryBehaviour';
    case 16: return 'UnlimitedStarsMod';
    case 32: return 'SuspiciousMaskWasModified';
    case 64: return 'TooMuchMoneyInOneTransaction';
  }
  return `Unknown EnumSuspiciousActivity code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumLocationRoomLoadingLazinessName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Lazy';
    case 2: return 'Hidden';
  }
  return `Unknown EnumLocationRoomLoadingLaziness code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumIconPlaceName(code) {
  switch(code) {
    case 0: return 'LEFT';
    case 1: return 'RIGHT';
  }
  return `Unknown EnumIconPlace code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumLocationName(code) {
  switch(code) {
    case  90844505: return 'theatre';
    case 195136432: return 'mansion';
  }
  return `Unknown EnumLocation code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumUpdateOfferTypeName(code) {
  switch(code) {
    case 0: return 'BATTLE_PASS';
    case 1: return 'GVNT';
    case 2: return 'MESA';
  }
  return `Unknown EnumUpdateOfferType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMesaCheckpointsLivesRecoveryKindName(code) {
  switch(code) {
    case 0: return 'AllLivesLoss';
    case 1: return 'EveryCheckpointReached';
  }
  return `Unknown EnumMesaCheckpointsLivesRecoveryKind code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMesaCheckpointsRewardsClaimPointName(code) {
  switch(code) {
    case 0: return 'EveryCheckpointReached';
    case 1: return 'MaxProgressReached';
  }
  return `Unknown EnumMesaCheckpointsRewardsClaimPoint code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumMesaCheckpointsRewardsLossKindName(code) {
  switch(code) {
    case 0: return 'AnyLoss';
    case 1: return 'NoLoss';
  }
  return `Unknown EnumMesaCheckpointsRewardsLossKind code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumIconDisplayModeName(code) {
  switch(code) {
    case 0: return 'TakeSprite';
    case 1: return 'InstantiatePrefab';
  }
  return `Unknown EnumIconDisplayMode code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumFBSAnalyticsEventName(code) {
  switch(code) {
    case 1: return 'Adtop10';
    case 2: return 'Adtop25';
  }
  return `Unknown EnumFBSAnalyticsEvent code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumAFAnalyticsEventName(code) {
  switch(code) {
    case 1: return 'Adtop10';
    case 2: return 'Adtop25';
  }
  return `Unknown EnumAFAnalyticsEvent code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRegattaStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Active';
    case 2: return 'Finished';
  }
  return `Unknown EnumRegattaStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRegattaRoundStatusName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Active';
    case 2: return 'RewardClaimed';
    case 3: return 'Finished';
  }
  return `Unknown EnumRegattaRoundStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRegattaJoinRoundStatusName(code) {
  switch(code) {
    case 0: return 'Success';
    case 1: return 'NotActive';
    case 2: return 'AlreadyJoined';
  }
  return `Unknown EnumRegattaJoinRoundStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRegattaLeaveRoundStatusName(code) {
  switch(code) {
    case 0: return 'Success';
    case 1: return 'NotActive';
    case 2: return 'NotJoined';
    case 3: return 'NotClaimedReward';
    case 4: return 'AlreadyLeft';
  }
  return `Unknown EnumRegattaLeaveRoundStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumABTestTagName(code) {
  switch(code) {
    case 1: return 'InsiderActivityScheduler';
  }
  return `Unknown EnumABTestTag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumCollectionStatusName(code) {
  switch(code) {
    case 0: return 'locked';
    case 1: return 'opened';
    case 2: return 'collected';
    case 3: return 'received';
  }
  return `Unknown EnumCollectionStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCollectionItemTypeName(code) {
  switch(code) {
    case 0: return 'fake';
    case 1: return 'gold';
    case 2: return 'silver';
    case 3: return 'joker';
  }
  return `Unknown CollectionItemType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCollectionGroupTypeName(code) {
  switch(code) {
    case 1: return 'decor';
    case 2: return 'dress';
  }
  return `Unknown CollectionGroupType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCollectionGroupBackgroundName(code) {
  switch(code) {
    case  1: return 'blue';
    case  2: return 'purple';
    case  4: return 'pink';
    case  5: return 'green';
    case  6: return 'neutral';
    case  7: return 'yellow';
    case  8: return 'peach';
    case  9: return 'bright_green';
    case 10: return 'cyan';
  }
  return `Unknown CollectionGroupBackground code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCollectionCardBackgroundName(code) {
  switch(code) {
    case  1: return 'azure';
    case  2: return 'bright_orange';
    case  3: return 'bright_pink';
    case  4: return 'bubblegum';
    case  5: return 'cobalt';
    case  6: return 'green';
    case  7: return 'lavender';
    case  8: return 'pale_green';
    case  9: return 'peachy';
    case 10: return 'purple';
    case 11: return 'torqoise';
    case 12: return 'tyffany';
    case 13: return 'viridian';
    case 14: return 'warmred';
    case 15: return 'yellowgreen';
    case 16: return 'yelloworange';
  }
  return `Unknown CollectionCardBackground code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCollectionGroupPatternName(code) {
  switch(code) {
    case 3: return 'lines';
    case 4: return 'rhombus';
    case 5: return 'stars';
    case 6: return 'flowers';
    case 7: return 'pattern_05';
    case 8: return 'pattern_06';
    case 9: return 'pattern_07';
  }
  return `Unknown CollectionGroupPattern code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumActivityTypeName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'Tmnt';
    case  2: return 'Gvnt';
    case  3: return 'BattlePass';
    case  4: return 'Mesa';
    case  5: return 'Derby';
    case  6: return 'RainbowRush';
    case  7: return 'RiverRumble';
    case  8: return 'Regatta';
    case  9: return 'WinStreak';
    case 10: return 'DailyQuest';
  }
  return `Unknown EnumActivityType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumDigMechanicsFieldTagName(code) {
  switch(code) {
    case 1: return 'MesaDig01January24';
  }
  return `Unknown EnumDigMechanicsFieldTag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3DirName(code) {
  switch(code) {
    case 0: return 'DOWN';
    case 1: return 'UP';
    case 2: return 'LEFT';
    case 3: return 'RIGHT';
    case 4: return 'NONE';
  }
  return `Unknown M3Dir code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3MatchModeName(code) {
  switch(code) {
    case 0: return 'REGULAR';
    case 1: return 'CHILD';
    case 2: return 'NONE';
    case 3: return 'REGULAR_NONE';
  }
  return `Unknown M3MatchMode code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3PlaneName(code) {
  switch(code) {
    case 0: return 'Horizontal';
    case 1: return 'Vertical';
  }
  return `Unknown M3Plane code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3TilemapName(code) {
  switch(code) {
    case 0: return 'background';
    case 1: return 'mat';
    case 2: return 'jelly';
    case 3: return 'clear';
    case 4: return 'honey';
    case 5: return 'tutorial';
    case 6: return 'honey_outline';
    case 7: return 'flower_field';
    case 8: return 'flower_field_outline';
  }
  return `Unknown M3Tilemap code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3MechanicsName(code) {
  switch(code) {
    case  0: return 'none';
    case  1: return 'box';
    case  2: return 'chain';
    case  3: return 'flower';
    case  4: return 'tray';
    case  5: return 'ice';
    case  6: return 'key';
    case  7: return 'plate';
    case  8: return 'letter';
    case  9: return 'carpet';
    case 10: return 'foam';
    case 11: return 'gravity';
    case 12: return 'portals';
    case 13: return 'spawners';
    case 14: return 'walls';
    case 15: return 'belt';
    case 16: return 'lyre_note';
    case 17: return 'feather';
    case 20: return 'web';
    case 21: return 'mouse';
    case 22: return 'candle';
    case 23: return 'ring';
    case 24: return 'cuckoo_clock';
    case 25: return 'jelly';
    case 27: return 'paint_tray';
    case 28: return 'barrier';
    case 29: return 'cat';
    case 31: return 'compass';
    case 32: return 'curtain';
    case 33: return 'book';
    case 34: return 'pillow';
    case 35: return 'cookies';
    case 36: return 'smoke';
    case 37: return 'birds';
    case 38: return 'crystalyzer';
    case 39: return 'bobbin';
    case 40: return 'fan';
    case 41: return 'honey';
    case 42: return 'ribbon';
    case 43: return 'gift';
    case 44: return 'stack';
    case 45: return 'armored_wall';
    case 46: return 'umbrella';
    case 47: return 'icebomb';
    case 48: return 'music_box';
    case 49: return 'candy';
    case 50: return 'stone_tiles';
    case 51: return 'fireworks';
    case 52: return 'flower_field';
    case 53: return 'cake';
    case 54: return 'cake_piece';
  }
  return `Unknown M3Mechanics code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3GoalsIdsName(code) {
  switch(code) {
    case         0: return 'none';
    case        10: return 'color_match';
    case  34681458: return 'box';
    case 182865318: return 'plate';
    case 165835097: return 'key';
    case  17201424: return 'flower';
    case 124248265: return 'coil';
    case 105096733: return 'cookie';
    case  72057805: return 'lyre_note';
    case  86370893: return 'candy';
    case 168633071: return 'jelly';
    case 107133260: return 'foam';
    case  37925772: return 'carpet';
    case 144139772: return 'glass';
    case 152123871: return 'stone_tiles';
    case  69201358: return 'honey';
    case 103514130: return 'chain';
    case 109310110: return 'ice';
    case  47307072: return 'candle';
    case  99200788: return 'feather';
    case 239173506: return 'cake_piece';
    case  58458845: return 'web';
    case 240727102: return 'smoke';
    case  77815192: return 'mouse';
    case  99382431: return 'ring';
    case 268228540: return 'cuckoo_clock';
    case  46351931: return 'cat_end';
    case 171013116: return 'compass';
    case 187083537: return 'curtain';
    case  77312621: return 'coin';
    case 259889572: return 'birds';
    case   4705389: return 'fan_red';
    case 259027716: return 'fan_cyan';
    case 215706882: return 'music_box';
    case 243654319: return 'fireworks';
    case         1: return 'tag_letter';
    case         2: return 'tag_bomb';
    case         3: return 'tag_paint';
    case         4: return 'tag_coil';
    case         5: return 'tag_cookie';
    case         6: return 'tag_chain';
  }
  return `Unknown M3GoalsIds code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ChipsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 159587649: return 'random';
    case 149856411: return 'empty';
    case 173571093: return 'green';
    case  20043541: return 'red';
    case 152790968: return 'blue';
    case 266541332: return 'pink';
    case 152369935: return 'yellow';
    case  17824785: return 'cyan';
    case  34681458: return 'box';
    case 182865318: return 'plate';
    case 192896741: return 'stack_of_plates';
    case 165835097: return 'key';
    case  17201424: return 'flower';
    case 103514130: return 'chain';
    case  37876280: return 'chain_mirror';
    case 168633071: return 'jelly';
    case 109310110: return 'ice';
    case 130928691: return 'gift';
    case  47307072: return 'candle';
    case   4705389: return 'fan_red';
    case 259027716: return 'fan_cyan';
    case 158564410: return 'rocket';
    case 203671966: return 'bbomb';
    case 144508370: return 'vbomb';
    case 108834744: return 'hbomb';
    case   4153540: return 'rainbow';
    case 105916447: return 'super_rainbow';
    case 150880180: return 'tray';
    case 223856470: return 'lyre';
    case  72057805: return 'lyre_note';
    case 251912449: return 'candy_jar';
    case  86370893: return 'candy';
    case 220370293: return 'random_1';
    case  78621104: return 'random_2';
    case  64273907: return 'random_3';
    case 129355834: return 'random_4';
    case 107133260: return 'foam';
    case  99200788: return 'feather';
    case 264630631: return 'pillow';
    case  97991665: return 'crystalyzer';
    case  27253688: return 'paint_tray_3x1';
    case  20890305: return 'paint_tray_2x1';
    case 243654319: return 'fireworks';
    case 259889572: return 'birds';
    case  77815192: return 'mouse';
    case 203259574: return 'mouse_hole';
    case 156916201: return 'box_with_ring';
    case 268228540: return 'cuckoo_clock';
    case 215706882: return 'music_box';
    case  99382431: return 'ring';
    case 169073011: return 'bowknot';
    case 204595850: return 'bowknot_violet';
    case 126361439: return 'bowknot_ribbon';
    case   7588332: return 'bowknot_unlink';
    case 217835229: return 'bobbin';
    case  34356751: return 'bobbin_line';
    case  63418720: return 'bobbin_turn_l';
    case 130361475: return 'bobbin_turn_r';
    case 238292662: return 'cat';
    case 246509973: return 'cat_green';
    case 233729156: return 'cat_red';
    case 248454097: return 'cat_blue';
    case 137848189: return 'cat_pink';
    case  77107490: return 'cat_yellow';
    case 115048568: return 'cat_cyan';
    case  46351931: return 'cat_end';
    case 171013116: return 'compass';
    case 187083537: return 'curtain';
    case 164015039: return 'bookcase';
    case 146262794: return 'book';
    case 233405292: return 'cookies_jar_1x2';
    case 226894248: return 'cookies_jar_2x1';
    case  22251383: return 'umbrella_blue';
    case 155655390: return 'umbrella_cyan';
    case  33287124: return 'umbrella_green';
    case 128711131: return 'umbrella_pink';
    case 236501597: return 'umbrella_red';
    case  92056254: return 'umbrella_yellow';
    case 115710274: return 'icebomb1_blue';
    case 250675947: return 'icebomb1_cyan';
    case 119511529: return 'icebomb1_green';
    case   1959918: return 'icebomb1_pink';
    case  11774505: return 'icebomb1_red';
    case 222429917: return 'icebomb1_yellow';
    case 176471193: return 'icebomb2_blue';
    case  43001648: return 'icebomb2_cyan';
    case 107148176: return 'icebomb2_green';
    case 209502773: return 'icebomb2_pink';
    case 226084583: return 'icebomb2_red';
    case  76199471: return 'icebomb2_yellow';
    case 228435278: return 'flower_seed';
    case  77312621: return 'coin';
    case  52335828: return 'cake';
    case 239173506: return 'cake_piece';
  }
  return `Unknown M3Chips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3RegularChipsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 149856411: return 'empty';
    case 159587649: return 'random';
    case 173571093: return 'green';
    case  20043541: return 'red';
    case 152790968: return 'blue';
    case 152369935: return 'yellow';
    case  17824785: return 'cyan';
    case 266541332: return 'pink';
  }
  return `Unknown M3RegularChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3TargetChipsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 223856470: return 'lyre';
    case 268228540: return 'cuckoo_clock';
    case  77312621: return 'coin';
    case 251912449: return 'candy_jar';
    case 228435278: return 'flower_seed';
  }
  return `Unknown M3TargetChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ChipsCatName(code) {
  switch(code) {
    case 238292662: return 'cat';
    case 246509973: return 'cat_green';
    case 233729156: return 'cat_red';
    case 248454097: return 'cat_blue';
    case 137848189: return 'cat_pink';
    case  77107490: return 'cat_yellow';
    case 115048568: return 'cat_cyan';
    case  46351931: return 'cat_end';
  }
  return `Unknown M3ChipsCat code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3CompassDirName(code) {
  switch(code) {
    case 1: return 'Top';
    case 2: return 'Right';
    case 3: return 'Bottom';
    case 4: return 'Left';
    case 5: return 'Random';
  }
  return `Unknown M3CompassDir code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ChipsPaintName(code) {
  switch(code) {
    case         0: return 'clear';
    case 176942238: return 'blue';
    case  10502419: return 'yellow';
    case 137783651: return 'green';
    case 208900658: return 'pink';
    case  44005175: return 'cyan';
    case 131475464: return 'red';
    case 159587649: return 'random';
    case 220370293: return 'random_1';
    case  78621104: return 'random_2';
    case  64273907: return 'random_3';
    case 129355834: return 'random_4';
  }
  return `Unknown M3ChipsPaint code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ChipsPetardName(code) {
  switch(code) {
    case         0: return 'clear';
    case  22788757: return 'blue';
    case  22861769: return 'yellow';
    case 257908925: return 'green';
    case 128173113: return 'pink';
    case 156180796: return 'cyan';
    case 214376637: return 'red';
    case 159587649: return 'random';
    case 220370293: return 'random_1';
    case  78621104: return 'random_2';
    case  64273907: return 'random_3';
    case 129355834: return 'random_4';
  }
  return `Unknown M3ChipsPetard code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ChipsBirdsName(code) {
  switch(code) {
    case 225305613: return 'blue';
    case  68663070: return 'yellow';
    case  26693013: return 'green';
    case 194353825: return 'pink';
    case  91848612: return 'cyan';
    case 116972268: return 'red';
    case 159587649: return 'random';
    case 220370293: return 'random_1';
    case  78621104: return 'random_2';
    case  64273907: return 'random_3';
    case 129355834: return 'random_4';
  }
  return `Unknown M3ChipsBirds code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3TrashChipsName(code) {
  switch(code) {
    case  34681458: return 'box';
    case 182865318: return 'plate';
    case 192896741: return 'stack_of_plates';
    case 130928691: return 'gift';
    case  47307072: return 'candle';
    case 156916201: return 'box_with_ring';
    case 169073011: return 'bowknot';
    case 204595850: return 'bowknot_violet';
    case 171013116: return 'compass';
    case   4705389: return 'fan_red';
    case 259027716: return 'fan_cyan';
    case 215706882: return 'music_box';
  }
  return `Unknown M3TrashChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3LinkChipsName(code) {
  switch(code) {
    case 217835229: return 'bobbin';
    case  34356751: return 'bobbin_line';
    case  63418720: return 'bobbin_turn_l';
    case 130361475: return 'bobbin_turn_r';
  }
  return `Unknown M3LinkChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3BombChipsName(code) {
  switch(code) {
    case 158564410: return 'rocket';
    case 203671966: return 'bbomb';
    case 144508370: return 'vbomb';
    case 108834744: return 'hbomb';
    case   4153540: return 'rainbow';
    case 105916447: return 'super_rainbow';
  }
  return `Unknown M3BombChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3MultiColorChipsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 259889572: return 'birds';
    case  27253688: return 'paint_tray_3x1';
    case  20890305: return 'paint_tray_2x1';
    case 243654319: return 'fireworks';
  }
  return `Unknown M3MultiColorChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3UmbrellaChipsName(code) {
  switch(code) {
    case         0: return 'clear';
    case  22251383: return 'umbrella_blue';
    case 155655390: return 'umbrella_cyan';
    case  33287124: return 'umbrella_green';
    case 128711131: return 'umbrella_pink';
    case 236501597: return 'umbrella_red';
    case  92056254: return 'umbrella_yellow';
  }
  return `Unknown M3UmbrellaChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3Icebomb1ChipsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 115710274: return 'icebomb1_blue';
    case 250675947: return 'icebomb1_cyan';
    case 119511529: return 'icebomb1_green';
    case   1959918: return 'icebomb1_pink';
    case  11774505: return 'icebomb1_red';
    case 222429917: return 'icebomb1_yellow';
  }
  return `Unknown M3Icebomb1Chips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3Icebomb2ChipsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 176471193: return 'icebomb2_blue';
    case  43001648: return 'icebomb2_cyan';
    case 107148176: return 'icebomb2_green';
    case 209502773: return 'icebomb2_pink';
    case 226084583: return 'icebomb2_red';
    case  76199471: return 'icebomb2_yellow';
  }
  return `Unknown M3Icebomb2Chips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3MultiCellChipsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 150880180: return 'tray';
    case 233405292: return 'cookies_jar_1x2';
    case 226894248: return 'cookies_jar_2x1';
  }
  return `Unknown M3MultiCellChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3CurtainsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 187083537: return 'curtain';
  }
  return `Unknown M3Curtains code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3InvaderChipsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 107133260: return 'foam';
  }
  return `Unknown M3InvaderChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3SourceSpawnName(code) {
  switch(code) {
    case 0: return 'from_conf';
    case 1: return 'from_replace';
    case 2: return 'from_spawner';
    case 3: return 'from_parent';
    case 4: return 'from_invasion';
  }
  return `Unknown M3SourceSpawn code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3SpawnTypeName(code) {
  switch(code) {
    case 173571093: return 'green';
    case  20043541: return 'red';
    case 152790968: return 'blue';
    case 152369935: return 'yellow';
    case 266541332: return 'pink';
    case  17824785: return 'cyan';
    case 165835097: return 'key';
    case 182865318: return 'plate';
    case  99200788: return 'feather';
    case  52335828: return 'cake';
    case 239173506: return 'cake_piece';
    case  77312621: return 'coin';
    case 215706882: return 'music_box';
    case 228435278: return 'flower_seed';
    case 246509973: return 'cat_green';
    case 233729156: return 'cat_red';
    case 248454097: return 'cat_blue';
    case 137848189: return 'cat_pink';
    case  77107490: return 'cat_yellow';
    case 115048568: return 'cat_cyan';
    case 115710274: return 'icebomb1_blue';
    case 250675947: return 'icebomb1_cyan';
    case 119511529: return 'icebomb1_green';
    case   1959918: return 'icebomb1_pink';
    case  11774505: return 'icebomb1_red';
    case 222429917: return 'icebomb1_yellow';
    case 176471193: return 'icebomb2_blue';
    case  43001648: return 'icebomb2_cyan';
    case 107148176: return 'icebomb2_green';
    case 209502773: return 'icebomb2_pink';
    case 226084583: return 'icebomb2_red';
    case  76199471: return 'icebomb2_yellow';
  }
  return `Unknown M3SpawnType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ExtraSpawnTypeName(code) {
  switch(code) {
    case 173571093: return 'green';
    case  20043541: return 'red';
    case 152790968: return 'blue';
    case 152369935: return 'yellow';
    case 266541332: return 'pink';
    case  17824785: return 'cyan';
    case 158564410: return 'rocket';
    case 203671966: return 'bbomb';
    case 144508370: return 'vbomb';
    case 108834744: return 'hbomb';
    case   4153540: return 'rainbow';
    case 105916447: return 'super_rainbow';
    case 165835097: return 'key';
    case 182865318: return 'plate';
    case  52335828: return 'cake';
    case  99200788: return 'feather';
    case 239173506: return 'cake_piece';
    case 156916201: return 'box_with_ring';
    case  99382431: return 'ring';
    case 171013116: return 'compass';
    case 146262794: return 'book';
    case  17201424: return 'flower';
    case 168633071: return 'jelly';
    case  77312621: return 'coin';
    case 215706882: return 'music_box';
    case 228435278: return 'flower_seed';
    case 246509973: return 'cat_green';
    case 233729156: return 'cat_red';
    case 248454097: return 'cat_blue';
    case 137848189: return 'cat_pink';
    case  77107490: return 'cat_yellow';
    case 115048568: return 'cat_cyan';
    case 115710274: return 'icebomb1_blue';
    case 250675947: return 'icebomb1_cyan';
    case 119511529: return 'icebomb1_green';
    case   1959918: return 'icebomb1_pink';
    case  11774505: return 'icebomb1_red';
    case 222429917: return 'icebomb1_yellow';
    case 176471193: return 'icebomb2_blue';
    case  43001648: return 'icebomb2_cyan';
    case 107148176: return 'icebomb2_green';
    case 209502773: return 'icebomb2_pink';
    case 226084583: return 'icebomb2_red';
    case  76199471: return 'icebomb2_yellow';
  }
  return `Unknown M3ExtraSpawnType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3SpawnIconName(code) {
  switch(code) {
    case  0: return 'clear';
    case  1: return 'def';
    case  2: return 'rainbow';
    case  3: return 'rocket';
    case  4: return 'bbomb';
    case  5: return 'hbomb';
    case  6: return 'vbomb';
    case  7: return 'some_bombs';
    case  8: return 'hbomb_rocket';
    case  9: return 'vbomb_rocket';
    case 10: return 'plate';
    case 11: return 'bbomb_hbomb';
    case 12: return 'bbomb_plate';
    case 13: return 'bbomb_rocket';
    case 14: return 'bbomb_vbomb';
    case 15: return 'hbomb_plate';
    case 16: return 'hbomb_vbomb_plate';
    case 17: return 'hbomb_vbomb_rocket';
    case 18: return 'rocket_plate';
    case 19: return 'vbomb_hbomb';
    case 20: return 'vbomb_plate';
    case 21: return 'cats_paw';
    case 22: return 'box_with_ring';
    case 23: return 'compas';
    case 24: return 'book';
    case 25: return 'keys';
    case 26: return 'icebomb';
    case 27: return 'music_box';
    case 28: return 'flower_seed';
    case 29: return 'cake';
  }
  return `Unknown M3SpawnIcon code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ChipsLayeredName(code) {
  switch(code) {
    case         0: return 'clear';
    case 103514130: return 'chain';
    case  37876280: return 'chain_mirror';
    case 168633071: return 'jelly';
    case 109310110: return 'ice';
    case  34681458: return 'box';
    case 203259574: return 'mouse_hole';
  }
  return `Unknown M3ChipsLayered code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ChipsBlockerName(code) {
  switch(code) {
    case         0: return 'clear';
    case 144139772: return 'glass';
    case 152123871: return 'stone_tiles';
    case  69201358: return 'honey';
  }
  return `Unknown M3ChipsBlocker code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ChipsBlockedName(code) {
  switch(code) {
    case         0: return 'clear';
    case  37280846: return 'letter_2x1';
    case  62260110: return 'letter_3x1';
    case 171654987: return 'letter_3x2';
    case  50342600: return 'letter_4x2';
    case  75185803: return 'letter_4x3';
    case 100000075: return 'letter_5x3';
    case  26512514: return 'letter_5x4';
    case 267755988: return 'letter_2x1v';
    case  72412603: return 'letter_3x1v';
    case 258430648: return 'letter_3x2v';
    case 201310007: return 'letter_4x2v';
    case  71160841: return 'letter_4x3v';
    case 261658726: return 'letter_5x3v';
    case 222593823: return 'letter_5x4v';
  }
  return `Unknown M3ChipsBlocked code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ChipsRiderName(code) {
  switch(code) {
    case 0: return 'clear';
  }
  return `Unknown M3ChipsRider code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ChipsConversionsName(code) {
  switch(code) {
    case 264630631: return 'pillow';
    case 164015039: return 'bookcase';
    case  97991665: return 'crystalyzer';
    case  52335828: return 'cake';
  }
  return `Unknown M3ChipsConversions code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3MatsName(code) {
  switch(code) {
    case        0: return 'clear';
    case 37925772: return 'carpet';
  }
  return `Unknown M3Mats code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3CoversName(code) {
  switch(code) {
    case         0: return 'clear';
    case  58458845: return 'web';
    case 240727102: return 'smoke';
  }
  return `Unknown M3Covers code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3WallsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 165432907: return 'generic';
    case 196666317: return 'armored';
  }
  return `Unknown M3Walls code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3BeltsName(code) {
  switch(code) {
    case        0: return 'clear';
    case 39232813: return 'generic';
    case 92461380: return 'cat_belt';
  }
  return `Unknown M3Belts code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3BarriersName(code) {
  switch(code) {
    case         0: return 'clear';
    case 150329024: return 'barrier';
    case  42563302: return 'flower_field';
  }
  return `Unknown M3Barriers code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3PortalsName(code) {
  switch(code) {
    case         0: return 'clear';
    case 210966518: return 'for_keys';
    case  83030634: return 'entrance';
    case  80246951: return 'exit';
  }
  return `Unknown M3Portals code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3SpawnersName(code) {
  switch(code) {
    case 0: return 'clear';
    case 1: return 'generic';
  }
  return `Unknown M3Spawners code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3DamageSourceTypeName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Combo';
  }
  return `Unknown M3DamageSourceType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3DamageTypeName(code) {
  switch(code) {
    case  0: return 'NONE';
    case  1: return 'MATCH';
    case  2: return 'COLLATERAL_MATCH';
    case  4: return 'BOMB_DIRECT';
    case  8: return 'COLLATERAL_BOMB';
    case 16: return 'SYSTEM';
    case 32: return 'COLLATERAL_TEAR';
    case 64: return 'DESTROY_DIRECT';
  }
  return `Unknown M3DamageType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3DamageResponseName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'HIT';
    case 2: return 'ABSORB';
  }
  return `Unknown M3DamageResponse code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3GoalTypeName(code) {
  switch(code) {
    case 0: return 'REMOVE';
    case 1: return 'FILL_MAT';
    case 2: return 'REMOVE_ALL';
    case 3: return 'REMOVE_TAG';
    case 4: return 'COLLECT';
  }
  return `Unknown M3GoalType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3GoalTypeBarrierListName(code) {
  switch(code) {
    case 0: return 'REMOVE';
    case 3: return 'REMOVE_TAG';
  }
  return `Unknown M3GoalTypeBarrierList code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3GoalAnimTypeName(code) {
  switch(code) {
    case 0: return 'QUIET';
    case 1: return 'SIMPLE';
    case 2: return 'REPLACE';
  }
  return `Unknown M3GoalAnimType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3GoalChipsName(code) {
  switch(code) {
    case 173571093: return 'green';
    case  20043541: return 'red';
    case 152790968: return 'blue';
    case 266541332: return 'pink';
    case 152369935: return 'yellow';
    case  17824785: return 'cyan';
    case  34681458: return 'box';
    case 182865318: return 'plate';
    case 165835097: return 'key';
    case  17201424: return 'flower';
    case 124248265: return 'coil';
    case 105096733: return 'cookie';
    case 109310110: return 'ice';
    case  72057805: return 'lyre_note';
    case  86370893: return 'candy';
    case  47307072: return 'candle';
    case  99200788: return 'feather';
    case 239173506: return 'cake_piece';
    case  58458845: return 'web';
    case 240727102: return 'smoke';
    case  77815192: return 'mouse';
    case  99382431: return 'ring';
    case 169073011: return 'bowknot';
    case 204595850: return 'bowknot_violet';
    case 144508370: return 'vbomb';
    case 108834744: return 'hbomb';
    case 203671966: return 'bbomb';
    case 158564410: return 'rocket';
    case   4153540: return 'rainbow';
    case 268228540: return 'cuckoo_clock';
    case  46351931: return 'cat_end';
    case 171013116: return 'compass';
    case 187083537: return 'curtain';
    case 146262794: return 'book';
    case  77312621: return 'coin';
    case 259889572: return 'birds';
    case 217835229: return 'bobbin';
    case   4705389: return 'fan_red';
    case 259027716: return 'fan_cyan';
    case 215706882: return 'music_box';
    case 243654319: return 'fireworks';
    case 228435278: return 'flower_seed';
    case  42563302: return 'flower_field';
  }
  return `Unknown M3GoalChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3GoalCollectChipsName(code) {
  switch(code) {
    case 77312621: return 'coin';
  }
  return `Unknown M3GoalCollectChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3GoalTagsName(code) {
  switch(code) {
    case 0: return 'none';
    case 1: return 'letter';
    case 2: return 'bomb';
    case 3: return 'paint';
    case 4: return 'coil';
    case 5: return 'cookie';
    case 6: return 'chain';
  }
  return `Unknown M3GoalTags code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3GoalRemoveAllTargetsName(code) {
  switch(code) {
    case         0: return 'clear';
    case  17824785: return 'cyan';
    case  34681458: return 'box';
    case 182865318: return 'plate';
    case 165835097: return 'key';
    case  17201424: return 'flower';
    case 150880180: return 'tray';
    case 107133260: return 'foam';
    case 144139772: return 'glass';
    case 152123871: return 'stone_tiles';
    case  69201358: return 'honey';
    case 109310110: return 'ice';
    case  47307072: return 'candle';
    case 171013116: return 'compass';
    case  58458845: return 'web';
    case 240727102: return 'smoke';
    case  77815192: return 'mouse';
    case 268228540: return 'cuckoo_clock';
    case 169073011: return 'bowknot';
    case 204595850: return 'bowknot_violet';
    case  46351931: return 'cat_end';
    case 187083537: return 'curtain';
    case  77312621: return 'coin';
    case 259889572: return 'birds';
    case 217835229: return 'bobbin';
    case   4705389: return 'fan_red';
    case 259027716: return 'fan_cyan';
    case 215706882: return 'music_box';
    case 239173506: return 'cake_piece';
    case         1: return 'tag_letter';
    case         2: return 'tag_bomb';
    case         3: return 'tag_paint';
    case         4: return 'tag_coil';
    case         5: return 'tag_cookie';
    case         6: return 'tag_chain';
    case         7: return 'tag_petard';
  }
  return `Unknown M3GoalRemoveAllTargets code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3CertainRandomChipsName(code) {
  switch(code) {
    case 220370293: return 'random_1';
    case  78621104: return 'random_2';
    case  64273907: return 'random_3';
    case 129355834: return 'random_4';
  }
  return `Unknown M3CertainRandomChips code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3LevelSpecificsTypeName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'SetDefaultRocketTargets';
    case  2: return 'SetSpawnerForGift';
    case  4: return 'SetSettingsPaintTray';
    case  5: return 'SetSettingsBoxWithRing';
    case  6: return 'BowknotRibbonLink';
    case  7: return 'SetSpawnChipForLayer';
    case  8: return 'SetSettingsMarker';
    case  9: return 'RandomRingInBox';
    case 10: return 'AddBurningBoosters';
    case 11: return 'SetDirCompass';
    case 12: return 'SetCatCharge';
    case 13: return 'SetSettingsCookiesJar';
    case 14: return 'SetSettingsBirds';
    case 15: return 'BobbinLink';
    case 16: return 'SetSettingsUmbrella';
    case 17: return 'SetSettingsCandyJar';
    case 18: return 'SetSettingsFireworks';
  }
  return `Unknown M3LevelSpecificsType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3LevelOfDifficultyName(code) {
  switch(code) {
    case 0: return 'Normal';
    case 1: return 'Hard';
    case 2: return 'VeryHard';
  }
  return `Unknown M3LevelOfDifficulty code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3BoosterTypeName(code) {
  switch(code) {
    case  1: return 'ExtraMoves';
    case  2: return 'Rainbow';
    case  3: return 'HBBomb';
    case  4: return 'Rocket';
    case  5: return 'RocketOnField';
    case  6: return 'Hammer';
    case  7: return 'Sledgehammer';
    case  8: return 'Glove';
    case  9: return 'BonusMoves';
    case 10: return 'HBomb';
    case 11: return 'VBomb';
    case 12: return 'BBomb';
    case 13: return 'HVBomb';
    case 14: return 'SuperRainbow';
  }
  return `Unknown M3BoosterType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3BoosterUseTypeName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Starting';
    case 2: return 'Instant';
    case 3: return 'Accumulative';
  }
  return `Unknown M3BoosterUseType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3InstantBoostersName(code) {
  switch(code) {
    case 100649854: return 'hammer';
    case 222310101: return 'glove';
    case  95925952: return 'sledgehammer';
  }
  return `Unknown M3InstantBoosters code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3LinkDirectionName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'LEFT';
    case 2: return 'RIGHT';
    case 4: return 'UP';
    case 8: return 'DOWN';
  }
  return `Unknown M3LinkDirection code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3MarkerTypeName(code) {
  switch(code) {
    case   2827952: return 'FlowerSeed';
    case  50688134: return 'PumpkinSeed';
    case 225717855: return 'Elephant';
    case  82154108: return 'DailyQuest';
  }
  return `Unknown M3MarkerType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3WinStreakTypeName(code) {
  switch(code) {
    case         0: return 'None';
    case 102032800: return 'BeeInSheepsClothing';
  }
  return `Unknown M3WinStreakType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3AssistantTypeName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'ByMissedDays';
    case 2: return 'ByLosses';
    case 3: return 'Combo';
  }
  return `Unknown M3AssistantType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCutsceneWrapModeName(code) {
  switch(code) {
    case 0: return 'ONCE';
    case 1: return 'LOOP';
    case 2: return 'SCALE';
    case 3: return 'PINGPONG';
  }
  return `Unknown CutsceneWrapMode code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCutscenePostPlaybackStateName(code) {
  switch(code) {
    case 0: return 'LEAVE_AS_IS';
    case 1: return 'ACTIVATE';
    case 2: return 'INACTIVATE';
    case 3: return 'REVERT';
  }
  return `Unknown CutscenePostPlaybackState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCutscenePostPlaybackCustomizationStateName(code) {
  switch(code) {
    case 0: return 'LEAVE_AS_IS';
    case 1: return 'EMPTY';
    case 2: return 'REVERT_TO_PREVIOUS';
  }
  return `Unknown CutscenePostPlaybackCustomizationState code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCutsceneTransformApplyModeName(code) {
  switch(code) {
    case 0: return 'ROTATION';
    case 1: return 'PATH';
  }
  return `Unknown CutsceneTransformApplyMode code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCutsceneDialogTypeName(code) {
  switch(code) {
    case   0: return 'DIALOG';
    case   1: return 'FACT';
    case   2: return 'TEXT';
    case   3: return 'LETTER';
    case   4: return 'BIG_TEXT';
    case   5: return 'LETTER_JANE';
    case   6: return 'LETTER_SLAGGER';
    case   7: return 'LETTER_WROTH';
    case   8: return 'MEDALLION';
    case   9: return 'NEW_ROOM';
    case  10: return 'PORTRAIT_MOTHER';
    case  11: return 'LETTER_JAMES';
    case  12: return 'BOOKSHOP_TEXT';
    case  13: return 'HANDKERCHIEF';
    case  14: return 'NEWSPAPER';
    case  15: return 'BOOK';
    case  16: return 'LETTER_FATHER';
    case  17: return 'LETTER_LINWOOD';
    case  18: return 'LETTER_WROTH_CLEAR';
    case  19: return 'LETTER_WROTH_OUTGOING';
    case  20: return 'WRITTEN_NOTE_OUTGOING';
    case  21: return 'WRITTEN_NOTE_INCOMING';
    case  22: return 'MAGAZINE_LADIES';
    case  23: return 'CARRIAGES';
    case  24: return 'CARD_KING_OF_SPADES';
    case  25: return 'EDWARDS_BEDROOM';
    case  26: return 'LETTER_ANONYMOUS';
    case  27: return 'LETTER_APPLEKIN';
    case  28: return 'LETTER_SMUDGE';
    case  29: return 'CASKET';
    case  30: return 'CASKET_OPENING';
    case  31: return 'CASKET_BROKEN';
    case  32: return 'DOCS_SLAGGER';
    case  33: return 'PORTRAIT_FATHER';
    case  34: return 'PORTRAIT_EDWARD_RUINED';
    case  35: return 'PORTRAIT_EDWARD_NORMAL';
    case  36: return 'NEWSPAPER_JANE';
    case  37: return 'TEXT_GVNT_INTRO';
    case  38: return 'LETTER_APPLEKIN_PORTRAIT';
    case  39: return 'CASKET_LETTERS';
    case  40: return 'LETTER_SCREEN_DAVID';
    case  41: return 'LETTER_WROTH_YOUNG_INCOMING';
    case  42: return 'LETTER_MAMMY_YOUNG_INCOMING';
    case  43: return 'PORTRAIT_REGINA_WROTH_YOUNG';
    case  44: return 'DIADEM';
    case  45: return 'PREVIEW';
    case  46: return 'BALL_BOOK';
    case  47: return 'PREVIEW_BATTLE_PASS';
    case  48: return 'LETTER_LINWOOD_OUTGOING';
    case  49: return 'LETTER_GREZINNA';
    case  50: return 'PORTRAIT_ALLENS_PARENTS_CLEAN';
    case  51: return 'PORTRAIT_ALLENS_PARENTS';
    case  52: return 'RING';
    case  53: return 'LETTER_VIATVIL';
    case  54: return 'PORTRAIT_EMMA_LINWOOD';
    case  55: return 'TEXT_ON_WHITE';
    case  56: return 'NEWSPAPER_VILLAGE_BALL';
    case  57: return 'NEWSPAPER_FASHION_CLUB';
    case  58: return 'ALLENS_FATHERS_SMOKING_PIPE';
    case  59: return 'SKIP';
    case  60: return 'BALL_BOOK_SPROUNTS';
    case  61: return 'PORTRAIT_MOTHER_FASHIONABLE';
    case  62: return 'LETTER_SCREEN_ANONYMOUS_WITHOUT_PORTRAIT';
    case  63: return 'EDWARDS_DIARY_5_APRIL';
    case  64: return 'EDWARDS_DIARY_20_APRIL';
    case  65: return 'EDWARDS_DIARY_25_APRIL';
    case  66: return 'PORTRAIT_ZLATA';
    case  67: return 'EDWARDS_DIARY_28_APRIL';
    case  68: return 'OUIJA_BOARD';
    case  69: return 'PORTRAIT_LITTLE_MARY';
    case  70: return 'FIREWORKS_SCHEME_PIECE_01';
    case  71: return 'FIREWORKS_SCHEME_PIECE_02';
    case  72: return 'FIREWORKS_SCHEME';
    case  73: return 'EDWARDS_DIARY_1_MAY';
    case  74: return 'EDWARDS_DIARY_5_MAY';
    case  75: return 'ACCOUNT_BOOK';
    case  76: return 'PORTRAIT_GOLDA_APPLETON_TELESCOPE';
    case  77: return 'NEWSPAPER_HEARTBREAKER';
    case  78: return 'PORTRAIT_JANE';
    case  79: return 'LETTER_OPENER';
    case  80: return 'FACT_FIRST';
    case  81: return 'LETTER_SLAGGER_WITHOUT_PORTRAIT';
    case  82: return 'EDWARDS_DIARY_12_MAY';
    case  83: return 'ALCHEMICAL_BOOK';
    case  84: return 'NEWSPAPER_SCULPTURES_EXHIBITION';
    case  85: return 'EDWARDS_DIARY_6_JULY';
    case  86: return 'LETTER_SCREEN_EDWARDS_FATHER';
    case  87: return 'LETTER_SCREEN_EDWARD';
    case  88: return 'NEWSPAPER_EXHIBITION';
    case  89: return 'KNIGHT_DIAGRAM';
    case  90: return 'CANDY_BOX';
    case  91: return 'LETTER_POETRY';
    case  92: return 'WEDDING_TEXT';
    case  93: return 'WEDDING_ANIMATION';
    case  94: return 'WEDDING_EFFECT';
    case  95: return 'BOOK_POEMS_QUESTIONABLE';
    case  96: return 'WEDDING_DRESS';
    case  97: return 'INTRO_LOCATION_PAN';
    case  98: return 'LETTER_WITH_PRESENT';
    case  99: return 'LETTER_FROM_BILL';
    case 100: return 'NEWSPAPER_RUNAWAY_BRIDE';
    case 101: return 'NEWSPAPER_NEW_HOBBY';
    case 102: return 'HOUSE_MAP';
    case 103: return 'NOTE_FOR_SLAGGER';
    case 104: return 'HILL_CLOTH_PIECE';
    case 105: return 'BROKEN_CHAIR_LEG';
    case 106: return 'EMPTY_FRAME';
    case 107: return 'NEWSPAPER_MASSIVE_ESCAPE';
    case 108: return 'LETTER_SCREEN_RYDALKINS';
    case 109: return 'PORTRAIT_PARENTS';
    case 110: return 'EDWARDS_DIARY_17_MAY';
    case 111: return 'EDWARDS_DIARY_24_APRIL';
    case 112: return 'SACHET_REGINA_WROTH';
    case 113: return 'NEWSPAPER_MOOD_DRAMA';
    case 114: return 'STATFALL';
    case 115: return 'TORN_GLOVE';
    case 116: return 'BROKEN_SHOE';
    case 117: return 'JANES_EMBROIDERY';
    case 118: return 'NEWSPAPER_DESPERATE_MADNESS';
    case 119: return 'STASH_EDWARD';
    case 120: return 'ALCHEMICAL_SCROLL';
    case 121: return 'NEWSPAPER_THEATER_CLOSED';
    case 122: return 'AGREEMENT';
    case 123: return 'NEWSPAPER_ROLE_CHANGE';
    case 124: return 'MORTGAGE';
    case 125: return 'EDWARDS_PICTURE';
    case 126: return 'PLAYBILL';
    case 127: return 'PLAY_PAGE';
    case 128: return 'EDWARDS_WATCH';
    case 129: return 'GIFT_FOR_HILL';
    case 130: return 'CARICATURE_REGINA_WROTH';
    case 131: return 'NEWSPAPER_DUBIOUS_VISITS';
    case 132: return 'LETTER_SCREEN_ANONYMOUS_THEATRE';
    case 133: return 'CARNATION_BROOCH';
    case 134: return 'HANDKERCHIEF_FLOWER';
    case 135: return 'NOTE_LOVE';
    case 136: return 'LETTER_SCREEN_RUINGTON';
    case 137: return 'PORTRAIT_ANNA';
    case 138: return 'POEM';
    case 139: return 'CARICATURE_PITER';
    case 140: return 'PORTRAIT_ANNA_2';
    case 141: return 'NEWSPAPER_LADY_FOR_DRAMA';
    case 142: return 'LETTER_SCREEN_REGINA_WROTH';
    case 143: return 'NOTE_FOR_EDWARD';
    case 144: return 'ACTRESS_DIARY';
    case 145: return 'CARICATURE_PITER_REGINA';
    case 146: return 'NEWSPAPER_PRODIGAL_NOBLEMAN';
    case 147: return 'HAND_MIRROR';
    case 148: return 'PIRATE_CODEX';
    case 149: return 'SNAIL';
    case 150: return 'NOTE_LOVE_BIG';
    case 151: return 'FATHERSDAY_ANIMATION';
    case 152: return 'WOODEN_BOX';
    case 153: return 'BOTTLE_OF_OIL';
    case 154: return 'NEWSPAPER_UGLINESS';
    case 155: return 'PICTURE_JOE';
    case 156: return 'POSTER_PERFOMANCE';
    case 157: return 'VAMPIRE_ANIMATION';
    case 158: return 'NEWSPAPER_PRIMITIVE_CULTURE';
    case 159: return 'PORTRAIT_ANNA_SOUVENIR';
    case 160: return 'BOTTLE_BEAUTIFUL';
    case 161: return 'NEWSPAPER_NO_CIRCUS';
    case 162: return 'MAGNIFYING_GLASS';
    case 163: return 'LETTER_ZLATA';
    case 164: return 'MAKEUP_JAR';
    case 165: return 'BROKEN_MASK';
    case 166: return 'BAG_PROVISIONS';
    case 167: return 'TICKET';
    case 168: return 'SKULL_BOX';
    case 169: return 'TICKET_17_05';
    case 170: return 'NEWSPAPER_FIASCO';
    case 171: return 'BOX_WITH_SET';
    case 172: return 'NECKLACE_STAND';
    case 173: return 'BRACELET_BOX';
    case 174: return 'RING_BOX';
    case 175: return 'KEY';
    case 176: return 'ENGAGEMENT_RING';
    case 177: return 'PORTAIT_FLOOR_SOUVENIR';
    case 178: return 'MYSTERIOUS_MEDALLION';
  }
  return `Unknown CutsceneDialogType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getCutscenePointName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'BATTLE_PASS';
    case 2: return 'BATTLE_PASS_BACK';
    case 3: return 'GVNT_ASSEMBLY';
    case 4: return 'GVNT_FESTIVAL_SQUARE';
    case 5: return 'GVNT_STAIRS';
  }
  return `Unknown CutscenePoint code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getClubTypeName(code) {
  switch(code) {
    case 0: return 'Open';
    case 1: return 'Private';
  }
  return `Unknown ClubType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getClubFlagName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'Flag01';
    case  2: return 'Flag02';
    case  3: return 'Flag03';
    case  4: return 'Flag04';
    case  5: return 'Flag05';
    case  6: return 'Flag06';
    case  7: return 'Flag07';
    case  8: return 'Flag08';
    case  9: return 'Flag09';
    case 10: return 'Flag10';
    case 11: return 'Flag11';
    case 12: return 'Flag12';
    case 13: return 'Flag13';
    case 14: return 'Flag14';
    case 15: return 'Flag15';
    case 16: return 'Flag16';
    case 17: return 'Flag17';
    case 18: return 'Flag18';
    case 19: return 'Flag19';
    case 20: return 'Flag20';
    case 21: return 'Flag21';
    case 22: return 'Flag22';
    case 23: return 'Flag23';
    case 24: return 'Flag24';
    case 25: return 'Flag25';
    case 26: return 'Flag26';
    case 27: return 'Flag27';
    case 28: return 'Flag28';
    case 29: return 'Flag29';
    case 30: return 'Flag30';
    case 31: return 'Flag31';
    case 32: return 'Flag32';
    case 33: return 'Flag33';
    case 34: return 'Flag34';
    case 35: return 'Flag35';
    case 36: return 'Flag36';
    case 37: return 'Flag37';
    case 38: return 'Flag38';
    case 39: return 'Flag39';
    case 40: return 'Flag40';
    case 41: return 'Flag41';
    case 42: return 'Flag42';
    case 43: return 'Flag43';
    case 44: return 'Flag44';
    case 45: return 'Flag45';
    case 46: return 'Flag46';
    case 47: return 'Flag47';
    case 48: return 'Flag48';
    case 49: return 'Flag49';
    case 50: return 'Flag50';
    case 51: return 'Flag51';
  }
  return `Unknown ClubFlag code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getTweenFuncTypeName(code) {
  switch(code) {
    case  0: return 'Linear';
    case  2: return 'ExpoEaseIn';
    case  3: return 'ExpoEaseOut';
    case  4: return 'QuadraticEaseIn';
    case  5: return 'QuadraticEaseOut';
    case  6: return 'QuadraticEaseInOut';
    case  7: return 'ElasticEaseInOut';
    case  8: return 'CircEaseIn';
    case  9: return 'BackEaseIn';
    case 10: return 'BackEaseOut';
    case 11: return 'QuarticEaseOut';
    case 12: return 'QuarticEaseIn';
    case 13: return 'SinusoidalEaseIn';
    case 14: return 'SinusoidalEaseOut';
    case 15: return 'CubicEaseIn';
    case 16: return 'CubicEaseOut';
  }
  return `Unknown TweenFuncType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3ActionTypeName(code) {
  switch(code) {
    case  0: return 'EMPTY';
    case  1: return 'SWAP_BOMB2REG';
    case  2: return 'SWAP_REG2BOMB';
    case  4: return 'SWAP_COMBO';
    case  8: return 'ACTIVATE';
    case 16: return 'DAMAGE';
    case 32: return 'SWAP_BOOSTER';
  }
  return `Unknown M3ActionType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getM3EventTypeName(code) {
  switch(code) {
    case  0: return 'None';
    case  1: return 'HorizontalDamage';
    case  2: return 'VerticalDamage';
    case  3: return 'Damage';
    case  4: return 'BlastWave';
    case  5: return 'HighlightCell';
    case  6: return 'CreateWave';
    case  7: return 'StopWave';
    case  8: return 'ShowVFX';
    case  9: return 'ShowProjectile';
    case 10: return 'ActivateChip';
    case 11: return 'RainbowDestroy';
    case 12: return 'DestroyChannel';
    case 13: return 'Move';
  }
  return `Unknown M3EventType code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getOperatorName(code) {
  switch(code) {
    case 0: return 'EQUALITY';
    case 1: return 'MAX';
    case 2: return 'ADD';
  }
  return `Unknown Operator code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRiverRumbleStatusName(code) {
  switch(code) {
    case 0: return 'Active';
    case 1: return 'WinFinished';
    case 2: return 'LoseFinished';
    case 3: return 'TimeIsOverFinished';
  }
  return `Unknown EnumRiverRumbleStatus code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumRiverRumbleSequenceName(code) {
  switch(code) {
    case 0: return 'MainSequence';
    case 1: return 'HighSociety';
  }
  return `Unknown EnumRiverRumbleSequence code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumBitStatsEventName(code) {
  switch(code) {
    case  0: return 'NONE';
    case  1: return 'LOGIN';
    case  2: return 'LEVEL_UP';
    case  3: return 'FEATURE_USE';
    case  4: return 'COST_STOCK';
    case  5: return 'ADD_STOCK';
    case  6: return 'NEW_PLAYER';
    case  7: return 'OUT_ENERGY';
    case  8: return 'PAY_COST';
    case  9: return 'QUEST_DONE';
    case 10: return 'QUEST_START';
    case 11: return 'QUEST_TASK_COMPLETE';
    case 12: return 'VIRAL_RECIVE';
    case 14: return 'VIRAL_SEND';
    case 15: return 'REAL_PAY';
    case 16: return 'SHOP_OPEN';
  }
  return `Unknown EnumBitStatsEvent code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getRpcErrorRestoreGameName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'NOT_FOUND';
  }
  return `Unknown RpcErrorRestoreGame code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getRpcErrorSaveGameName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'CONFLICT';
  }
  return `Unknown RpcErrorSaveGame code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getRpcErrorAddIdentityName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'EXISTS';
  }
  return `Unknown RpcErrorAddIdentity code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getRpcErrorIAPName(code) {
  switch(code) {
    case  0: return 'NONE';
    case  1: return 'GP_NOT_IN_REGISTRY';
    case  2: return 'GP_BAD_SIGNATURE';
    case  3: return 'GP_NOT_VERIFIED';
    case  4: return 'IOS_NOT_VERIFIED';
    case  5: return 'IOS_TRX_NO_MATCH';
    case  6: return 'IOS_SKU_NO_MATCH';
    case  7: return 'AMAZON_NOT_VERIFIED';
    case  8: return 'AMAZON_RECEIPT_NO_MATCH';
    case  9: return 'AMAZON_SKU_NO_MATCH';
    case 10: return 'GP_TX_EXIST';
    case 11: return 'SAMSUNG_NOT_VERIFIED';
    case 12: return 'SAMSUNG_RECEIPT_NO_MATCH';
    case 13: return 'SAMSUNG_SKU_NO_MATCH';
  }
  return `Unknown RpcErrorIAP code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getError_CLUB_MAKEName(code) {
  switch(code) {
    case 0: return 'NONE';
  }
  return `Unknown Error_CLUB_MAKE code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getError_CLUB_JOINName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'ALREADY_MEMBER';
    case 2: return 'NO_FREE_SLOT';
    case 3: return 'NO_CLUB';
    case 4: return 'PRIVATE_ONLY';
  }
  return `Unknown Error_CLUB_JOIN code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getError_CLUB_JOIN_PRIVName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'ALREADY_MEMBER';
    case 2: return 'NO_FREE_SLOT';
    case 3: return 'NO_CLUB';
    case 4: return 'NOT_PRIVATE';
    case 5: return 'TOO_MANY_REQS';
  }
  return `Unknown Error_CLUB_JOIN_PRIV code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getError_CLUB_SAYName(code) {
  switch(code) {
    case 0: return 'NONE';
    case 1: return 'BLOCKED';
  }
  return `Unknown Error_CLUB_SAY code ${code}.`;
}

/**
 * @param {number} code 
 * @returns {string}
 */
export function getEnumTmntPromotionName(code) {
  switch(code) {
    case 0: return 'None';
    case 1: return 'Up';
    case 2: return 'Down';
  }
  return `Unknown EnumTmntPromotion code ${code}.`;
}
